import Vue from 'vue';
import Router from 'vue-router';
import { ROLES_ADMIN, ROLES_TENANT } from '@/utils/auth';

const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(Router);

/* Layout */
import Layout from '@/layout';

export const big = [
  {
    path: '/big/tenantManage',
    component: Layout,
    name: 'big-tenantManage',
    meta: {
      title: '租户管理',
      icon: 'tenant_manage',
      roles: [ROLES_ADMIN]
    },
    children: [
      {
        path: 'tenant-management',
        component: () => import('@/views/backstage/config-detail'),
        name: 'tenant-management',
        meta: {
          title: '租户配置',
          roles: [ROLES_ADMIN]
        }
      },
      {
        path: 'global-BI-config',
        component: () => import('@/views/backstage/global-BI-config'),
        name: 'global-BI-config',
        meta: {
          title: '默认报表配置',
          roles: [ROLES_ADMIN]
        }
      },
      {
        path: 'tenant-module-management',
        component: () => import('@/views/backstage/tenant-management/module'),
        name: 'tenant-module-management',
        hidden: true,
        meta: {
          title: '配置功能',
          roles: [ROLES_ADMIN],
          activeMenu: '/big/tenantManage/tenant-management'
        }
      },
      {
        path: 'configuring-message-templates',
        component: () =>
          import('@/views/backstage/configuring-message-templates'),
        name: 'configuring-message-templates',
        hidden: true,
        meta: {
          title: '配置公众号消息模板',
          roles: [ROLES_ADMIN],
          activeMenu: '/big/tenantManage/tenant-management'
        }
      },
      {
        path: 'tenant-set-domain',
        component: () =>
          import('@/views/backstage/tenant-management/set-domain'),
        name: 'tenant-set-domain',
        hidden: true,
        meta: {
          title: '设置活动推广域名',
          roles: [ROLES_ADMIN],
          activeMenu: '/big/tenantManage/tenant-management'
        }
      },
      {
        path: 'tenant-set-custom',
        component: () =>
          import('@/views/backstage/tenant-management/set-custom'),
        name: 'tenant-set-custom',
        hidden: true,
        meta: {
          title: '自定义功能配置',
          roles: [ROLES_ADMIN],
          activeMenu: '/big/tenantManage/tenant-management'
        }
      },
      {
        path: 'tenant-template-public',
        component: () => import('@/views/backstage/tenant-management/public'),
        name: 'tenant-template-public',
        hidden: true,
        meta: {
          title: '公众号配置',
          roles: [ROLES_ADMIN],
          activeMenu: '/big/tenantManage/tenant-management'
        }
      },
      {
        path: 'config-query',
        component: () => import('@/views/backstage/config-query'),
        name: 'config-query',
        hidden: true,
        meta: {
          title: '小程序功能配置',
          roles: [ROLES_ADMIN],
          activeMenu: '/big/tenantManage/tenant-management'
        }
      }
    ]
  },
  {
    path: '/big/corporationManage',
    component: Layout,
    name: 'big-corporationManage',
    meta: {
      title: '药企管理',
      icon: 'corporation-manage',
      roles: [ROLES_ADMIN]
    },
    children: [
      {
        path: 'tenant-corporationManage',
        component: () =>
          import('@/views/backstage/corporation-manage/corporation'),
        name: 'tenant-corporationManage',
        meta: {
          title: '合作药企管理',
          roles: [ROLES_ADMIN],
          activeMenu: '/big/corporationManage/tenant-corporationManage'
        }
      },
      {
        path: 'tenant-contract-management',
        component: () =>
          import('@/views/backstage/corporation-manage/contract'),
        name: 'tenant-contract-management',
        meta: {
          title: '合同管理',
          roles: [ROLES_ADMIN],
          activeMenu: '/big/corporationManage/tenant-contract-management'
        }
      },
      {
        path: 'contract-management',
        component: {
          render: (e) => e('router-view')
        },
        name: 'contract-management',
        meta: {
          title: '合约管理',
          roles: [ROLES_ADMIN]
          // activeMenu: '/big/corporationManage/contract-management/contract-template'
          // activeMenu: 'agreement_manage'
        },
        children: [
          // 合约模板
          {
            path: 'contract-template',
            component: () =>
              import('@/views/backstage/contract-management/contract-template'),
            name: 'contract-template',
            meta: {
              title: '合约模板',
              roles: [ROLES_ADMIN]
              // menuId: 'agreement_template'
            }
          },
          // 创建/编辑模板
          {
            path: 'contract-template-edit',
            component: () =>
              import(
                '@/views/backstage/contract-management/contract-template/edit-page'
              ),
            name: 'contract-template-edit',
            hidden: true,
            meta: {
              title: '创建模板',
              roles: [ROLES_ADMIN],
              // menuId: 'agreement_template',
              activeMenu:
                '/big/corporationManage/contract-management/contract-template'
            }
          },
          // 查看模板
          {
            path: 'contract-template-view',
            component: () =>
              import(
                '@/views/backstage/contract-management/contract-template/view-page'
              ),
            name: 'contract-template-view',
            hidden: true,
            meta: {
              title: '查看模板',
              roles: [ROLES_ADMIN],
              // menuId: 'agreement_template',
              activeMenu:
                '/big/corporationManage/contract-management/contract-template'
            }
          },
          // 合约主体
          {
            path: 'contract-body',
            component: () =>
              import('@/views/backstage/contract-management/contract-body'),
            name: 'contract-body',
            meta: {
              title: '合约主体',
              roles: [ROLES_ADMIN]
              // menuId: 'agreement_body'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/big/report-manage',
    component: Layout,
    name: 'big-reportManage',
    meta: {
      title: '运营报表',
      icon: 'report-manage',
      roles: [ROLES_ADMIN]
    },
    children: [
      {
        path: 'commercialization-statistics',
        component: () =>
          import('@/views/backstage/report-manage/operation-theme/index'),
        name: 'commercialization-statistics',
        meta: {
          title: '租户商业化统计',
          roles: [ROLES_ADMIN]
          // menuId: 'commercialization-statistics'
        }
      },
      {
        path: 'use-statistics',
        component: () =>
          import('@/views/backstage/report-manage/operation-theme/index'),
        name: 'use-statistics',
        meta: {
          title: '租户使用统计',
          roles: [ROLES_ADMIN]
          // menuId: 'use-statistics'
        }
      },
      {
        path: 'tenant-reportManage',
        component: () => import('@/views/backstage/report-manage/reportConfig'),
        name: 'tenant-reportManage',
        meta: {
          title: '运营报表配置',
          roles: [ROLES_ADMIN]
        }
      }
    ]
  },
  {
    path: '/big/personManage',
    component: Layout,
    name: 'big-personManage',
    meta: {
      title: '人员管理',
      icon: 'person_manage',
      roles: [ROLES_ADMIN]
    },
    children: [
      {
        path: 'user-conversion',
        component: () => import('@/views/backstage/user-conversion'),
        name: 'user-conversion',
        meta: {
          title: '推广拉新微信用户',
          roles: [ROLES_ADMIN]
        }
      },
      {
        path: 'customer-management',
        component: () => import('@/views/backstage/customer-management'),
        name: 'customer-management',
        meta: {
          title: '企业微信客户管理',
          roles: [ROLES_ADMIN]
        }
      }
    ]
  },
  // {
  //   path: '/big/functionManage',
  //   component: Layout,
  //   name: 'big-functionManage',
  //   meta: {
  //     title: '功能管理',
  //     icon: 'function_manage',
  //     roles: [ROLES_ADMIN]
  //   },
  //   children: [
  //     {
  //       path: 'session-save',
  //       component: () => import('@/views/backstage/session-save'),
  //       name: 'session-save',
  //       meta: {
  //         title: '会话留存',
  //         roles: [ROLES_ADMIN]
  //       }
  //     },
  //     {
  //       path: 'employ-detail',
  //       component: () => import('@/views/backstage/session-save/employ-detail'),
  //       name: 'employ-detail',
  //       hidden: true,
  //       meta: {
  //         title: '会话留存',
  //         roles: [ROLES_ADMIN],
  //         activeMenu: '/big/functionManage/session-save'
  //       }
  //     },
  //     {
  //       path: 'session-save-detail',
  //       component: () =>
  //         import('@/views/backstage/session-save/session-save-detail'),
  //       name: 'session-save-detail',
  //       hidden: true,
  //       meta: {
  //         title: '会话留存',
  //         roles: [ROLES_ADMIN],
  //         activeMenu: '/big/functionManage/session-save'
  //       }
  //     },
  //     {
  //       path: 'promoted',
  //       component: () => import('@/views/backstage/promoted-manage'),
  //       name: 'promoted',
  //       meta: {
  //         title: '活动推广任务管理',
  //         roles: [ROLES_ADMIN]
  //       }
  //     },
  //     {
  //       path: 'promoted-detail',
  //       component: () => import('@/views/backstage/promoted-manage/detail'),
  //       name: 'promoted-detail',
  //       hidden: true,
  //       meta: {
  //         title: '活动推广任务详情',
  //         roles: [ROLES_ADMIN],
  //         activeMenu: '/big/functionManage/promoted'
  //       }
  //     },
  //     {
  //       path: 'content-management',
  //       component: () => import('@/views/backstage/content-management'),
  //       name: 'content-management',
  //       meta: {
  //         title: 'SaaS任务管理',
  //         roles: [ROLES_ADMIN]
  //       }
  //     },
  //     {
  //       path: 'content-management-detail',
  //       component: () => import('@/views/backstage/content-management-detail'),
  //       name: 'content-management-detail',
  //       hidden: true,
  //       meta: {
  //         title: 'SaaS任务详情',
  //         roles: [ROLES_ADMIN],
  //         activeMenu: '/big/functionManage/content-management'
  //       }
  //     },
  //     {
  //       path: 'general-public',
  //       component: () => import('@/views/backstage/general-public'),
  //       name: 'general-public',
  //       meta: {
  //         title: '公众号任务管理',
  //         roles: [ROLES_ADMIN]
  //       }
  //     },
  //     {
  //       path: 'general-public-detail',
  //       component: () => import('@/views/backstage/general-public-detail'),
  //       name: 'general-public-detail',
  //       hidden: true,
  //       meta: {
  //         title: '公众号任务详情',
  //         roles: [ROLES_ADMIN],
  //         activeMenu: '/big/functionManage/general-public'
  //       }
  //     },

  //     {
  //       path: 'offline-sign-detail',
  //       component: () => import('@/views/backstage/offline-sign-detail'),
  //       name: 'offline-sign-detail',
  //       hidden: true,
  //       meta: {
  //         title: '签到详情',
  //         roles: [ROLES_ADMIN],
  //         activeMenu: '/big/functionManage/offline-sign'
  //       }
  //     }
  //   ]
  // },
  {
    path: '/big/dataManage',
    component: Layout,
    name: 'big-dataManage',
    meta: {
      title: '数据管理',
      icon: 'data_manage',
      roles: [ROLES_ADMIN]
    },
    children: [
      {
        path: 'export-list-gross',
        component: () => import('@/views/backstage/export-list-gross'),
        name: 'export-list-gross',
        meta: {
          title: '大后台导出列表',
          roles: [ROLES_ADMIN]
        }
      }
    ]
  }
];

export const small = [
  // 测试/内部使用
  {
    path: '/t/time-set',
    component: Layout,
    name: 'smallTimeSet1',
    hidden: true,
    meta: {
      title: '时间窗配置',
      roles: [ROLES_TENANT],
      menuId: 'message-management'
    },
    children: [
      {
        path: 'time-window-set',
        component: () =>
          import('@/views/small-backstage/time-set/time-window-set'),
        name: 'time-window-set1',
        hidden: true,
        meta: {
          title: '时间窗配置',
          roles: [ROLES_TENANT],
          menuId: 'message-management'
        }
      },
      {
        path: 'time-window-config',
        component: () =>
          import('@/views/small-backstage/time-set/time-window-config'),
        name: 'time-window-config1',
        hidden: true,
        meta: {
          title: '财年账期',
          roles: [ROLES_TENANT],
          menuId: 'message-management'
        }
      }
    ]
  },
  {
    path: '/small/Y-Data',
    component: Layout,
    name: 'small-Y-Data',
    meta: {
      title: 'Y-Data',
      icon: 'Y-Data',
      roles: [ROLES_TENANT],
      menuId: 'small-Y-Data'
    },
    children: [
      {
        path: 'sales-theme',
        component: { render: (e) => e('router-view') },
        name: 'sales-theme',
        meta: {
          title: '销量主题',
          roles: [ROLES_TENANT],
          menuId: 'sales-theme'
        },
        children: [
          {
            path: 'area-sales',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'area-sales',
            meta: {
              title: '进销存统计分析',
              roles: [ROLES_TENANT],
              menuId: 'area-sales'
            }
          },
          {
            path: 'city-sales',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'city-sales',
            meta: {
              title: '区域销售分析',
              roles: [ROLES_TENANT],
              menuId: 'city-sales'
            }
          },
          {
            path: 'end-sales',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'end-sales',
            meta: {
              title: '终端销售分析',
              roles: [ROLES_TENANT],
              menuId: 'end-sales'
            }
          },
          {
            path: 'product-sales',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'product-sales',
            meta: {
              title: '产品销售分析',
              roles: [ROLES_TENANT],
              menuId: 'product-sales'
            }
          },
          {
            path: 'abnormal-customer',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'abnormal-customer',
            meta: {
              title: '异常客户分析',
              roles: [ROLES_TENANT],
              menuId: 'abnormal-customer'
            }
          },
          {
            path: 'zombies-customer',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'zombies-customer',
            meta: {
              title: '僵尸客户分析',
              roles: [ROLES_TENANT],
              menuId: 'zombies-customer'
            }
          },
          {
            path: 'lost-customer',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'lost-customer',
            meta: {
              title: '客户流失分析',
              roles: [ROLES_TENANT],
              menuId: 'lost-customer'
            }
          },
          {
            path: 'sales-report-overview',
            name: 'sales-report-overview',
            component: () =>
              import('@/views/small-backstage/sales-report/overview.vue'),
            meta: {
              title: '销量概览',
              roles: [ROLES_TENANT],
              menuId: 'small-sales-report-overview'
            }
          },
          {
            path: 'sales-report-ranking-analysis',
            name: 'sales-report-ranking-analysis',
            component: () =>
              import(
                '@/views/small-backstage/sales-report/ranking-analysis.vue'
              ),
            meta: {
              title: '销量排名分析',
              roles: [ROLES_TENANT],
              menuId: 'small-sales-report-ranking-analysis'
            }
          },
          {
            path: 'sales-report-monthly-sales',
            name: 'sales-report-monthly-sales',
            component: () =>
              import('@/views/small-backstage/sales-report/monthly-sales.vue'),
            meta: {
              title: '机构月销量',
              roles: [ROLES_TENANT],
              menuId: 'small-sales-report-monthly-sales'
            }
          }
        ]
      },

      {
        path: 'delivery-theme',
        component: { render: (e) => e('router-view') },
        name: 'delivery-theme',
        meta: {
          title: '发货主题',
          roles: [ROLES_TENANT],
          menuId: 'delivery-theme'
        },
        children: [
          {
            path: 'province-delivery',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'province-delivery',
            meta: {
              title: '区域发货分析',
              roles: [ROLES_TENANT],
              menuId: 'province-delivery'
            }
          },
          {
            path: 'terminal-delivery',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'terminal-delivery',
            meta: {
              title: '终端发货分析',
              roles: [ROLES_TENANT],
              menuId: 'terminal-delivery'
            }
          },
          {
            path: 'product-delivery',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'product-delivery',
            meta: {
              title: '产品发货分析',
              roles: [ROLES_TENANT],
              menuId: 'product-delivery'
            }
          }
        ]
      },
      {
        path: 'representative-theme',
        component: { render: (e) => e('router-view') },
        name: 'representative-theme',
        meta: {
          title: '员工主题',
          roles: [ROLES_TENANT],
          menuId: 'representative-theme'
        },
        children: [
          {
            path: 'representative-overview',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'representative-overview',
            meta: {
              title: '员工概览',
              roles: [ROLES_TENANT],
              menuId: 'representative-overview'
            }
          },
          {
            path: 'representative-detailed',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'representative-detailed',
            meta: {
              title: '员工明细',
              roles: [ROLES_TENANT],
              menuId: 'representative-detailed'
            }
          }
        ]
      },
      {
        path: 'customer-theme',
        component: { render: (e) => e('router-view') },
        name: 'customer-theme',
        meta: {
          title: '客户主题',
          roles: [ROLES_TENANT],
          menuId: 'customer-theme'
        },
        children: [
          {
            path: 'customer-overview',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'customer-overview',
            meta: {
              title: '客户概览',
              roles: [ROLES_TENANT],
              menuId: 'customer-overview'
            }
          },
          {
            path: 'customer-tendency',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'customer-tendency',
            meta: {
              title: '客户趋势分析',
              roles: [ROLES_TENANT],
              menuId: 'customer-tendency'
            }
          },
          {
            path: 'customer-particulars',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'customer-particulars',
            meta: {
              title: '客户明细',
              roles: [ROLES_TENANT],
              menuId: 'customer-particulars'
            }
          }
        ]
      },
      {
        path: 'visit-theme',
        component: { render: (e) => e('router-view') },
        name: 'visit-theme',
        meta: {
          title: '拜访主题',
          roles: [ROLES_TENANT],
          menuId: 'visit-theme'
        },
        children: [
          {
            path: 'visit-overview',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'visit-overview',
            meta: {
              title: '拜访概览',
              roles: [ROLES_TENANT],
              menuId: 'visit-overview'
            }
          },
          {
            path: 'visit-trend-analysis',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'visit-trend-analysis',
            meta: {
              title: '拜访趋势分析',
              roles: [ROLES_TENANT],
              menuId: 'visit-trend-analysis'
            }
          },
          {
            path: 'visit-detail',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'visit-detail',
            meta: {
              title: '拜访明细',
              roles: [ROLES_TENANT],
              menuId: 'visit-detail'
            }
          }
        ]
      },
      {
        path: 'eda-theme',
        component: { render: (e) => e('router-view') },
        name: 'eda-theme',
        meta: {
          title: 'EDA主题',
          roles: [ROLES_TENANT],
          menuId: 'eda-theme'
        },
        children: [
          {
            path: 'eda-overview',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'eda-overview',
            meta: {
              title: 'EDA概览',
              roles: [ROLES_TENANT],
              menuId: 'eda-overview'
            }
          },
          {
            path: 'eda-tendency',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'eda-tendency',
            meta: {
              title: 'EDA趋势分析',
              roles: [ROLES_TENANT],
              menuId: 'eda-tendency'
            }
          },
          {
            path: 'eda-detailed',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'eda-detailed',
            meta: {
              title: 'EDA明细',
              roles: [ROLES_TENANT],
              menuId: 'eda-detailed'
            }
          }
        ]
      },
      {
        path: 'meeting-theme',
        component: { render: (e) => e('router-view') },
        name: 'meeting-theme',
        meta: {
          title: '会议主题',
          roles: [ROLES_TENANT],
          menuId: 'meeting-theme'
        },
        children: [
          {
            path: 'meeting-overview',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'meeting-overview',
            meta: {
              title: '会议概览',
              roles: [ROLES_TENANT],
              menuId: 'meeting-overview'
            }
          },
          {
            path: 'meeting-tendency',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'meeting-tendency',
            meta: {
              title: '会议趋势分析',
              roles: [ROLES_TENANT],
              menuId: 'meeting-tendency'
            }
          },
          {
            path: 'meeting-particulars',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'meeting-particulars',
            meta: {
              title: '会议明细',
              roles: [ROLES_TENANT],
              menuId: 'meeting-particulars'
            }
          }
        ]
      },
      {
        path: 'marketing-promotion-yb',
        component: { render: (e) => e('router-view') },
        name: 'marketing-promotion-yb',
        meta: {
          title: '医百营销活动推广主题',
          roles: [ROLES_TENANT],
          menuId: 'marketing-promotion-yb'
        },
        children: [
          {
            path: 'marketing-promotion-summary',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'marketing-promotion-summary',
            meta: {
              title: '推广概览',
              roles: [ROLES_TENANT],
              menuId: 'marketing-promotion-summary'
            }
          },
          {
            path: 'marketing-promotion-trend',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'marketing-promotion-trend',
            meta: {
              title: '推广趋势',
              roles: [ROLES_TENANT],
              menuId: 'marketing-promotion-trend'
            }
          },
          {
            path: 'marketing-promotion-detailed',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'marketing-promotion-detailed',
            meta: {
              title: '推广明细',
              roles: [ROLES_TENANT],
              menuId: 'marketing-promotion-detailed'
            }
          }
        ]
      },
      {
        path: 'train-theme',
        component: { render: (e) => e('router-view') },
        name: 'train-theme',
        meta: {
          title: '培训主题',
          roles: [ROLES_TENANT],
          menuId: 'train-theme'
        },
        children: [
          {
            path: 'train-overview',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'train-overview',
            meta: {
              title: '培训概览',
              roles: [ROLES_TENANT],
              menuId: 'train-overview'
            }
          },
          {
            path: 'train-tendency',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'train-tendency',
            meta: {
              title: '培训分析',
              roles: [ROLES_TENANT],
              menuId: 'train-tendency'
            }
          },
          {
            path: 'train-detailed',
            component: () =>
              import('@/views/small-backstage/sales-theme/index'),
            name: 'train-detailed',
            meta: {
              title: '培训明细',
              roles: [ROLES_TENANT],
              menuId: 'train-detailed'
            }
          }
        ]
      },
      {
        path: 'bi-analysis',
        component: { render: (e) => e('router-view') },
        name: 'bi-analysis',
        meta: {
          title: 'BI分析',
          roles: [ROLES_TENANT],
          menuId: 'bi-analysis'
        },
        children: [
          {
            path: 'bi-analysis-details',
            component: () =>
              import('@/views/small-backstage/bi-analysis-details/index'),
            name: 'bi-analysis-details',
            meta: {
              title: '指标完成final表明细查询',
              roles: [ROLES_TENANT],
              menuId: 'bi-analysis-details'
            }
          },
          {
            path: 'bi-analysis-visit-details',
            component: () =>
              import('@/views/small-backstage/bi-analysis-visit-details/index'),
            name: 'bi-analysis-visit-details',
            meta: {
              title: '拜访final表明细查询',
              roles: [ROLES_TENANT],
              menuId: 'bi-analysis-visit-details'
            }
          },
          {
            path: 'bi-analysis-meeting-details',
            component: () =>
              import(
                '@/views/small-backstage/bi-analysis-meeting-details/index'
              ),
            name: 'bi-analysis-meeting-details',
            meta: {
              title: '参会人费用final表明细查询',
              roles: [ROLES_TENANT],
              menuId: 'bi-analysis-meeting-details'
            }
          },
          {
            path: 'bi-analysis-market-share-details',
            component: () =>
              import(
                '@/views/small-backstage/bi-analysis-market-share-details/index'
              ),
            name: 'bi-analysis-market-share-details',
            meta: {
              title: '份额final表明细查询',
              roles: [ROLES_TENANT],
              menuId: 'bi-analysis-market-share-details'
            }
          },
          {
            path: 'bi-analysis-league-table',
            component: () =>
              import('@/views/small-backstage/bi-analysis-league-table/index'),
            name: 'bi-analysis-league-table',
            meta: {
              title: '排名表',
              roles: [ROLES_TENANT],
              menuId: 'bi-analysis-league-table'
            }
          },
          {
            path: 'bi-analsis-all-charts',
            component: () =>
              import('@/views/small-backstage/bi-analsis-all-charts/index'),
            name: 'bi-analsis-all-charts',
            meta: {
              title: '总览表',
              roles: [ROLES_TENANT],
              menuId: 'bi-analysis-overview'
            }
          }
        ]
      },
      {
        name: 'admission-record',
        path: 'admission-record',
        component: { render: (e) => e('router-view') },
        meta: {
          title: '准入报表',
          roles: [ROLES_TENANT],
          menuId: 'admission-record'
        },
        children: [
          {
            name: 'county-level-achievement-analysis',
            path: 'county-level-achievement-analysis',
            meta: {
              title: '区县达成分析',
              roles: [ROLES_TENANT],
              menuId: 'county-level-achievement-analysis'
            },
            component: () =>
              import(
                '@/views/small-backstage/admission-record/county-level-achievement/index'
              )
          }
        ]
      },
      {
        name: 'organization-record',
        path: 'organization-record',
        component: () =>
          import('@/views/small-backstage/organization-record/index'),
        meta: {
          title: '机构统计报表',
          roles: [ROLES_TENANT],
          menuId: 'org-statistic-report'
        }
      },
      {
        name: 'customer-record',
        path: 'customer-record',
        component: () =>
          import('@/views/small-backstage/customer-record/index'),
        meta: {
          title: '客户统计报表',
          roles: [ROLES_TENANT],
          menuId: 'customer-statistic-report'
        }
      }
    ]
  },
  {
    path: '/small/Y-Marketing',
    component: Layout,
    name: 'small-Y-Marketing',
    meta: {
      title: 'Y-Marketing',
      icon: 'Y-Marketing',
      roles: [ROLES_TENANT],
      menuId: 'small-Y-Marketing'
    },
    children: [
      {
        path: 'marketing-task-manage',
        component: { render: (e) => e('router-view') },
        name: 'marketingTaskManage',
        meta: {
          title: '营销任务管理',
          roles: [ROLES_TENANT],
          menuId: 'marketingTaskManage'
        },
        children: [
          {
            path: 'tenant-promoted',
            component: () => import('@/views/small-backstage/promoted'),
            name: 'tenant-promoted',
            meta: {
              title: '第三方活动推广',
              roles: [ROLES_TENANT],
              menuId: 'tenant-promoted'
            }
          },
          {
            path: 'tenant-promoted-detail',
            component: () => import('@/views/small-backstage/promoted/detail'),
            name: 'tenant-promoted-detail',
            hidden: true,
            meta: {
              title: '第三方活动推广详情',
              roles: [ROLES_TENANT],
              menuId: 'tenant-promoted',
              activeMenu:
                '/small/Y-Marketing/marketing-task-manage/tenant-promoted'
            }
          },
          {
            path: 'tenant-content-management',
            component: () =>
              import('@/views/small-backstage/tenant-content-management'),
            name: 'tenant-content-management',
            meta: {
              title: '医百营销活动推广',
              roles: [ROLES_TENANT],
              menuId: 'tenant-content-management'
            }
          },
          {
            path: 'tenant-content-management-detail',
            component: () => import('@/views/small-backstage/promoted/detail'),
            name: 'tenant-content-management-detail',
            hidden: true,
            meta: {
              title: '医百营销活动推广详情',
              roles: [ROLES_TENANT],
              menuId: 'tenant-content-management',
              activeMenu:
                '/small/Y-Marketing/marketing-task-manage/tenant-content-management'
            }
          },
          {
            path: 'tenant-general-public',
            component: () =>
              import('@/views/small-backstage/tenant-general-public'),
            name: 'tenant-general-public',
            meta: {
              title: '公众号活动推广',
              roles: [ROLES_TENANT],
              menuId: 'tenant-general-public'
            }
          },
          {
            path: 'tenant-general-public-detail',
            component: () => import('@/views/small-backstage/promoted/detail'),
            name: 'tenant-general-public-detail',
            hidden: true,
            meta: {
              title: '公众号活动推广详情',
              roles: [ROLES_TENANT],
              menuId: 'tenant-general-public',
              activeMenu:
                '/small/Y-Marketing/marketing-task-manage/tenant-general-public'
            }
          },
          {
            path: 'tenant-config-posters',
            component: () =>
              import('@/views/small-backstage/tenant-config-posters'),
            name: 'tenant-config-posters',
            meta: {
              title: '活动海报配置',
              roles: [ROLES_TENANT],
              menuId: 'tenant-config-posters'
            }
          },
          {
            path: 'tenant-user-conversion',
            component: () =>
              import('@/views/small-backstage/tenant-user-conversion'),
            name: 'tenant-user-conversion',
            meta: {
              title: '推广拉新微信用户',
              roles: [ROLES_TENANT],
              menuId: 'tenant-user-conversion'
            }
          }
        ]
      },
      {
        path: 'marketing-campaign-management',
        component: { render: (e) => e('router-view') },
        name: 'marketing-campaign-management',
        meta: {
          title: '营销活动管理',
          roles: [ROLES_TENANT],
          menuId: 'marketing-campaign-management'
        },
        children: [
          {
            path: 'marketing-campaign-portal',
            component: () =>
              import('@/views/small-backstage/marketing-campaign'),
            name: 'marketing-campaign-portal',
            meta: {
              title: '营销活动管理',
              roles: [ROLES_TENANT],
              menuId: 'marketing-campaign-portal'
            }
          },
          {
            path: 'marketing-campaign-details',
            component: () => import('@/views/small-backstage/promoted/detail'),
            name: 'marketing-campaign-details',
            hidden: true,
            meta: {
              title: '营销活动详情',
              roles: [ROLES_TENANT],
              menuId: 'marketing-campaign-portal',
              activeMenu:
                '/small/Y-Marketing/marketing-campaign-management/marketing-campaign-portal'
            }
          }
        ]
      },
      {
        path: 'ActivityManage',
        component: { render: (e) => e('router-view') },
        name: 'ActivityManage',
        meta: {
          title: '活动管理',
          roles: [ROLES_TENANT],
          menuId: 'ActivityManage'
        },
        children: [
          {
            path: 'cases-collect',
            component: () => import('@/views/small-backstage/cases-collect'),
            name: 'cases-collect',
            meta: {
              title: '医学研究管理',
              roles: [ROLES_TENANT],
              menuId: 'cases-collect'
            }
          },
          {
            path: 'cases-collect-detail',
            component: () =>
              import('@/views/small-backstage/cases-collect/detail'),
            name: 'cases-collect-detail',
            hidden: true,
            meta: {
              title: '医学研究详情',
              roles: [ROLES_TENANT],
              menuId: 'cases-collect',
              activeMenu: '/small/Y-Marketing/ActivityManage/cases-collect'
            }
          },
          {
            path: 'official-account-content',
            component: () =>
              import(
                '@/views/small-backstage/activities-manage/official-account-content/index'
              ),
            name: 'official-account-content',
            meta: {
              title: '公众号内容管理',
              roles: [ROLES_TENANT],
              menuId: 'official-account-content'
            }
          },
          {
            path: 'sass-content-management',
            component: () =>
              import(
                '@/views/small-backstage/sass-manage/sass-content-management/index'
              ),
            name: 'sass-content-management',
            meta: {
              title: 'SAAS内容管理',
              roles: [ROLES_TENANT],
              menuId: 'sass-content-management'
            }
          }
        ]
      },
      {
        path: 'content-manage',
        component: { render: (e) => e('router-view') },
        name: 'contentManage',
        meta: {
          title: '内容管理',
          roles: [ROLES_TENANT],
          menuId: 'contentManage'
        },
        children: [
          {
            path: 'database',
            component: () => import('@/views/small-backstage/database'),
            name: 'database',
            meta: {
              title: 'EDA',
              roles: [ROLES_TENANT],
              menuId: 'database'
            }
          },
          {
            path: 'data-statistics',
            component: () => import('@/views/small-backstage/data-statistics'),
            name: 'data-statistics',
            meta: {
              title: 'EDA数据统计',
              roles: [ROLES_TENANT],
              menuId: 'data-statistics'
            }
          },
          {
            path: 'browseLog',
            component: () =>
              import('@/views/small-backstage/data-statistics/browseLog'),
            name: 'browseLog',
            meta: {
              title: 'EDA浏览记录',
              roles: [ROLES_TENANT],
              menuId: 'browseLog'
            }
          }
        ]
      },
      {
        path: 'points-manage',
        component: { render: (e) => e('router-view') },
        name: 'pointsManage',
        meta: {
          title: '积分管理',
          roles: [ROLES_TENANT],
          menuId: 'pointsManage'
        },
        children: [
          {
            path: 'matchingPoints',
            component: () =>
              import('@/views/small-backstage/points-mange/relation-index'),
            name: 'matchingPoints',
            meta: {
              title: '内容积分配置',
              menuId: 'matchingPoints'
            }
          },
          {
            path: 'ScoreStatistics',
            component: () =>
              import('@/views/small-backstage/points-mange/score-statistics'),
            name: 'ScoreStatistics',
            hidden: true,
            meta: {
              title: '积分统计',
              menuId: 'matchingPoints',
              activeMenu: '/small/Y-Marketing/points-manage/matchingPoints'
            }
          },
          {
            path: 'haveRelation',
            component: () =>
              import(
                '@/views/small-backstage/points-mange/MatchComponents/Relatin-haveRelationList'
              ),
            name: 'haveRelation',
            hidden: true,
            meta: {
              title: '已关联积分规则内容列表',
              menuId: 'matchingPoints',
              activeMenu: '/small/Y-Marketing/points-manage/matchingPoints'
            }
          },
          {
            path: 'pointsRule',
            component: () =>
              import('@/views/small-backstage/points-mange/rule-index'),
            name: 'pointsRule',
            meta: {
              title: '积分规则管理',
              menuId: 'pointsRule'
            }
          },
          {
            path: 'addPointsRule',
            component: () =>
              import(
                '@/views/small-backstage/points-mange/RuleComponents/add-rule'
              ),
            name: 'addPointsRule',
            hidden: true,
            meta: {
              title: '添加积分规则详情',
              menuId: 'pointsRule',
              activeMenu: '/small/Y-Marketing/points-manage/pointsRule'
            }
          },
          {
            path: 'single-pointsStatistics',
            component: () =>
              import('@/views/small-backstage/points-mange/points-statistics'),
            name: 'single-pointsStatistics',
            hidden: true,
            meta: {
              title: '积分统计',
              menuId: 'pointsRule',
              activeMenu: '/small/Y-Marketing/points-manage/pointsRule'
            }
          },
          {
            path: 'page-stay4-representative-statistics',
            component: () =>
              import(
                '@/views/small-backstage/points-mange/page-stay4-representative-statistics'
              ),
            name: 'page-stay4-representative-statistics',
            hidden: true,
            meta: {
              title: '积分统计',
              menuId: 'pointsRule',
              activeMenu: '/small/Y-Marketing/points-manage/pointsRule'
            }
          },
          {
            path: 'pointsStatistics',
            component: () =>
              import('@/views/small-backstage/points-mange/points-statistics'),
            name: 'pointsStatistics',
            meta: {
              title: '积分统计',
              menuId: 'pointsStatistics'
            }
          }
        ]
      },
      {
        path: 'pointsMall',
        component: { render: (e) => e('router-view') },
        name: 'pointsMall',
        meta: {
          title: '商城管理',
          roles: [ROLES_TENANT],
          menuId: 'pointsMall'
        },
        children: [
          {
            path: 'categoryManagement',
            component: () =>
              import(
                '@/views/small-backstage/points-mall/category-management/list.vue'
              ),
            name: 'categoryManagement',
            meta: {
              title: '品类管理',
              menuId: 'categoryManagement',
              type: 'DOCTOR'
            }
          },
          {
            path: 'goodsManagement',
            component: () =>
              import(
                '@/views/small-backstage/points-mall/goods-management/list.vue'
              ),
            name: 'goodsManagement',
            meta: {
              title: '商品管理',
              menuId: 'goodsManagement',
              type: 'DOCTOR'
            }
          },
          {
            path: 'addCommodity',
            component: () =>
              import(
                '@/views/small-backstage/points-mall/goods-management/addCommodity.vue'
              ),
            hidden: true,
            name: 'addCommodity',
            meta: {
              title: '添加商品',
              menuId: 'goodsManagement',
              activeMenu: '/small/Y-Marketing/pointsMall/goodsManagement',
              type: 'DOCTOR'
            }
          },
          {
            path: 'addCommodity-edit',
            component: () =>
              import(
                '@/views/small-backstage/points-mall/goods-management/addCommodity.vue'
              ),
            hidden: true,
            name: 'addCommodity-edit',
            meta: {
              title: '编辑商品',
              menuId: 'goodsManagement',
              activeMenu: '/small/Y-Marketing/pointsMall/goodsManagement',
              type: 'DOCTOR'
            }
          },
          {
            path: 'editInventory',
            component: () =>
              import(
                '@/views/small-backstage/points-mall/goods-management/editInventory.vue'
              ),
            hidden: true,
            name: 'editInventory',
            meta: {
              title: '编辑库存',
              menuId: 'goodsManagement',
              activeMenu: '/small/Y-Marketing/pointsMall/goodsManagement',
              type: 'DOCTOR'
            }
          },
          {
            path: 'orderManagement',
            component: () =>
              import(
                '@/views/small-backstage/points-mall/order-management/list.vue'
              ),
            name: 'orderManagement',
            meta: {
              title: '订单管理',
              menuId: 'orderManagement',
              type: 'DOCTOR'
            }
          },
          {
            path: 'goods-detail',
            component: () =>
              import(
                '@/views/small-backstage/points-mall/order-management/goods-detail.vue'
              ),
            name: 'goods-detail',
            hidden: true,
            meta: {
              title: '订单详情',
              menuId: 'orderManagement',
              activeMenu: '/small/Y-Marketing/pointsMall/orderManagement',
              type: 'DOCTOR'
            }
          }
        ]
      },
      {
        path: 'doctor-manage',
        component: { render: (e) => e('router-view') },
        name: 'doctorManage',
        meta: {
          title: '医生端管理',
          roles: [ROLES_TENANT],
          menuId: 'doctorManage'
        },
        children: [
          {
            path: 'audit-management',
            component: () =>
              import(
                '@/views/small-backstage/info-authentication/audit-management'
              ),
            name: 'audit-management',
            meta: {
              title: '医生认证管理',
              menuId: 'audit-management'
            }
          },
          {
            path: 'audit-detail',
            component: () =>
              import(
                '@/views/small-backstage/info-authentication/audit-management/detail'
              ),
            name: 'audit-detail',
            hidden: true,
            meta: {
              title: '医生认证详情',
              menuId: 'audit-management',
              activeMenu: '/small/Y-Marketing/doctor-manage/audit-management'
            }
          },
          {
            path: 'config',
            component: () => import('@/views/small-backstage/home-page-config'),
            name: 'home-page-config',
            meta: {
              title: '医生首页配置',
              roles: [ROLES_TENANT],
              menuId: 'home-page-config'
            }
          },
          {
            path: 'column-manage',
            component: () =>
              import('@/views/small-backstage/home-page-config/column-manage'),
            name: 'column-manage',
            meta: {
              title: '专栏配置',
              roles: [ROLES_TENANT],
              menuId: 'column-manage'
            }
          },
          {
            path: 'column-content',
            component: () =>
              import('@/views/small-backstage/home-page-config/column-content'),
            name: 'column-content',
            hidden: true,
            meta: {
              title: '专栏内容',
              roles: [ROLES_TENANT],
              menuId: 'column-manage',
              activeMenu: '/small/Y-Marketing/doctor-manage/column-manage'
            }
          },
          {
            path: 'informed-consent',
            component: () =>
              import('@/views/small-backstage/basic-set/informed-consent'),
            name: 'informed-consent',
            meta: {
              title: '知情同意书配置',
              roles: [ROLES_TENANT],
              menuId: 'informed-consent'
            }
          },
          {
            path: 'browse-records',
            component: () =>
              import('@/views/small-backstage/doctor-records/browse-records'),
            name: 'browse-records',
            meta: {
              title: '医生浏览记录',
              roles: [ROLES_TENANT],
              menuId: 'browse-records'
            }
          }
        ]
      },
      {
        path: 'trainManage',
        component: { render: (e) => e('router-view') },
        name: 'trainManage',
        meta: {
          title: '培训管理',
          roles: [ROLES_TENANT],
          menuId: 'trainManage'
        },
        children: [
          {
            path: 'courseList',
            component: () =>
              import('@/views/small-backstage/course-document-manage/list'),
            name: 'courseList',
            meta: {
              title: '课程管理',
              menuId: 'courseList'
            }
          },
          {
            path: 'courseRecycle',
            component: () =>
              import(
                '@/views/small-backstage/course-document-manage/courseRecycle'
              ),
            name: 'courseRecycle',
            hidden: true,
            meta: {
              title: '回收站',
              menuId: 'courseList',
              activeMenu: '/small/Y-Marketing/trainManage/courseList'
            }
          },
          {
            path: 'courseCreat',
            component: () =>
              import('@/views/small-backstage/course-document-manage/creat'),
            name: 'courseCreat',
            hidden: true,
            meta: {
              title: '课程基本信息',
              menuId: 'courseList',
              activeMenu: '/small/Y-Marketing/trainManage/courseList'
            }
          },
          {
            path: 'courseCatalogue',
            component: () =>
              import(
                '@/views/small-backstage/course-document-manage/courseCatalogue'
              ),
            name: 'courseCatalogue',
            hidden: true,
            meta: {
              title: '课程目录',
              menuId: 'courseList',
              activeMenu: '/small/Y-Marketing/trainManage/courseList'
            }
          },
          {
            path: 'courseTestPaper',
            component: () =>
              import(
                '@/views/small-backstage/course-document-manage/courseTestPaper'
              ),
            name: 'courseTestPaper',
            hidden: true,
            meta: {
              title: '试卷目录',
              menuId: 'courseList',
              activeMenu: '/small/Y-Marketing/trainManage/courseList'
            }
          },
          {
            path: 'studentManage',
            component: () =>
              import(
                '@/views/small-backstage/trainPlan/statistics/studentManage'
              ),
            name: 'studentManage',
            meta: {
              title: '学员管理',
              menuId: 'studentManage'
            }
          },
          {
            path: 'studentData',
            component: () =>
              import('@/views/small-backstage/trainPlan/studentData'),
            name: 'studentData',
            hidden: true,
            meta: {
              title: '学员数据',
              menuId: 'dataStatistics',
              activeMenu: '/small/Y-Marketing/trainManage/dataStatistics'
            }
          },
          {
            path: 'stuDataDetails',
            component: () =>
              import('@/views/small-backstage/trainPlan/studentData/details'),
            name: 'stuDataDetails',
            hidden: true,
            meta: {
              title: '学员数据',
              menuId: 'dataStatistics',
              activeMenu: '/small/Y-Marketing/trainManage/dataStatistics'
            }
          },
          {
            path: 'stuExamDetail',
            component: () =>
              import(
                '@/views/small-backstage/trainPlan/studentData/details/exam-detail'
              ),
            name: 'stuExamDetail',
            hidden: true,
            meta: {
              title: '学员数据',
              menuId: 'dataStatistics',
              activeMenu: '/small/Y-Marketing/trainManage/dataStatistics'
            }
          },
          {
            path: 'stuExamList',
            component: () =>
              import(
                '@/views/small-backstage/trainPlan/studentData/details/stuExam-list'
              ),
            name: 'stuExamList',
            hidden: true,
            meta: {
              title: '学员数据',
              menuId: 'dataStatistics',
              activeMenu: '/small/Y-Marketing/trainManage/dataStatistics'
            }
          },
          {
            path: 'electiveCoursesList',
            component: () =>
              import('@/views/small-backstage/elective-courses/list'),
            name: 'electiveCoursesList',
            meta: {
              title: '选修课管理',
              menuId: 'electiveCoursesList'
            }
          },
          {
            path: 'electiveCourseCreat',
            component: () =>
              import('@/views/small-backstage/course-document-manage/creat'),
            name: 'electiveCourseCreat',
            hidden: true,
            meta: {
              title: '课程基本信息',
              menuId: 'electiveCoursesList',
              activeMenu: '/small/Y-Marketing/trainManage/electiveCoursesList'
            }
          },
          {
            path: 'electiveCourseCatalogue',
            component: () =>
              import(
                '@/views/small-backstage/course-document-manage/courseCatalogue'
              ),
            name: 'electiveCourseCatalogue',
            hidden: true,
            meta: {
              title: '课程目录',
              menuId: 'electiveCoursesList',
              activeMenu: '/small/Y-Marketing/trainManage/electiveCoursesList'
            }
          },
          {
            path: 'electiveCourseTestPaper',
            component: () =>
              import(
                '@/views/small-backstage/course-document-manage/courseTestPaper'
              ),
            name: 'electiveCourseTestPaper',
            hidden: true,
            meta: {
              title: '试卷目录',
              menuId: 'electiveCoursesList',
              activeMenu: '/small/Y-Marketing/trainManage/electiveCoursesList'
            }
          },
          {
            path: 'electiveStuData',
            component: () =>
              import('@/views/small-backstage/elective-courses/stu-data'),
            name: 'electiveStuData',
            hidden: true,
            meta: {
              title: '学员数据',
              menuId: 'electiveCoursesList',
              activeMenu: '/small/Y-Marketing/trainManage/electiveCoursesList'
            }
          },
          {
            path: 'trainPlan',
            component: () => import('@/views/small-backstage/trainPlan'),
            name: 'trainPlan',
            meta: {
              title: '培训计划',
              menuId: 'trainPlan'
            }
          },
          {
            path: 'trainPlanRecycle',
            component: () =>
              import('@/views/small-backstage/trainPlan/recycle'),
            name: 'trainPlanRecycle',
            hidden: true,
            meta: {
              title: '回收站',
              menuId: 'trainPlan',
              activeMenu: '/small/Y-Marketing/trainManage/trainPlan'
            }
          },
          {
            path: 'createPlan/:step/:id/:type/:isCompliance',
            component: () =>
              import('@/views/small-backstage/trainPlan/createPlan'),
            name: 'createPlan',
            hidden: true,
            meta: {
              title: '创建计划',
              menuId: 'trainPlan',
              activeMenu: '/small/Y-Marketing/trainManage/trainPlan'
            }
          },
          {
            path: 'statistics',
            component: () =>
              import('@/views/small-backstage/trainPlan/statistics'),
            name: 'statistics',
            hidden: true,
            meta: {
              title: '培训统计',
              menuId: 'dataStatistics',
              activeMenu: '/small/Y-Marketing/trainManage/dataStatistics'
            }
          },
          {
            path: 'testPaperPlan',
            component: () => import('@/views/small-backstage/test-paper-plan'),
            name: 'testPaperPlan',
            meta: {
              title: '考试计划',
              menuId: 'testPaperPlan'
            }
          },
          {
            path: 'createTestPaperPlan/:step/:id',
            component: () =>
              import('@/views/small-backstage/create-test-paper-plan'),
            name: 'createTestPaperPlan',
            hidden: true,
            meta: {
              title: '创建考试计划',
              menuId: 'testPaperPlan',
              activeMenu: '/small/Y-Marketing/trainManage/testPaperPlan'
            }
          },
          {
            path: 'testPaperPlanRecycle',
            component: () =>
              import('@/views/small-backstage/test-paper-plan/recycle'),
            name: 'testPaperPlanRecycle',
            hidden: true,
            meta: {
              title: '考试回收站',
              menuId: 'testPaperPlan',
              activeMenu: '/small/Y-Marketing/trainManage/testPaperPlan'
            }
          },
          {
            path: 'testPaperPlanStudentData',
            component: () =>
              import('@/views/small-backstage/test-paper-plan-student-data'),
            name: 'testPaperPlanStudentData',
            hidden: true,
            meta: {
              title: '学员数据',
              menuId: 'dataStatistics',
              activeMenu: '/small/Y-Marketing/trainManage/dataStatistics'
            }
          },
          {
            path: 'dataStatistics',
            component: () =>
              import('@/views/small-backstage/trainPlan/dataStatistics'),
            name: 'dataStatistics',
            meta: {
              title: '数据统计',
              menuId: 'dataStatistics'
            }
          },
          {
            path: 'mistakesStatistics',
            component: () =>
              import(
                '@/views/small-backstage/trainPlan/dataStatistics/mistakesStatistics'
              ),
            name: 'mistakesStatistics',
            hidden: true,
            meta: {
              title: '错题数据统计',
              menuId: 'dataStatistics',
              activeMenu: '/small/Y-Marketing/trainManage/dataStatistics'
            }
          },
          {
            path: 'mistakesStatistics-detail',
            component: () =>
              import(
                '@/views/small-backstage/trainPlan/dataStatistics/mistakesStatistics/detail'
              ),
            name: 'mistakesStatistics-detail',
            hidden: true,
            meta: {
              title: '错题详情',
              menuId: 'dataStatistics',
              activeMenu: '/small/Y-Marketing/trainManage/dataStatistics'
            }
          },
          {
            path: 'examMarkingList',
            component: () =>
              import('@/views/small-backstage/trainPlan/examMarking/list'),
            name: 'examMarkingList',
            hidden: true,
            meta: {
              title: '试卷批阅',
              menuId: 'trainPlan',
              activeMenu: '/small/Y-Marketing/trainManage/trainPlan'
            }
          },
          {
            path: 'testPaperList',
            component: () =>
              import('@/views/small-backstage/trainPlan/examMarking/list'),
            name: 'testPaperList',
            hidden: true,
            meta: {
              title: '试卷批阅',
              menuId: 'testPaperPlan',
              activeMenu: '/small/Y-Marketing/trainManage/testPaperPlan'
            }
          },
          {
            path: 'testPaperMarkingDetail',
            component: () =>
              import(
                '@/views/small-backstage/trainPlan/studentData/details/exam-detail'
              ),
            name: 'testPaperMarkingDetail',
            hidden: true,
            meta: {
              title: '批阅',
              menuId: 'testPaperPlan',
              activeMenu: '/small/Y-Marketing/trainManage/testPaperPlan'
            }
          },
          {
            path: 'examMarkingDetail',
            component: () =>
              import(
                '@/views/small-backstage/trainPlan/studentData/details/exam-detail'
              ),
            name: 'examMarkingDetail',
            hidden: true,
            meta: {
              title: '批阅',
              menuId: 'trainPlan',
              activeMenu: '/small/Y-Marketing/trainManage/trainPlan'
            }
          },
          {
            path: 'examMarkedDetail/:id',
            component: () =>
              import(
                '@/views/small-backstage/trainPlan/studentData/details/exam-detail'
              ),
            name: 'examMarkedDetail',
            hidden: true,
            meta: {
              title: '批阅详情',
              menuId: 'trainPlan',
              activeMenu: '/small/Y-Marketing/trainManage/trainPlan'
            }
          },
          {
            path: 'trainPlan-detail',
            component: () => import('@/views/small-backstage/trainPlan/detail'),
            name: 'trainPlan-detail',
            hidden: true,
            meta: {
              title: '培训详情',
              menuId: 'trainPlan',
              activeMenu: '/small/Y-Marketing/trainManage/trainPlan'
            }
          }
        ]
      },
      {
        path: '/small/eduManage',
        component: { render: (e) => e('router-view') },
        name: 'small-eduManage',
        meta: {
          title: '试卷管理',
          roles: [ROLES_TENANT],
          menuId: 'small-eduManage'
        },
        children: [
          {
            path: 'exam-list',
            component: () => import('@/views/small-backstage/edu-exam/list'),
            name: 'exam-list',
            meta: {
              title: '试卷管理',
              menuId: 'exam-list'
            }
          },
          {
            path: 'exam-editor/:id',
            component: () => import('@/views/small-backstage/edu-exam/index'),
            name: 'exam-editor',
            hidden: true,
            meta: {
              title: '试卷详情',
              menuId: 'exam-list',
              activeMenu: '/small/eduManage/exam-list'
            }
          },
          {
            path: 'exam-recycle',
            component: () => import('@/views/small-backstage/edu-exam/recycle'),
            name: 'exam-recycle',
            hidden: true,
            meta: {
              title: '试卷回收站',
              menuId: 'exam-list',
              activeMenu: '/small/eduManage/exam-list'
            }
          },
          {
            path: 'question-bank-list',
            component: () =>
              import('@/views/small-backstage/question-bank/list'),
            name: 'question-bank-list',
            meta: {
              title: '题库管理',
              menuId: 'question-bank-list'
            }
          },

          {
            path: 'question-bank-details',
            component: () =>
              import('@/views/small-backstage/question-bank/details'),
            name: 'question-bank-details',
            hidden: true,
            meta: {
              title: '题库详情',
              menuId: 'question-bank-list',
              activeMenu: '/small/eduManage/question-bank-list'
            }
          },
          {
            path: 'question-bank-recycle',
            component: () =>
              import('@/views/small-backstage/question-bank/recycle'),
            name: 'question-bank-recycle',
            hidden: true,
            meta: {
              title: '题库回收站',
              menuId: 'question-bank-list',
              activeMenu: '/small/eduManage/question-bank-list'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/small/Y-Events',
    component: Layout,
    name: 'small-Y-Events',
    meta: {
      title: 'Y-Events',
      icon: 'Y-Events',
      roles: [ROLES_TENANT],
      menuId: 'small-Y-Events'
    },
    children: [
      {
        path: 'meetManage',
        component: { render: (e) => e('router-view') },
        name: 'meetManage',
        meta: {
          title: '会议管理',
          roles: [ROLES_TENANT],
          menuId: 'meetManage'
        },
        children: [
          {
            path: 'my-meeting',
            component: () => import('@/views/small-backstage/my-meeting/index'),
            name: 'my-meeting',
            meta: {
              title: '我的会议',
              roles: [ROLES_TENANT],
              menuId: 'my-meeting',
              keepAlive: true
            }
          },
          {
            path: 'create-meeting-detail',
            component: () =>
              import(
                '@/views/small-backstage/my-meeting/create-meeting/detail'
              ),
            name: 'create-meeting-detail',
            hidden: true,
            meta: {
              title: '会议详情',
              roles: [ROLES_TENANT],
              menuId: 'my-meeting',
              activeMenu: '/small/Y-Events/meetManage/my-meeting'
            }
          },
          {
            path: 'create-meeting-edit',
            component: () =>
              import('@/views/small-backstage/my-meeting/create-meeting/edit'),
            name: 'create-meeting-edit',
            hidden: true,
            meta: {
              title: '创建会议',
              roles: [ROLES_TENANT],
              menuId: 'my-meeting',
              activeMenu: '/small/Y-Events/meetManage/my-meeting'
            }
          },
          {
            path: 'executive-meeting-detail',
            component: () =>
              import(
                '@/views/small-backstage/my-meeting/executive-meeting/detail'
              ),
            name: 'executive-meeting-detail',
            hidden: true,
            meta: {
              title: '会议详情',
              roles: [ROLES_TENANT],
              menuId: 'my-meeting',
              activeMenu: '/small/Y-Events/meetManage/my-meeting'
            }
          },
          {
            path: 'off-line-meet',
            component: () =>
              import('@/views/small-backstage/offLine-meet-manage/list'),
            name: 'off-line-meet',
            meta: {
              title: '会议记录',
              roles: [ROLES_TENANT],
              menuId: 'off-line-meet',
              keepAlive: true
            }
          },
          {
            path: 'off-line-detail',
            component: () =>
              import('@/views/small-backstage/offLine-meet-manage/detail'),
            name: 'off-line-detail',
            hidden: true,
            meta: {
              title: '会议详情',
              roles: [ROLES_TENANT],
              menuId: 'off-line-meet',
              activeMenu: '/small/Y-Events/meetManage/off-line-meet'
            }
          },
          {
            path: 'customer-list',
            component: () =>
              import(
                '@/views/small-backstage/offLine-meet-manage/customer-list'
              ),
            name: 'off-line-customer-list',
            hidden: true,
            meta: {
              title: '客户列表',
              roles: [ROLES_TENANT],
              menuId: 'off-line-meet',
              activeMenu: '/small/Y-Events/meetManage/off-line-meet'
            }
          },
          {
            path: 'meet-plan-detail-snapshot',
            component: () =>
              import(
                '@/views/small-backstage/offLine-meet-manage/meet-plan-detail'
              ),
            name: 'meet-plan-detail-snapshot',
            hidden: true,
            meta: {
              title: '会议计划快照',
              roles: [ROLES_TENANT],
              menuId: 'off-line-meet',
              activeMenu: '/small/Y-Events/meetManage/off-line-meet'
            }
          },
          {
            path: 'all-attendees',
            component: () =>
              import(
                '@/views/small-backstage/offLine-meet-manage/all-attendees'
              ),
            name: 'all-attendees',
            hidden: true,
            meta: {
              title: '全部参会人',
              roles: [ROLES_TENANT],
              menuId: 'off-line-meet',
              activeMenu: '/small/Y-Events/meetManage/off-line-meet'
            }
          },
          {
            path: 'join-meet-customer',
            component: () =>
              import(
                '@/views/small-backstage/offLine-meet-manage/join-meet-customer'
              ),
            name: 'join-meet-customer',
            hidden: true,
            meta: {
              title: '计划参会客户',
              roles: [ROLES_TENANT],
              menuId: 'off-line-meet',
              activeMenu: '/small/Y-Events/meetManage/off-line-meet'
            }
          },
          {
            path: 'plan-attend-customer-detail',
            component: () =>
              import(
                '@/views/small-backstage/offLine-meet-manage/plan-attend-customer-detail'
              ),
            name: 'plan-attend-customer-detail',
            hidden: true,
            meta: {
              title: '计划参会客户',
              roles: [ROLES_TENANT],
              menuId: 'off-line-meet',
              activeMenu: '/small/Y-Events/meetManage/off-line-meet'
            }
          },
          {
            path: 'tenant-offline-sign',
            component: () =>
              import('@/views/small-backstage/tenant-offline-sign'),
            name: 'tenant-offline-sign',
            meta: {
              title: '签到记录',
              roles: [ROLES_TENANT],
              menuId: 'tenant-offline-sign',
              keepAlive: true
            }
          },
          {
            path: 'tenant-offline-sign-detail',
            component: () =>
              import('@/views/small-backstage/tenant-offline-sign-detail'),
            name: 'tenant-offline-sign-detail',
            hidden: true,
            meta: {
              title: '签到详情',
              roles: [ROLES_TENANT],
              menuId: 'tenant-offline-sign',
              activeMenu: '/small/Y-Events/meetManage/tenant-offline-sign'
            }
          },

          {
            path: 'online-list',
            component: () =>
              import('@/views/small-backstage/offLine-meet-manage/online-list'),
            name: 'online-list',
            meta: {
              title: '在线记录',
              roles: [ROLES_TENANT],
              menuId: 'online-list',
              keepAlive: true
            }
          },
          {
            path: 'meet-budget',
            component: () =>
              import(
                '@/views/small-backstage/offLine-meet-manage/budget-config/index'
              ),
            // import('@/views/small-backstage/offLine-meet-manage/meet-budget'),
            name: 'meet-budget',
            meta: {
              title: '会议预算',
              roles: [ROLES_TENANT],
              menuId: 'meet-budget',
              keepAlive: true
            }
          },
          {
            path: 'join-meet-customer-fee',
            component: () =>
              import('@/views/small-backstage/join-meet-customer-fee'),
            name: 'join-meet-customer-fee',
            meta: {
              title: '参会人费用',
              roles: [ROLES_TENANT],
              menuId: 'join-meet-customer-fee'
            }
          },
          {
            path: 'budget-config-detail',
            component: () =>
              import(
                '@/views/small-backstage/offLine-meet-manage/budget-config/detail'
              ),
            name: 'budget-config-detail',
            hidden: true,
            meta: {
              title: '预算详情',
              roles: [ROLES_TENANT],
              menuId: 'meet-budget',
              activeMenu: '/small/Y-Events/meetManage/meet-budget'
            }
          }
        ]
      },
      {
        path: 'meet-config',
        component: { render: (e) => e('router-view') },
        name: 'meetConfig',
        meta: {
          title: '会议配置',
          roles: [ROLES_TENANT],
          menuId: 'meetConfig'
        },
        children: [
          {
            path: 'meetTypeManage',
            component: () =>
              import('@/views/small-backstage/meet-type-manage/list'),
            name: 'meet-type-manage',
            meta: {
              title: '会议设置',
              roles: [ROLES_TENANT],
              menuId: 'meet-type-manage'
            }
          },
          {
            path: 'meet-integral-statistics',
            component: () =>
              import(
                '@/views/small-backstage/meet-type-manage/meetIntegralStatistics'
              ),
            name: 'meet-integral-statistics',
            hidden: true,
            meta: {
              title: '会议积分统计',
              roles: [ROLES_TENANT],
              menuId: 'meet-type-manage',
              activeMenu: '/small/Y-Events/meet-config/meetTypeManage'
            }
          },
          {
            path: 'signFromConfig',
            component: () =>
              import('@/views/small-backstage/sign-from-config/list'),
            name: 'sign-from-config',
            meta: {
              title: '签到入会表单配置',
              roles: [ROLES_TENANT],
              menuId: 'sign-from-config'
            }
          },
          {
            path: 'budget-config',
            component: () =>
              import('@/views/small-backstage/meet-type-manage/budget-config'),
            name: 'budget-config',
            meta: {
              title: '预算配置',
              roles: [ROLES_TENANT],
              menuId: 'budget-config'
            }
          },
          {
            path: 'meet-type-list',
            component: () =>
              import('@/views/small-backstage/meet-type-manage/meet-type-list'),
            name: 'meet-type-list',
            hidden: true,
            meta: {
              title: '会议字段',
              roles: [ROLES_TENANT],
              menuId: 'meet-type-manage',
              activeMenu: '/small/Y-Events/meet-config/meetTypeManage'
            }
          },
          {
            path: 'meet-nested-list',
            component: () =>
              import(
                '@/views/small-backstage/meet-type-manage/meet-nested-list'
              ),
            name: 'meet-nested-list',
            hidden: true,
            meta: {
              title: '设置字段',
              roles: [ROLES_TENANT],
              menuId: 'meet-type-manage',
              activeMenu: '/small/Y-Events/meet-config/meetTypeManage'
            }
          },
          {
            path: 'meet-execute-standard',
            component: () =>
              import(
                '@/views/small-backstage/meet-type-manage/meet-execute-standard'
              ),
            name: 'meet-execute-standard',
            hidden: true,
            meta: {
              title: '执行标准',
              roles: [ROLES_TENANT],
              menuId: 'meet-type-manage',
              activeMenu: '/small/Y-Events/meet-config/meetTypeManage'
            }
          }
        ]
      },
      {
        path: 'speaker-management',
        component: { render: (e) => e('router-view') },
        name: 'speaker-management',
        meta: {
          title: '讲者管理',
          menuId: 'speaker-management',
          roles: [ROLES_TENANT]
        },
        children: [
          {
            path: 'speaker-level-management',
            component: () =>
              import('@/views/small-backstage/speaker-management/level'),
            name: 'speaker-level-management',
            meta: {
              title: '讲者级别管理',
              menuId: 'speaker-level-management',
              roles: [ROLES_TENANT]
            }
          },
          {
            path: 'apply-speaker-template',
            component: () =>
              import(
                '@/views/small-backstage/speaker-management/apply-speaker-template'
              ),
            name: 'apply-speaker-template',
            hidden: true,
            meta: {
              title: '讲者申请字段',
              menuId: 'speaker-level-management',
              roles: [ROLES_TENANT],
              activeMenu:
                '/small/Y-Events/speaker-management/speaker-level-management'
            }
          },
          {
            path: 'speaker-base-field',
            component: () =>
              import(
                '@/views/small-backstage/speaker-management/speaker-base-field'
              ),
            name: 'speaker-base-field',
            hidden: true,
            meta: {
              title: '讲者基础字段',
              menuId: 'speaker-level-management',
              roles: [ROLES_TENANT],
              activeMenu:
                '/small/Y-Events/speaker-management/speaker-level-management'
            }
          },
          {
            path: 'speaker-list',
            component: () =>
              import('@/views/small-backstage/speaker-management/list'),
            name: 'speaker-list',
            meta: {
              title: '讲者列表',
              menuId: 'speaker-list',
              roles: [ROLES_TENANT],
              keepAlive: true
            }
          },
          // {
          //   path: 'speaker_list_nosales',
          //   component: () =>
          //     import('@/views/small-backstage/speaker-management/list'),
          //   name: 'speaker_list_nosales',
          //   meta: {
          //     title: '讲者列表-非销',
          //     menuId: 'speaker_list_nosales',
          //     roles: [ROLES_TENANT],
          //     keepAlive: true
          //   }
          // },
          {
            path: 'speaker-list-detail',
            component: () =>
              import('@/views/small-backstage/speaker-management/detail'),
            name: 'speaker-list-detail',
            hidden: true,
            meta: {
              title: '讲者列表详情',
              menuId: 'speaker-list',
              roles: [ROLES_TENANT],
              activeMenu: '/small/Y-Events/speaker-management/speaker-list'
            }
          },
          {
            path: 'speaker-edit',
            component: () =>
              import('@/views/small-backstage/speaker-management/speaker-edit'),
            name: 'speakerEdit',
            hidden: true,
            meta: {
              title: '讲者编辑',
              menuId: 'speaker-list',
              roles: [ROLES_TENANT],
              activeMenu: '/small/Y-Events/speaker-management/speaker-list'
            }
          },
          {
            path: 'speaker-role-management',
            component: () =>
              import(
                '@/views/small-backstage/speaker-management/speaker-role-management'
              ),
            name: 'speaker-role-management',
            meta: {
              title: '讲者角色',
              menuId: 'speaker-role-management',
              roles: [ROLES_TENANT]
            }
          }
        ]
      },
      {
        path: 'meeting-flight-inspection',
        component: { render: (e) => e('router-view') },
        name: 'meeting-flight-inspection',
        meta: {
          title: '会议飞检',
          menuId: 'meeting-flight-inspection',
          roles: [ROLES_TENANT]
        },
        children: [
          {
            path: 'flight-inspection-distribution',
            component: () =>
              import(
                '@/views/small-backstage/meeting-flight-inspection/flight-inspection-distribution'
              ),
            name: 'flight-inspection-distribution',
            meta: {
              title: '飞检分配',
              menuId: 'flight-inspection-distribution',
              roles: [ROLES_TENANT]
            }
          },
          {
            path: 'flight-inspection-mine',
            component: () =>
              import(
                '@/views/small-backstage/meeting-flight-inspection/flight-inspection-mine'
              ),
            name: 'flight-inspection-mine',
            meta: {
              title: '我的飞检',
              menuId: 'flight-inspection-mine',
              roles: [ROLES_TENANT]
            }
          }
        ]
      },
      {
        path: 'cost-center',
        name: 'cost-center',
        component: { render: (e) => e('router-view') },
        meta: {
          title: '成本中心',
          menuId: 'cost-center'
        },
        children: [
          {
            path: 'cost-management',
            name: 'cost-management',
            component: () =>
              import(
                '@/views/small-backstage/cost-center/cost-management/index'
              ),
            meta: {
              title: '成本管理',
              menuId: 'cost-center'
            }
          },
          {
            path: 'create-cost',
            name: 'create-cost',
            hidden: true,
            component: () =>
              import(
                '@/views/small-backstage/cost-center/cost-management/create-cost'
              ),
            meta: {
              title: '创建成本中心',
              menuId: 'cost-management',
              activeMenu: '/small/Y-Events/cost-center/cost-management'
            }
          },
          {
            path: 'cost-detail',
            name: 'cost-detail',
            hidden: true,
            component: () =>
              import(
                '@/views/small-backstage/cost-center/cost-management/detail'
              ),
            meta: {
              title: '成本中心详情',
              menuId: 'cost-management',
              activeMenu: '/small/Y-Events/cost-center/cost-management'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/small/Y-Management',
    component: Layout,
    name: 'small-Y-Management',
    meta: {
      title: 'Y-Management',
      icon: 'Y-Management',
      roles: [ROLES_TENANT],
      menuId: 'small-Y-Management'
    },
    children: [
      {
        path: '/small/architectureMange',
        component: { render: (e) => e('router-view') },
        name: 'small-architectureMange',
        meta: {
          title: '架构管理',
          roles: [ROLES_TENANT],
          menuId: 'small-architectureMange'
        },
        children: [
          //7.0 新增 v2
          {
            path: 'position-management',
            component: () =>
              import('@/views/small-backstage/position-management'),
            name: 'position-management',
            meta: {
              title: '岗位管理',
              roles: [ROLES_TENANT],
              menuId: 'position-management'
            }
          },
          //7.0 新增 v2
          {
            path: 'jurisdiction-management',
            component: () =>
              import('@/views/small-backstage/jurisdiction-management'),
            name: 'jurisdiction-management',
            meta: {
              title: '辖区管理',
              roles: [ROLES_TENANT],
              menuId: 'jurisdiction-management'
            }
          },
          //7.0 新增 v2
          {
            path: 'aim-doctor-management',
            component: () =>
              import('@/views/small-backstage/aim-doctor-management'),
            name: 'aim-doctor-management',
            meta: {
              title: '目标医生管理',
              roles: [ROLES_TENANT],
              menuId: 'aim-doctor-management'
            }
          },
          //7.0 新增 v2
          {
            path: 'structure-version-management',
            component: () =>
              import('@/views/small-backstage/structure-version-management'),
            name: 'structure-version-management',
            meta: {
              title: '架构版本管理',
              roles: [ROLES_TENANT],
              menuId: 'structure-version-management'
            }
          },
          //7.0 新增 v2
          {
            path: 'position-setting',
            component: () => import('@/views/small-backstage/position-setting'),
            name: 'position-setting',
            meta: {
              title: '岗位字段设置',
              roles: [ROLES_TENANT],
              menuId: 'position-setting'
            }
          },
          //7.0 新增 v2
          {
            path: 'dept-city-product-relation',
            component: () =>
              import(
                '@/views/small-backstage/dept-city-product-relation/index'
              ),
            name: 'dept-city-product-relation',
            meta: {
              title: '非销辖区管理',
              roles: [ROLES_TENANT],
              menuId: 'dept-city-product-relation'
            }
          },
          {
            path: 'aim-doctor-no-sale-management',
            component: () =>
              import('@/views/small-backstage/aim-doctor-no-sale-management'),
            name: 'aim-doctor-no-sale-management',
            meta: {
              title: '非销目标医生',
              roles: [ROLES_TENANT],
              menuId: 'aim-doctor-no-sale-management'
            }
          },
          //7.7 新增
          {
            path: 'jurisdiction-split',
            component: () =>
              import('@/views/small-backstage/jurisdiction-split'),
            name: 'jurisdiction-split',
            meta: {
              title: '共坑拆分',
              roles: [ROLES_TENANT],
              menuId: 'jurisdiction-split'
            }
          },
          //v1
          {
            path: 'tenant-representative-management',
            component: () =>
              import(
                '@/views/small-backstage/tenant-representative-management'
              ),
            name: 'tenant-representative-management',
            meta: {
              title: '辖区管理',
              roles: [ROLES_TENANT],
              menuId: 'tenant-representative-management'
            }
          },
          //v1
          {
            path: 'architecture-versions',
            component: () =>
              import('@/views/small-backstage/architecture-versions'),
            name: 'architecture-versions',
            meta: {
              title: '架构版本',
              roles: [ROLES_TENANT],
              menuId: 'architecture-versions'
            }
          }
        ]
      },
      {
        path: '/small/masterDataManage',
        component: { render: (e) => e('router-view') },
        name: 'small-masterDataManage',
        meta: {
          title: '主数据管理',
          roles: [ROLES_TENANT],
          menuId: 'small-masterDataManage'
        },
        children: [
          {
            path: 'target-customer',
            component: () => import('@/views/small-backstage/target-customer'),
            name: 'target-customer',
            meta: {
              title: '客户管理',
              roles: [ROLES_TENANT],
              menuId: 'target-customer',
              keepAlive: true
            }
          },
          {
            path: 'target-customer-detail',
            component: () =>
              import('@/views/small-backstage/target-customer/detail'),
            name: 'target-customer-detail',
            hidden: true,
            meta: {
              title: '客户详情',
              roles: [ROLES_TENANT],
              menuId: 'target-customer',
              activeMenu: '/small/masterDataManage/target-customer'
            }
          },
          {
            path: 'target-customer-tab',
            component: () =>
              import('@/views/small-backstage/target-customer/tab'),
            name: 'target-customer-tab',
            hidden: true,
            meta: {
              title: '客户详情',
              roles: [ROLES_TENANT],
              menuId: 'target-customer',
              activeMenu: '/small/masterDataManage/target-customer'
            }
          },
          {
            path: 'add-customer',
            component: () =>
              import('@/views/small-backstage/target-customer/add-customer'),
            name: 'add-customer',
            hidden: true,
            meta: {
              title: '客户管理',
              menuId: 'target-customer',
              roles: [ROLES_TENANT],
              activeMenu: '/small/masterDataManage/target-customer'
            }
          },
          {
            path: 'main-customer',
            component: () =>
              import('@/views/small-backstage/target-customer/main-customer'),
            name: 'main-customer',
            meta: {
              title: '重点客户管理',
              roles: [ROLES_TENANT],
              menuId: 'main-customer',
              keepAlive: true
            }
          },
          {
            path: 'target-customer-single',
            component: () =>
              import('@/views/small-backstage/target-customer/single'),
            name: 'target-customer-single',
            hidden: true,
            meta: {
              title: '医生客户',
              roles: [ROLES_TENANT],
              menuId: 'target-customer',
              activeMenu: '/small/masterDataManage/target-customer'
            }
          },

          {
            path: 'hospital-potential',
            component: () =>
              import('@/views/small-backstage/hospital-potential/index'),
            name: 'hospital-potential',
            meta: {
              title: '医院潜力',
              roles: [ROLES_TENANT],
              menuId: 'hospital-potential',
              keepAlive: true
            }
          },
          {
            path: 'alias-management',
            component: () =>
              import('@/views/small-backstage/alias-management/index'),
            name: 'alias-management',
            meta: {
              title: '别名库管理',
              roles: [ROLES_TENANT],
              menuId: 'alias-management'
            }
          },

          {
            path: 'approval-configuration',
            component: () =>
              import('@/views/small-backstage/approval-configuration'),
            name: 'approval-configuration',
            meta: {
              title: '主数据审批配置',
              roles: [ROLES_TENANT],
              menuId: 'approval-configuration'
            }
          },
          {
            path: 'customer-rep',
            component: () => import('@/views/small-backstage/customer-rep'),
            name: 'customer-rep',
            meta: {
              title: '客户&员工',
              roles: [ROLES_TENANT],
              menuId: 'customer-rep'
            }
          },
          {
            path: 'jurisdiction-org',
            component: () => import('@/views/small-backstage/jurisdiction-org'),
            name: 'jurisdiction-org',
            meta: {
              title: '辖区&机构',
              roles: [ROLES_TENANT],
              menuId: 'jurisdiction-org'
            }
          },
          {
            path: 'customer-product',
            component: () => import('@/views/small-backstage/customer-product'),
            name: 'customer-product',
            meta: {
              title: '客户&产品',
              roles: [ROLES_TENANT],
              menuId: 'customer-product'
            }
          },
          {
            path: 'customer-product-detail',
            component: () =>
              import('@/views/small-backstage/customer-product/detail'),
            name: 'customer-product-detail',
            hidden: true,
            meta: {
              title: '编辑客户&产品关系',
              menuId: 'customer-product',
              roles: [ROLES_TENANT],
              activeMenu: '/small/masterDataManage/customer-product'
            }
          },
          {
            path: 'AddRelation',
            component: () =>
              import(
                '@/views/small-backstage/customer-product/components/AddRelation'
              ),
            name: 'AddRelation',
            hidden: true,
            meta: {
              title: '添加客户&产品关系',
              menuId: 'customer-product',
              roles: [ROLES_TENANT],
              activeMenu: '/small/masterDataManage/customer-product'
            }
          },
          {
            path: 'data-consolidation',
            component: () =>
              import('@/views/small-backstage/data-consolidation'),
            name: 'data-consolidation',
            meta: {
              title: '主数据合并',
              roles: [ROLES_TENANT],
              menuId: 'data-consolidation'
            }
          }
        ]
      },
      {
        path: '/small/marketManagement',
        component: { render: (e) => e('router-view') },
        name: 'small-marketManagement',
        meta: {
          title: '市场管理',
          roles: [ROLES_TENANT],
          menuId: 'small-marketManagement'
        },
        children: [
          {
            path: 'competitive-management-nosales',
            component: () =>
              import(
                '@/views/small-backstage/competitive-management/competitiveNosales'
              ),
            name: 'competitive-management-nosales',
            meta: {
              title: '竞品管理-非销',
              roles: [ROLES_TENANT],
              menuId: 'competitive-management-nosales'
            }
          },
          {
            path: 'np-management',
            component: () => import('@/views/small-backstage/np-management'),
            name: 'np-management',
            meta: {
              title: 'NP管理',
              roles: [ROLES_TENANT],
              menuId: 'np-management'
            }
          },
          /**
           * v7.61 产品要求隐藏该菜单
           */
          // {
          //   path: 'np-management-nosales',
          //   component: () =>
          //     import('@/views/small-backstage/np-management/npNosales'),
          //   name: 'np-management-nosales',
          //   meta: {
          //     title: 'NP管理-非销',
          //     roles: [ROLES_TENANT],
          //     menuId: 'np-management-nosales'
          //   }
          // },
          {
            path: 'sales-reporting-management',
            component: () =>
              import('@/views/small-backstage/sales-reporting-management'),
            name: 'sales-reporting-management',
            meta: {
              title: '销量上报管理',
              roles: [ROLES_TENANT],
              menuId: 'sales-reporting-management'
            }
          },
          /**
           * v7.61 产品要求隐藏该菜单
           */
          // {
          //   path: 'sales-reporting-management-nosales',
          //   component: () =>
          //     import(
          //       '@/views/small-backstage/sales-reporting-management/salesNosales'
          //     ),
          //   name: 'sales-reporting-management-nosales',
          //   meta: {
          //     title: '销量上报管理-非销',
          //     roles: [ROLES_TENANT],
          //     menuId: 'sales-reporting-management-nosales'
          //   }
          // },
          {
            path: 'adverse-event-report',
            name: 'adverse-event-report',
            meta: {
              title: '不良反应上报',
              roles: [ROLES_TENANT],
              menuId: 'adverse_event_report'
            },
            component: { render: (e) => e('router-view') },
            children: [
              {
                path: 'adverse-event-report-list',
                name: 'adverse-event-report-list',
                meta: {
                  title: '上报列表',
                  roles: [ROLES_TENANT],
                  menuId: 'adverse_event_report_list'
                },
                component: () =>
                  import('@/views/small-backstage/adverse-event-report/list')
              },
              {
                path: 'adverse-event-report-detail',
                name: 'adverse-event-report-detail',
                hidden: true,
                meta: {
                  title: '上报详情',
                  roles: [ROLES_TENANT],
                  menuId: 'adverse_event_report_list',
                  activeMenu:
                    '/small/marketManagement/adverse-event-report/adverse-event-report-list'
                },
                component: () =>
                  import('@/views/small-backstage/adverse-event-report/detail')
              },
              {
                path: 'adverse-event-report-config',
                name: 'adverse-event-report-config',
                meta: {
                  title: '上报配置',
                  roles: [ROLES_TENANT],
                  menuId: 'adverse_event_report_config'
                },
                component: () =>
                  import('@/views/small-backstage/adverse-event-report/config')
              }
            ]
          },
          {
            path: 'sales-forecasting',
            component: () =>
              import(
                '@/views/small-backstage/sales-reporting-management/sales-forecasting'
              ),
            name: 'sales-forecasting',
            meta: {
              title: '销量预估',
              roles: [ROLES_TENANT],
              menuId: 'sales-forecasting'
            }
          },
          {
            path: 'forecast-confirmation',
            component: () =>
              import(
                '@/views/small-backstage/sales-reporting-management/forecast-confirmation'
              ),
            name: 'forecast-confirmation',
            meta: {
              title: '销量预估确认',
              roles: [ROLES_TENANT],
              menuId: 'forecast-confirmation'
            }
          }
          /**
           * v7.61 产品要求隐藏该菜单
           */
          // {
          //   path: 'sales-reporting-management-nosales',
          //   component: () =>
          //     import(
          //       '@/views/small-backstage/sales-reporting-management/salesNosales'
          //     ),
          //   name: 'sales-reporting-management-nosales',
          //   meta: {
          //     title: '销量上报管理-非销',
          //     roles: [ROLES_TENANT],
          //     menuId: 'sales-reporting-management-nosales'
          //   }
          // }
        ]
      },
      {
        path: '/small/institutionalAffiliation',
        component: { render: (e) => e('router-view') },
        name: 'small-institutionalAffiliation',
        meta: {
          title: '机构挂靠',
          roles: [ROLES_TENANT],
          menuId: 'small-institutionalAffiliation'
        },
        children: [
          {
            path: 'affiliated-management',
            component: () =>
              import('@/views/small-backstage/affiliated-management'),
            name: 'affiliated-management',
            meta: {
              title: '挂靠管理',
              roles: [ROLES_TENANT],
              menuId: 'affiliated-management'
            }
          }
        ]
      },
      {
        path: 'visit-management',
        component: { render: (e) => e('router-view') },
        name: 'visitManagement',
        meta: {
          title: '拜访管理',
          roles: [ROLES_TENANT],
          menuId: 'visitManagement'
        },
        children: [
          {
            path: 'tenant-offline-visit',
            component: () =>
              import('@/views/small-backstage/tenant-offline-visit'),
            name: 'tenant-offline-visit',
            meta: {
              title: '线下拜访记录',
              roles: [ROLES_TENANT],
              menuId: 'tenant-offline-visit',
              keepAlive: true
            }
          },
          {
            path: 'tenant-offline-visit-two',
            component: () =>
              import('@/views/small-backstage/tenant-offline-visit2'),
            name: 'tenant-offline-visit2',
            meta: {
              title: '线下拜访签到记录',
              roles: [ROLES_TENANT],
              menuId: 'tenant-offline-visit2'
            }
          },
          {
            path: 'tenant-offline-inspection-store',
            component: () =>
              import('@/views/small-backstage/tenant-offline-inspection-store'),
            name: 'tenant-offline-inspection-store',
            meta: {
              title: '巡店记录',
              roles: [ROLES_TENANT],
              menuId: 'tenant-offline-inspection-store',
              keepAlive: true
            }
          },
          {
            path: 'tenant-offline-inspection-store-detail',
            component: () =>
              import(
                '@/views/small-backstage/tenant-offline-inspection-store/detail'
              ),
            name: 'tenant-offline-inspection-store-detail',
            hidden: true,
            meta: {
              title: '巡店详情',
              roles: [ROLES_TENANT],
              menuId: 'tenant-offline-inspection-store',
              activeMenu:
                '/small/Y-Management/visit-management/tenant-offline-inspection-store'
            }
          },
          {
            path: 'offline-visit-detail',
            component: () =>
              import('@/views/small-backstage/offline-visit-detail'),
            name: 'offline-visit-detail',
            hidden: true,
            meta: {
              title: '拜访详情',
              roles: [ROLES_TENANT],
              menuId: 'tenant-offline-visit',
              activeMenu:
                '/small/Y-Management/visit-management/tenant-offline-visit'
            }
          },

          {
            path: 'online-visit-detail',
            component: () =>
              import('@/views/small-backstage/online-visit-detail'),
            name: 'online-visit-detail',
            hidden: true,
            meta: {
              title: '线上拜访详情',
              roles: [ROLES_TENANT],
              menuId: 'online-visit-record',
              activeMenu:
                '/small/Y-Management/visit-management/online-visit-record'
            }
          },
          {
            path: 'online-visit-record',
            component: () =>
              import('@/views/small-backstage/online-visit-record'),
            name: 'online-visit-record',
            meta: {
              title: '线上拜访记录',
              roles: [ROLES_TENANT],
              menuId: 'online-visit-record'
            }
          },
          {
            path: 'online-record',
            component: () => import('@/views/small-backstage/online-record'),
            name: 'online-record',
            meta: {
              title: '线上拜访在线记录',
              roles: [ROLES_TENANT],
              menuId: 'online-record'
            }
          },
          {
            path: 'follow-up-visit',
            component: () => import('@/views/small-backstage/follow-up-visit'),
            name: 'follow-up-visit',
            meta: {
              title: '随访记录',
              roles: [ROLES_TENANT],
              menuId: 'follow-up-visit'
            }
          },
          {
            path: 'visit-configuration',
            component: () =>
              import('@/views/small-backstage/visit-configuration'),
            name: 'visit-configuration',
            meta: {
              title: '拜访配置',
              roles: [ROLES_TENANT],
              menuId: 'visit-configuration'
            }
          }
        ]
      },
      {
        // 业务计划管理
        path: 'business-plan-management',
        component: { render: (e) => e('router-view') },
        name: 'business-plan-management',
        meta: {
          title: '业务计划管理',
          roles: [ROLES_TENANT],
          menuId: 'business-plan-management'
        },
        children: [
          {
            path: 'business-plan',
            component: () => import('@/views/small-backstage/business-plan'),
            name: 'business-plan',
            meta: {
              title: '业务计划',
              roles: [ROLES_TENANT],
              menuId: 'business-plan'
            }
          }
        ]
      },
      {
        path: 'service-task-management',
        component: { render: (e) => e('router-view') },
        name: 'service-task-management',
        meta: {
          title: '服务任务管理',
          roles: [ROLES_TENANT],
          menuId: 'service-task-management'
        },
        children: [
          {
            path: 'service-provider',
            component: () =>
              import(
                '@/views/small-backstage/service-task-management/service-provider'
              ),
            name: 'service-provider',
            meta: {
              title: '服务商管理',
              roles: [ROLES_TENANT],
              menuId: 'service-provider'
            }
          },
          {
            path: 'service-provide-create',
            component: () =>
              import(
                '@/views/small-backstage/service-task-management/service-provider/create'
              ),
            name: 'service-provide-create',
            hidden: true,
            meta: {
              title: '服务商管理',
              roles: [ROLES_TENANT],
              menuId: 'service-provider',
              activeMenu:
                '/small/Y-Management/service-task-management/service-provider'
            }
          },
          {
            path: 'service-provide-detail',
            component: () =>
              import(
                '@/views/small-backstage/service-task-management/service-provider/detail'
              ),
            name: 'service-provide-detail',
            hidden: true,
            meta: {
              title: '服务商管理',
              roles: [ROLES_TENANT],
              menuId: 'service-provider',
              activeMenu:
                '/small/Y-Management/service-task-management/service-provider'
            }
          },
          {
            path: 'project-config',
            component: () =>
              import(
                '@/views/small-backstage/service-task-management/project-config'
              ),
            name: 'project-config',
            meta: {
              title: '服务设置',
              roles: [ROLES_TENANT],
              menuId: 'project-config'
            }
          },
          {
            path: 'project-config-create',
            component: () =>
              import(
                '@/views/small-backstage/service-task-management/project-config/create'
              ),
            name: 'project-config-create',
            hidden: true,
            meta: {
              title: '服务设置',
              roles: [ROLES_TENANT],
              menuId: 'project-config',
              activeMenu:
                '/small/Y-Management/service-task-management/project-config'
            }
          },
          {
            path: 'agency-aptitudes',
            component: () =>
              import(
                '@/views/small-backstage/service-task-management/agency-aptitudes'
              ),
            name: 'agency-aptitudes',
            meta: {
              title: '服务商资质审批',
              roles: [ROLES_TENANT],
              menuId: 'agency-aptitudes'
            }
          },
          {
            path: 'agency-aptitudes-detail',
            component: () =>
              import(
                '@/views/small-backstage/service-task-management/agency-aptitudes/detail'
              ),
            name: 'agency-aptitudes-detail',
            hidden: true,
            meta: {
              title: '服务商资质详情',
              roles: [ROLES_TENANT],
              menuId: 'agency-aptitudes',
              activeMenu:
                '/small/Y-Management/service-task-management/agency-aptitudes'
            }
          },
          {
            path: 'task-distribute',
            component: () =>
              import(
                '@/views/small-backstage/service-task-management/task-distribute'
              ),
            name: 'task-distribute',
            meta: {
              title: '服务商任务下发',
              roles: [ROLES_TENANT],
              menuId: 'task-distribute',
              keepAlive: true
            }
          },
          {
            path: 'task-distribute-create',
            component: () =>
              import(
                '@/views/small-backstage/service-task-management/task-distribute/create'
              ),
            name: 'task-distribute-create',
            hidden: true,
            meta: {
              title: '服务商任务下发',
              roles: [ROLES_TENANT],
              menuId: 'task-distribute',
              activeMenu:
                '/small/Y-Management/service-task-management/task-distribute'
            }
          },
          {
            path: 'task-distribute-detail',
            component: () =>
              import(
                '@/views/small-backstage/service-task-management/task-distribute/detail'
              ),
            name: 'task-distribute-detail',
            hidden: true,
            meta: {
              title: '服务商任务下发',
              roles: [ROLES_TENANT],
              menuId: 'task-distribute',
              activeMenu:
                '/small/Y-Management/service-task-management/task-distribute'
            }
          },
          {
            path: 'execution-trace',
            component: () =>
              import(
                '@/views/small-backstage/service-task-management/execution-trace/tabs'
              ),
            name: 'execution-trace',
            meta: {
              title: '服务商执行跟踪',
              roles: [ROLES_TENANT],
              menuId: 'execution-trace',
              keepAlive: true
            }
          },
          {
            path: 'provider-task-approval',
            component: () =>
              import(
                '@/views/small-backstage/service-task-management/provider-task-approval'
              ),
            name: 'provider-task-approval',
            meta: {
              title: '服务商任务审批',
              roles: [ROLES_TENANT],
              menuId: 'provider-task-approval',
              keepAlive: true
            }
          },
          {
            path: 'provider-task-approval-ai-audit',
            component: () =>
              import(
                '@/views/small-backstage/service-task-management/provider-task-approval/ai-audit'
              ),
            hidden: true,
            name: 'provider-task-approval-ai-audit',
            meta: {
              title: 'AI控件审核',
              roles: [ROLES_TENANT],
              menuId: 'provider-task-approval',
              activeMenu:
                '/small/Y-Management/service-task-management/provider-task-approval'
            }
          },
          {
            path: 'provider-task-approval-detail',
            component: () =>
              import(
                '@/views/small-backstage/service-provider-center/approval-detail'
              ),
            name: 'provider-task-approval-detail',
            hidden: true,
            meta: {
              title: '详情',
              roles: [ROLES_TENANT],
              menuId: 'provider-task-approval',
              // menuId: 'subtask-record',
              activeMenu:
                '/small/Y-Management/service-task-management/provider-task-approval'
            }
          },
          {
            name: 'third-level-signing-area',
            path: 'third-level-signing-area',
            meta: {
              title: '签约区域管理',
              roles: [ROLES_TENANT],
              menuId: 'third-level-signing-area'
            },
            component: { render: (e) => e('router-view') },
            children: [
              {
                name: 'first-level-contract-management',
                path: 'first-level-contract-management',
                meta: {
                  title: '一级签约管理',
                  roles: [ROLES_TENANT],
                  menuId: 'first-level-contract-management',
                  keepAlive: true
                },
                component: () =>
                  import(
                    '@/views/small-backstage/service-task-management/third-level-signing-area/first-level-contract-management/index'
                  )
              },
              {
                name: 'second-level-contract-management',
                path: 'second-level-contract-management',
                meta: {
                  title: '二级签约管理',
                  roles: [ROLES_TENANT],
                  menuId: 'second-level-contract-management',
                  keepAlive: true
                },
                component: () =>
                  import(
                    '@/views/small-backstage/service-task-management/third-level-signing-area/second-level-contract-management/index'
                  )
              },
              {
                name: 'third-level-contract-management',
                path: 'third-level-contract-management',
                meta: {
                  title: '三级签约管理',
                  roles: [ROLES_TENANT],
                  menuId: 'third-level-contract-management',
                  keepAlive: true
                },
                component: () =>
                  import(
                    '@/views/small-backstage/service-task-management/third-level-signing-area/third-level-contract-management/index'
                  )
              },
              {
                name: 'level-contract-details',
                path: 'level-contract-details',
                hidden: true,
                meta: {
                  title: '三级签约区域详情',
                  roles: [ROLES_TENANT],
                  menuId: 'third-level-signing-area',
                  activeMenu:
                    '/small/Y-Management/service-task-management/third-level-signing-area/third-level-contract-management'
                },
                component: () =>
                  import(
                    '@/views/small-backstage/service-task-management/third-level-signing-area/components/level-contract-details'
                  )
              }
            ]
          },
          {
            path: 'settlement-task-list',
            component: () =>
              import(
                '@/views/small-backstage/service-task-management/settlement-task-list'
              ),
            name: 'settlement-task-list',
            meta: {
              title: '服务商任务结算',
              roles: [ROLES_TENANT],
              menuId: 'agency-task-settlement'
            }
          },
          {
            path: 'settlement-task-visit',
            component: () =>
              import(
                '@/views/small-backstage/service-task-management/settlement-task-list/settlement-task-visit'
              ),
            name: 'settlement-task-visit',
            hidden: true,
            meta: {
              title: '任务结算拜访',
              roles: [ROLES_TENANT],
              menuId: 'agency-task-settlement',
              activeMenu:
                '/small/Y-Management/service-task-management/settlement-task-list'
            }
          },
          {
            path: 'settlement-task-store-visit',
            component: () =>
              import(
                '@/views/small-backstage/service-task-management/settlement-task-list/settlement-task-store-visit'
              ),
            name: 'settlement-task-store-visit',
            hidden: true,
            meta: {
              title: '任务结算巡店',
              roles: [ROLES_TENANT],
              menuId: 'agency-task-settlement',
              activeMenu:
                '/small/Y-Management/service-task-management/settlement-task-list'
            }
          },
          {
            path: 'settlement-task-external-questionnaire',
            component: () =>
              import(
                '@/views/small-backstage/service-task-management/settlement-task-list/settlement-task-external-questionnaire'
              ),
            name: 'settlement-task-external-questionnaire',
            hidden: true,
            meta: {
              title: '任务结算问卷外部',
              roles: [ROLES_TENANT],
              menuId: 'agency-task-settlement',
              activeMenu:
                '/small/Y-Management/service-task-management/settlement-task-list'
            }
          },
          {
            path: 'settlement-task-internal-questionnaire',
            component: () =>
              import(
                '@/views/small-backstage/service-task-management/settlement-task-list/settlement-task-internal-questionnaire'
              ),
            name: 'settlement-task-internal-questionnaire',
            hidden: true,
            meta: {
              title: '任务结算问卷内部',
              roles: [ROLES_TENANT],
              menuId: 'agency-task-settlement',
              activeMenu:
                '/small/Y-Management/service-task-management/settlement-task-list'
            }
          },
          {
            path: 'settlement-task-marketing',
            component: () =>
              import(
                '@/views/small-backstage/service-task-management/settlement-task-list/settlement-task-marketing'
              ),
            name: 'settlement-task-marketing',
            hidden: true,
            meta: {
              title: '任务结算营销任务',
              roles: [ROLES_TENANT],
              menuId: 'agency-task-settlement',
              activeMenu:
                '/small/Y-Management/service-task-management/settlement-task-list'
            }
          }
        ]
      },

      {
        path: 'service-provider-center',
        component: { render: (e) => e('router-view') },
        name: 'service-provider-center',
        meta: {
          title: '服务商中心',
          roles: [ROLES_TENANT],
          menuId: 'service-provider-center'
        },
        children: [
          {
            path: 'task-management',
            component: () =>
              import(
                '@/views/small-backstage/service-provider-center/task-management'
              ),
            name: 'task-management',
            meta: {
              title: '任务管理',
              roles: [ROLES_TENANT],
              menuId: 'task-management',
              keepAlive: true
            }
          },
          {
            path: 'task-management/submit-task',
            component: () =>
              import(
                '@/views/small-backstage/service-provider-center/task-management/submit-task'
              ),
            name: 'task-management-submit-task',
            hidden: true,
            meta: {
              title: '选择任务',
              roles: [ROLES_TENANT],
              menuId: 'task-management',
              activeMenu:
                '/small/Y-Management/service-provider-center/task-management'
            }
          },
          {
            path: 'task-management/approval',
            component: () =>
              import(
                '@/views/small-backstage/service-provider-center/task-management/approval'
              ),
            name: 'task-management-approval',
            hidden: true,
            meta: {
              title: '任务审批',
              roles: [ROLES_TENANT],
              menuId: 'task-management',
              activeMenu:
                '/small/Y-Management/service-task-management/task-distribute'
            }
          },
          {
            path: 'set-distribute-subtasks',
            component: () =>
              import(
                '@/views/small-backstage/service-provider-center/set-distribute-subtasks'
              ),
            hidden: true,
            name: 'set-distribute-subtasks',
            meta: {
              title: '分配子任务',
              roles: [ROLES_TENANT],
              menuId: 'task-management',
              activeMenu:
                '/small/Y-Management/service-provider-center/task-management'
            }
          },
          {
            path: 'subtask-record',
            component: () =>
              import(
                '@/views/small-backstage/service-provider-center/subtask-record'
              ),
            name: 'subtask-record',
            meta: {
              title: '子任务记录',
              roles: [ROLES_TENANT],
              menuId: 'subtask-record',
              keepAlive: true
            }
          },
          {
            path: 'subtask-detail',
            component: () =>
              import(
                '@/views/small-backstage/service-provider-center/subtask-detail'
              ),
            hidden: true,
            name: 'subtask-detail',
            meta: {
              title: '子任务记录',
              roles: [ROLES_TENANT],
              menuId: 'subtask-record',
              activeMenu:
                '/small/Y-Management/service-provider-center/subtask-record'
            }
          },
          {
            path: 'approval-detail',
            component: () =>
              import(
                '@/views/small-backstage/service-provider-center/approval-detail'
              ),
            name: 'approval-detail',
            hidden: true,
            meta: {
              title: '详情',
              roles: [ROLES_TENANT],
              menuId: 'subtask-record',
              activeMenu:
                '/small/Y-Management/service-provider-center/subtask-record'
            }
          }
        ]
      },
      {
        path: '/small/enter-hospital-management-v2',
        component: { render: (e) => e('router-view') },
        name: 'enter-hospital-management',
        meta: {
          title: '进院管理',
          roles: [ROLES_TENANT],
          menuId: 'enter-hospital-management-v2'
        },
        children: [
          {
            path: 'enter-hospital-data-management-v2',
            component: () =>
              import(
                '@/views/small-backstage/enter-hospital-management/data-management-v2.vue'
              ),
            name: 'enter-hospital-data-management-v2',
            meta: {
              title: '进院记录',
              roles: [ROLES_TENANT],
              menuId: 'enter-hospital-data-management-v2'
            }
          },
          {
            path: 'enter-hospital-data-management-v2-nosales',
            component: () =>
              import(
                '@/views/small-backstage/enter-hospital-management/data-management-v2.vue'
              ),
            name: 'enter-hospital-data-management-v2-nosales',
            meta: {
              title: '进院记录-非销',
              roles: [ROLES_TENANT],
              menuId: 'enter-hospital-data-management-v2-nosales'
            }
          }
        ]
      },
      {
        path: '/small/enter-hospital-management',
        component: { render: (e) => e('router-view') },
        name: 'enter-hospital-management_1111',
        meta: {
          title: '进院管理',
          roles: [ROLES_TENANT],
          menuId: 'enter-hospital-management'
        },
        children: [
          {
            path: 'enter-hospital-data-management',
            component: () =>
              import(
                '@/views/small-backstage/enter-hospital-management/data-management.vue'
              ),
            name: 'enter-hospital-data-management',
            meta: {
              title: '进院记录',
              roles: [ROLES_TENANT],
              menuId: 'enter-hospital-data-management'
            }
          },
          {
            path: 'enter-hospital-data-detail',
            component: () =>
              import(
                '@/views/small-backstage/enter-hospital-management/data-detail.vue'
              ),
            name: 'enter-hospital-data-detail',
            hidden: true,
            meta: {
              title: '进院记录',
              roles: [ROLES_TENANT],
              menuId: 'enter-hospital-data-management',
              activeMenu:
                '/small/enter-hospital-management/enter-hospital-data-management'
            }
          },
          {
            path: 'enter-hospital-type-config',
            component: () =>
              import(
                '@/views/small-backstage/enter-hospital-management/type-config.vue'
              ),
            name: 'enter-hospital-type-config',
            meta: {
              title: '进院类型配置',
              roles: [ROLES_TENANT],
              menuId: 'enter-hospital-type-config'
            }
          },
          {
            path: 'enter-hospital-stage-config',
            component: () =>
              import(
                '@/views/small-backstage/enter-hospital-management/stage-config.vue'
              ),
            name: 'enter-hospital-stage-config',
            hidden: true,
            meta: {
              title: '进院类型配置',
              roles: [ROLES_TENANT],
              menuId: 'enter-hospital-type-config',
              activeMenu:
                '/small/enter-hospital-management/enter-hospital-type-config'
            }
          },
          {
            path: 'enter-hospital-template-config',
            component: () =>
              import(
                '@/views/small-backstage/enter-hospital-management/template-config.vue'
              ),
            name: 'enter-hospital-template-config',
            hidden: true,
            meta: {
              title: '进院类型配置',
              roles: [ROLES_TENANT],
              menuId: 'enter-hospital-type-config',
              activeMenu:
                '/small/enter-hospital-management/enter-hospital-type-config'
            }
          }
        ]
      },
      {
        path: '/daily-manage',
        component: { render: (e) => e('router-view') },
        name: 'daily-manage',
        meta: {
          title: '日报管理',
          roles: [ROLES_TENANT],
          menuId: 'daily-manage'
        },
        children: [
          {
            path: 'daily-config',
            component: () =>
              import('@/views/small-backstage/daily-manage/index'),
            name: 'daily-config',
            meta: {
              title: '日报配置',
              roles: [ROLES_TENANT],
              menuId: 'daily-config'
            }
          }
        ]
      },
      {
        path: '/small/commute-manage',
        component: { render: (e) => e('router-view') },
        name: 'small-commute-manage',
        meta: {
          title: '考勤管理',
          roles: [ROLES_TENANT],
          menuId: 'small-commute-manage'
        },
        children: [
          {
            path: 'commute-manage-record',
            component: () =>
              import('@/views/small-backstage/commute-manage/record.vue'),
            name: 'commute-manage-record',
            meta: {
              title: '考勤记录',
              roles: [ROLES_TENANT],
              menuId: 'commute-manage-record'
            }
          },
          {
            path: 'commute-manage-setting',
            component: () =>
              import('@/views/small-backstage/commute-manage/setting.vue'),
            name: 'commute-manage-setting',
            meta: {
              title: '考勤设置',
              roles: [ROLES_TENANT],
              menuId: 'commute-manage-setting'
            }
          }
        ]
      },
      {
        path: '/small/flow-manage',
        component: { render: (e) => e('router-view') },
        name: 'flow-manage',
        meta: {
          title: '流向管理',
          roles: [ROLES_TENANT],
          menuId: 'flow-manage'
        },
        children: [
          {
            path: 'flow-data-manage',
            component: () => import('@/views/small-backstage/flow-manage-page'),
            name: 'flow-data-manage',
            meta: {
              title: '流向数据管理',
              roles: [ROLES_TENANT],
              menuId: 'flow-data-manage'
            }
          },
          {
            path: 'dealer-inventory-management',
            component: () => import('@/views/small-backstage/flow-manage-page'),
            name: 'dealer-inventory-management',
            meta: {
              title: '经销商进销存管理',
              roles: [ROLES_TENANT],
              menuId: 'dealer-inventory-management'
            }
          },
          {
            path: 'performance-task-indicato-management',
            component: () => import('@/views/small-backstage/flow-manage-page'),
            name: 'performance-task-indicato-management',
            meta: {
              title: '绩效任务指标管理',
              roles: [ROLES_TENANT],
              menuId: 'performance-task-indicato-management'
            }
          }
        ]
      },
      {
        path: '/small/sfe-flow-manage',
        component: { render: (e) => e('router-view') },
        name: 'sfe-flow-manage',
        meta: {
          title: '流向管理',
          roles: [ROLES_TENANT],
          menuId: 'sfe-flow-manage'
        },
        children: [
          {
            path: 'import-flow',
            component: () => import('@/views/small-backstage/import-flow-page'),
            name: 'import-flow',
            meta: {
              title: '原始流向',
              roles: [ROLES_TENANT],
              menuId: 'import-flow'
            }
          },
          {
            path: 'history-flow',
            component: () =>
              import('@/views/small-backstage/history-flow-page'),
            name: 'history-flow',
            meta: {
              title: '历史流向',
              roles: [ROLES_TENANT],
              menuId: 'history-flow'
            }
          },
          {
            path: 'sales-allocation',
            component: () =>
              import('@/views/small-backstage/sales-allocation-page'),
            name: 'sales-allocation',
            meta: {
              title: '销量分配下发',
              roles: [ROLES_TENANT],
              menuId: 'sales-allocation'
            }
          },
          {
            path: 'finalized-sales-volume',
            component: () =>
              import('@/views/small-backstage/finalized-sales-page'),
            name: 'finalized-sales-volume',
            meta: {
              title: '定稿销量',
              roles: [ROLES_TENANT],
              menuId: 'finalized-sales-volume'
            }
          },
          {
            path: 'appeal-management',
            component: () =>
              import('@/views/small-backstage/appeal-management-page'),
            meta: {
              title: '申诉管理',
              roles: [ROLES_TENANT],
              menuId: 'appeal-management'
            },
            children: [
              {
                path: '',
                component: () =>
                  import(
                    '@/views/small-backstage/appeal-management-page/components/home'
                  ),
                name: 'appeal-management-home',
                hidden: true,
                meta: {
                  title: '申诉管理',
                  roles: [ROLES_TENANT],
                  menuId: 'appeal-management'
                }
              },
              {
                path: 'appeal-management-detail',
                hidden: true,
                component: () =>
                  import(
                    '@/views/small-backstage/appeal-management-page/components/detail'
                  ),
                name: 'appeal-management-detail',
                meta: {
                  title: '详情',
                  roles: [ROLES_TENANT],
                  menuId: 'appeal-management',
                  activeMenu: '/small/sfe-flow-manage/appeal-management'
                }
              }
            ]
          },
          {
            path: 'sales-allocation-appeal',
            component: () =>
              import('@/views/small-backstage/sales-allocation-appeal'),
            name: 'sales-allocation-appeal',
            meta: {
              title: '销量分配申诉',
              roles: [ROLES_TENANT],
              menuId: 'sales-allocation-appeal'
            }
          },
          {
            path: 'competitive-sales-volume-management',
            component: () =>
              import('@/views/small-backstage/competitive-management'),
            name: 'competitive-sales-volume-management',
            meta: {
              title: '竞品销量管理',
              roles: [ROLES_TENANT],
              menuId: 'competitive-sales-volume-management'
            }
          },
          {
            path: 'flow-tracking',
            component: () => import('@/views/small-backstage/flow-tracking'),
            name: 'flow-tracking',
            meta: {
              title: '流向查询',
              // roles: [ROLES_TENANT],
              menuId: 'flow-tracking'
            }
          }
        ]
      },
      {
        path: '/small/work-plan',
        component: { render: (e) => e('router-view') },
        name: 'work-plan',
        meta: {
          title: '工作计划',
          roles: [ROLES_TENANT],
          menuId: 'work-plan'
        },
        children: [
          {
            path: 'work-log',
            component: () =>
              import('@/views/small-backstage/work-plan/index.vue'),
            name: 'work-log',
            meta: {
              title: '工作计划记录',
              roles: [ROLES_TENANT],
              menuId: 'work-log'
            }
          },
          {
            path: 'work-detail',
            component: () =>
              import('@/views/small-backstage/work-plan/detail.vue'),
            name: 'work-detail',
            hidden: true,
            meta: {
              title: '工作计划详情',
              roles: [ROLES_TENANT],
              menuId: 'work-log',
              activeMenu: '/small/work-plan/work-log'
            }
          },
          {
            path: 'work-config',
            component: () =>
              import('@/views/small-backstage/work-plan/config.vue'),
            name: 'work-config',
            meta: {
              title: '工作计划配置',
              roles: [ROLES_TENANT],
              menuId: 'work-config'
            }
          }
        ]
      },
      {
        path: '/small/metrics-manage',
        component: { render: (e) => e('router-view') },
        name: 'metrics-manage',
        meta: {
          title: '指标管理',
          roles: [ROLES_TENANT],
          menuId: 'metrics-manage'
        },
        children: [
          {
            path: 'metrics-resolve',
            component: { render: (e) => e('router-view') },
            name: 'metrics-resolve',
            meta: {
              title: '指标分解',
              roles: [ROLES_TENANT],
              menuId: 'metrics-resolve'
            },
            children: [
              {
                path: 'hospital-product-metrics',
                component: () =>
                  import('@/views/small-backstage/hospital-product-metrics'),
                name: 'hospital-product-metrics',
                meta: {
                  title: '医院产品指标',
                  roles: [ROLES_TENANT],
                  menuId: 'hospital-product-metrics'
                }
              },
              {
                path: 'metrics-post-matching',
                component: () =>
                  import('@/views/small-backstage/metrics-post-matching'),
                name: 'metrics-post-matching',
                meta: {
                  title: '指标岗位匹配',
                  roles: [ROLES_TENANT],
                  menuId: 'metrics-post-matching'
                }
              },
              {
                path: 'hospital-product-adjust',
                component: () =>
                  import('@/views/small-backstage/hospital-product-adjust'),
                name: 'hospital-product-adjust',
                meta: {
                  title: '医院产品指标调整',
                  roles: [ROLES_TENANT],
                  menuId: 'hospital-product-adjust'
                }
              },
              {
                path: 'metrics-position-adjust',
                component: () =>
                  import('@/views/small-backstage/metrics-position-adjust'),
                name: 'metrics-position-adjust',
                meta: {
                  title: '指标岗位调整',
                  roles: [ROLES_TENANT],
                  menuId: 'metrics-position-adjust'
                }
              }
            ]
          },
          {
            path: 'metrics-import',
            component: () => import('@/views/small-backstage/metrics-import'),
            name: 'metrics-import',
            meta: {
              title: '指标导入',
              roles: [ROLES_TENANT],
              menuId: 'metrics-import'
            }
          },
          {
            path: 'metrics-query',
            component: () => import('@/views/small-backstage/metrics-query'),
            name: 'metrics-query',
            meta: {
              title: '指标查询',
              roles: [ROLES_TENANT],
              menuId: 'metrics-query'
            }
          },
          {
            path: 'metrics-adjust',
            component: () => import('@/views/small-backstage/metrics-adjust'),
            name: 'metrics-adjust',
            meta: {
              title: '指标调整',
              roles: [ROLES_TENANT],
              menuId: 'metrics-adjust'
            }
          }
        ]
      },
      {
        path: '/small/flowDataManagement',
        component: { render: (e) => e('router-view') },
        name: 'small-flowDataManagement',
        meta: {
          title: '流向数据管理',
          roles: [ROLES_TENANT],
          menuId: 'small-flowDataManagement'
        },
        children: [
          {
            path: 'daily-data-management',
            component: () =>
              import('@/views/small-backstage/daily-data-management'),
            name: 'daily-data-management',
            meta: {
              title: '日流向数据管理',
              roles: [ROLES_TENANT],
              menuId: 'daily-data-management'
            }
          },
          {
            path: 'monthly-data-management',
            component: () =>
              import('@/views/small-backstage/monthly-data-management'),
            name: 'monthly-data-management',
            meta: {
              title: '月流向数据管理',
              roles: [ROLES_TENANT],
              menuId: 'monthly-data-management'
            }
          },
          {
            path: 'data-task-inquiry',
            component: () =>
              import('@/views/small-backstage/data-task-inquiry'),
            name: 'data-task-inquiry',
            meta: {
              title: '数据任务查询',
              roles: [ROLES_TENANT],
              menuId: 'data-task-inquiry'
            }
          }
        ]
      },
      {
        path: '/small/sales-volume-estimate',
        component: { render: (e) => e('router-view') },
        name: 'sales-volume-estimate',
        meta: {
          title: '销量预估',
          roles: [ROLES_TENANT],
          menuId: 'sales-volume-estimate'
        },
        children: [
          {
            path: 'forecast-write',
            component: () => import('@/views/small-backstage/forecast-write'),
            name: 'forecast-write',
            meta: {
              title: '预估填写',
              roles: [ROLES_TENANT],
              menuId: 'forecast-write'
            }
          },
          {
            path: 'forecast-query',
            component: () => import('@/views/small-backstage/forecast-query'),
            name: 'forecast-query',
            meta: {
              title: '预估查询',
              roles: [ROLES_TENANT],
              menuId: 'forecast-query'
            }
          },
          {
            path: 'forecast-reach-analyse',
            component: () =>
              import('@/views/small-backstage/forecast-reach-analyse'),
            name: 'forecast-reach-analyse',
            meta: {
              title: '预估达成分析',
              roles: [ROLES_TENANT],
              menuId: 'forecast-reach-analyse'
            }
          },
          {
            path: 'estimate-approval-summary',
            component: () =>
              import('@/views/small-backstage/estimate-approval-summary'),
            name: 'estimate-approval-summary',
            meta: {
              title: '预估审批汇总',
              roles: [ROLES_TENANT],
              menuId: 'estimate-approval-summary'
            }
          }
        ]
      },
      {
        path: '/small/sales-volume-query',
        component: { render: (e) => e('router-view') },
        name: 'sales-volume-query',
        meta: {
          title: '销量查询',
          roles: [ROLES_TENANT],
          menuId: 'sales-volume-query'
        },
        children: [
          {
            path: 'day-sales-volume-query',
            component: () =>
              import('@/views/small-backstage/day-sales-volume-query'),
            name: 'day-sales-volume-query',
            meta: {
              title: '日销量查询',
              roles: [ROLES_TENANT],
              menuId: 'day-sales-volume-query',
              keepAlive: true
            }
          },
          {
            path: 'sales-volume-query-detail',
            component: () =>
              import('@/views/small-backstage/sales-volume-query-detail'),
            name: 'sales-volume-query-detail',
            hidden: true,
            meta: {
              title: '流向明细',
              roles: [ROLES_TENANT],
              menuId: 'day-sales-volume-query',
              activeMenu: '/small/sales-volume-query/day-sales-volume-query'
            }
          },
          {
            path: 'month-sales-volume-query',
            component: () =>
              import('@/views/small-backstage/month-sales-volume-query'),
            name: 'month-sales-volume-query',
            meta: {
              title: '月销量查询',
              roles: [ROLES_TENANT],
              menuId: 'month-sales-volume-query',
              keepAlive: true
            }
          },
          {
            path: 'sales-volume-query-detail2',
            component: () =>
              import('@/views/small-backstage/sales-volume-query-detail'),
            name: 'sales-volume-query-detail2',
            hidden: true,
            meta: {
              title: '流向明细',
              roles: [ROLES_TENANT],
              menuId: 'month-sales-volume-query',
              activeMenu: '/small/sales-volume-query/month-sales-volume-query'
            }
          }
        ]
      },
      {
        path: '/small/sales-volume-appeal',
        component: { render: (e) => e('router-view') },
        name: 'sales-volume-appeal',
        meta: {
          title: '销量申诉',
          roles: [ROLES_TENANT],
          menuId: 'sales-volume-appeal'
        },
        children: [
          {
            path: 'terminal-month-sales-volume',
            component: () =>
              import('@/views/small-backstage/terminal-month-sales-volume'),
            name: 'terminal-month-sales-volume',
            meta: {
              title: '机构月销量查询',
              roles: [ROLES_TENANT],
              menuId: 'terminal-month-sales-volume',
              keepAlive: true
            }
          },
          {
            path: 'sales-appeal',
            component: () =>
              import(
                '@/views/small-backstage/terminal-month-sales-volume/sales-appeal'
              ),
            name: 'sales-appeal',
            hidden: true,
            meta: {
              title: '销量申诉',
              roles: [ROLES_TENANT],
              menuId: 'terminal-month-sales-volume',
              activeMenu:
                '/small/sales-volume-appeal/terminal-month-sales-volume'
            }
          },

          {
            path: 'complaint-inquiry',
            component: () =>
              import('@/views/small-backstage/complaint-inquiry'),
            name: 'complaint-inquiry',
            meta: {
              title: '申诉单查询',
              roles: [ROLES_TENANT],
              menuId: 'complaint-inquiry',
              keepAlive: true
            }
          },
          {
            path: 'complaint-inquiry-detail',
            component: () =>
              import(
                '@/views/small-backstage/tenant-after-verification-detail/my-approval-detail'
              ),
            name: 'complaint-inquiry-detail',
            hidden: true,
            meta: {
              title: '申诉单详情',
              roles: [ROLES_TENANT],
              menuId: 'complaint-inquiry',
              activeMenu: '/small/sales-volume-appeal/complaint-inquiry'
            }
          }
        ]
      },
      {
        path: '/small/inventory-manage',
        component: { render: (e) => e('router-view') },
        name: 'inventory-manage',
        meta: {
          title: '库存管理',
          roles: [ROLES_TENANT],
          menuId: 'inventory-manage'
        },
        children: [
          {
            path: 'inventory-config',
            component: () =>
              import(
                '@/views/small-backstage/inventory-manage/inventory-config.vue'
              ),
            name: 'inventory-config',
            meta: {
              title: '库存配置',
              roles: [ROLES_TENANT],
              menuId: 'inventory-config'
            }
          },
          {
            path: 'real-time-inventory',
            component: () =>
              import(
                '@/views/small-backstage/inventory-manage/real-time-inventory.vue'
              ),
            name: 'real-time-inventory',
            meta: {
              title: '实时库存',
              roles: [ROLES_TENANT],
              menuId: 'real-time-inventory',
              keepAlive: true
            }
          },
          {
            path: 'real-time-inventory-detail',
            component: () =>
              import(
                '@/views/small-backstage/inventory-manage/real-time-inventory-detail.vue'
              ),
            hidden: true,
            name: 'real-time-inventory-detail',
            meta: {
              title: '实时库存详情',
              roles: [ROLES_TENANT],
              menuId: 'real-time-inventory'
            }
          },

          {
            path: 'stock-report-month',
            component: { render: (e) => e('router-view') },
            name: 'stock_report_month',
            meta: {
              title: '月库存管理',
              roles: [ROLES_TENANT],
              menuId: 'stock_report_month'
            },
            children: [
              {
                path: 'monthly-inventory-report',
                component: () =>
                  import(
                    '@/views/small-backstage/inventory-manage/monthly-inventory-report/monthly-inventory-report.vue'
                  ),
                name: 'monthly-inventory-report',
                meta: {
                  roles: [ROLES_TENANT],
                  title: '月库存上报',
                  menuId: 'stock_report_month_report',
                  keepAlive: true
                }
              },
              {
                path: 'monthly-inventory-report-summary',
                component: () =>
                  import(
                    '@/views/small-backstage/inventory-manage/monthly-inventory-report/monthly-inventory-report-summary.vue'
                  ),
                name: 'monthly-inventory-report-summary',
                hidden: true,
                meta: {
                  roles: [ROLES_TENANT],
                  title: '月库存上报明细',
                  menuId: 'stock_report_month_report',
                  activeMenu:
                    '/small/inventory-manage/stock-report-month/monthly-inventory-report'
                }
              },
              {
                path: 'monthly-inventory-report-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/inventory-manage/monthly-inventory-report/monthly-inventory-report-detail.vue'
                  ),
                name: 'monthly-inventory-report-detail',
                hidden: true,
                meta: {
                  roles: [ROLES_TENANT],
                  title: '月库存详情',
                  menuId: 'stock_report_month_report',
                  activeMenu:
                    '/small/inventory-manage/stock-report-month/monthly-inventory-report'
                }
              },
              {
                path: 'stock-report-month-approval',
                component: () =>
                  import(
                    '@/views/small-backstage/inventory-report-month/stock-report-month-approve/index.vue'
                  ),
                name: 'stock-report-month-approval',
                meta: {
                  title: '月库存审批',
                  roles: [ROLES_TENANT],
                  menuId: 'stock_report_month_approval',
                  keepAlive: true
                }
              },
              {
                path: 'monthly-stock-review-details',
                component: () =>
                  import(
                    '@/views/small-backstage/inventory-report-month/monthly-stock-review-details/index.vue'
                  ),
                name: 'monthly-stock-review-details',
                hidden: true,
                meta: {
                  roles: [ROLES_TENANT],
                  title: '月库存审批',
                  menuId: 'stock_report_month_approval'
                }
              },
              {
                path: 'stock-report-month-query',
                component: () =>
                  import(
                    '@/views/small-backstage/inventory-report-month/stock-report-month-manage/index.vue'
                  ),
                name: 'stock_report_month_query',
                meta: {
                  title: '月库存查询',
                  roles: [ROLES_TENANT],
                  menuId: 'stock_report_month_query',
                  keepAlive: true
                }
              }
            ]
          },

          {
            path: 'inventory_report_near_expiry',
            component: { render: (e) => e('router-view') },
            name: 'inventory_report_near_expiry',
            meta: {
              title: '近效期库存上报',
              roles: [ROLES_TENANT],
              menuId: 'inventory_report_near_expiry'
            },
            children: [
              {
                path: 'stock_report_near_expiry_report',
                component: () =>
                  import(
                    '@/views/small-backstage/inventory-report-near/report.vue'
                  ),
                name: 'stock_report_near_expiry_report',
                meta: {
                  title: '近效期库存上报',
                  roles: [ROLES_TENANT],
                  menuId: 'stock_report_near_expiry_report'
                }
              },
              {
                path: 'stock_report_near_expiry_report_details',
                component: () =>
                  import(
                    '@/views/small-backstage/inventory-report-near/report-details.vue'
                  ),
                name: 'stock_report_near_expiry_report_details',
                meta: {
                  title: '近效期库存上报明细',
                  roles: [ROLES_TENANT],
                  menuId: 'stock_report_near_expiry_report',
                  activeMenu:
                    '/small/inventory-manage/inventory_report_near_expiry/stock_report_near_expiry_report'
                },
                hidden: true
              },
              {
                path: 'stock_report_near_expiry_report-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/inventory-report-near/manage-detail.vue'
                  ),
                hidden: true,
                name: 'stock_report_near_expiry_report-detail',
                meta: {
                  title: '近效期库存上报详情',
                  roles: [ROLES_TENANT],
                  menuId: 'stock_report_near_expiry_report',
                  activeMenu:
                    '/small/inventory-manage/inventory_report_near_expiry/stock_report_near_expiry_report'
                }
              },
              {
                path: 'stock_report_near_expiry_approve',
                component: () =>
                  import(
                    '@/views/small-backstage/inventory-report-near/approve.vue'
                  ),
                name: 'stock_report_near_expiry_approve',
                meta: {
                  title: '近效期库存审批',
                  roles: [ROLES_TENANT],
                  menuId: 'stock_report_near_expiry_approve'
                }
              },
              {
                path: 'stock_report_near_expiry_approve_details',
                component: () =>
                  import(
                    '@/views/small-backstage/inventory-report-near/report-details.vue'
                  ),
                name: 'stock_report_near_expiry_approve_details',
                meta: {
                  title: '近效期库存审批明细',
                  roles: [ROLES_TENANT],
                  menuId: 'stock_report_near_expiry_approve',
                  activeMenu:
                    '/small/inventory-manage/inventory_report_near_expiry/stock_report_near_expiry_approve'
                },
                hidden: true
              },
              {
                path: 'stock_report_near_expiry_approve-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/inventory-report-near/manage-detail.vue'
                  ),
                hidden: true,
                name: 'stock_report_near_expiry_approve-detail',
                meta: {
                  title: '近效期库存审批详情',
                  roles: [ROLES_TENANT],
                  menuId: 'stock_report_near_expiry_approve',
                  activeMenu:
                    '/small/inventory-manage/inventory_report_near_expiry/stock_report_near_expiry_approve'
                }
              },
              {
                path: 'stock_report_near_expiry_manage',
                component: () =>
                  import(
                    '@/views/small-backstage/inventory-report-near/manage.vue'
                  ),
                name: 'stock_report_near_expiry_manage',
                meta: {
                  title: '近效期库存查询',
                  roles: [ROLES_TENANT],
                  menuId: 'stock_report_near_expiry_manage'
                }
              },
              {
                path: 'stock_report_near_expiry_manage-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/inventory-report-near/manage-detail.vue'
                  ),
                hidden: true,
                name: 'stock_report_near_expiry_manage-detail',
                meta: {
                  title: '近效期库存详情',
                  roles: [ROLES_TENANT],
                  menuId: 'stock_report_near_expiry_manage',
                  activeMenu:
                    '/small/inventory-manage/inventory_report_near_expiry/stock_report_near_expiry_manage'
                }
              }
            ]
          },
          {
            path: 'stock_report_batch_number',
            component: { render: (e) => e('router-view') },
            name: 'stock_report_batch_number',
            children: [
              {
                path: 'stock_report_batch_number_report',
                component: () =>
                  import(
                    '@/views/small-backstage/inventory-manage/batch-number-inventory/index.vue'
                  ),
                name: 'stock_report_batch_number_report',
                meta: {
                  title: '批号库存上报',
                  roles: [ROLES_TENANT],
                  menuId: 'stock_report_batch_number'
                }
              },
              {
                path: 'stock_report_batch_number_report_detail',
                component: () =>
                  import(
                    '@/views/small-backstage/inventory-manage/batch-number-inventory/detail.vue'
                  ),
                hidden: true,
                name: 'stock_report_batch_number_report_detail',
                meta: {
                  title: '批号库存详情',
                  roles: [ROLES_TENANT],
                  menuId: 'stock_report_batch_number'
                }
              },
              {
                path: 'stock_report_batch_number_manage',
                component: () =>
                  import(
                    '@/views/small-backstage/inventory-manage/batch-number-inventory-manage/index.vue'
                  ),
                name: 'stock_report_batch_number_manage',
                meta: {
                  title: '批号库存查询',
                  roles: [ROLES_TENANT],
                  menuId: 'stock_report_batch_number'
                }
              }
            ],
            meta: {
              title: '批号库存上报',
              roles: [ROLES_TENANT],
              menuId: 'real-time-inventory',
              keepAlive: true
            }
          }
        ]
      },
      {
        path: '/small/order-menu-management',
        component: { render: (e) => e('router-view') },
        name: 'order-menu-management',
        meta: {
          title: '订单管理',
          roles: [ROLES_TENANT],
          menuId: 'order-menu-management'
        },
        children: [
          {
            path: 'order-manage',
            component: () =>
              import(
                '@/views/small-backstage/order-management/order-manage/index.vue'
              ),
            name: 'order-manage',
            meta: {
              title: '订单管理',
              roles: [ROLES_TENANT],
              menuId: 'order-manage'
            }
          },
          {
            name: 'order-manage-details',
            path: 'order-manage-details',
            hidden: true,
            meta: {
              title: '订单管理详情',
              roles: [ROLES_TENANT],
              menuId: 'order-manage',
              activeMenu: '/small/order-menu-management/order-manage'
            },
            component: () =>
              import(
                '@/views/small-backstage/order-management/order-manage/details.vue'
              )
          }
        ]
      },
      {
        path: '/small/associationManagement',
        component: () =>
          import('@/views/small-backstage/associationManagement'),
        name: 'small-associationManagement',
        meta: {
          title: '关联管理',
          roles: [ROLES_TENANT],
          menuId: 'dealer_hospital_pharmacy_relation'
        }
      },
      {
        path: '/small/purchaseSaveManagement',
        component: { render: (e) => e('router-view') },
        name: 'small-purchaseSaveManagement',
        meta: {
          title: '进销存管理',
          roles: [ROLES_TENANT],
          menuId: 'permission_inventory_management'
        },
        children: [
          {
            path: 'permission_pharmacy_inventory_detail',
            component: () =>
              import(
                '@/views/small-backstage/permission-pharmacy/permission_pharmacy_inventory_detail'
              ),
            name: 'permission_pharmacy_inventory_detail',
            meta: {
              title: '药店进销存明细查询',
              roles: [ROLES_TENANT],
              menuId: 'permission_pharmacy_inventory_detail'
            }
          },
          {
            path: 'permission_pharmacy_inventory_summary',
            component: () =>
              import(
                '@/views/small-backstage/permission-pharmacy/permission_pharmacy_inventory_summary'
              ),
            name: 'permission_pharmacy_inventory_summary',
            meta: {
              title: '药店进销存汇总查询',
              roles: [ROLES_TENANT],
              menuId: 'permission_pharmacy_inventory_summary'
            }
          },
          {
            path: 'permission_dealer_inventory_detail',
            component: () =>
              import(
                '@/views/small-backstage/permission-pharmacy/permission_dealer_inventory_detail'
              ),
            name: 'permission_dealer_inventory_detail',
            meta: {
              title: '经销商数据明细查询',
              roles: [ROLES_TENANT],
              menuId: 'permission_dealer_inventory_detail'
            }
          },
          {
            path: 'permission_dealer_inventory_summary',
            component: () =>
              import(
                '@/views/small-backstage/permission-pharmacy/permission_dealer_inventory_summary'
              ),
            name: 'permission_dealer_inventory_summary',
            meta: {
              title: '经销商数据汇总查询',
              roles: [ROLES_TENANT],
              menuId: 'permission_dealer_inventory_summary'
            }
          },
          {
            path: 'permission_sales_prediction_summary',
            component: () =>
              import(
                '@/views/small-backstage/permission-pharmacy/permission_sales_prediction_summary'
              ),
            name: 'permission_sales_prediction_summary',
            meta: {
              title: '销量预估汇总查询',
              roles: [ROLES_TENANT],
              menuId: 'permission_sales_prediction_summary'
            }
          },
          // 期初库存导入
          {
            path: 'initial-inventory-import',
            component: () =>
              import(
                '@/views/small-backstage/permission-pharmacy/initial-inventory-import'
              ),
            name: 'initial-inventory-import',
            meta: {
              title: '期初库存导入',
              roles: [ROLES_TENANT],
              menuId: 'initial-inventory-import'
            }
          }
        ]
      },
      // [AI-GEN]
      {
        path: '/small/bonus-management',
        component: { render: (e) => e('router-view') },
        name: 'bonus-management',
        meta: {
          title: '奖金管理',
          roles: [ROLES_TENANT],
          menuId: 'bonus-management'
        },
        children: [
          {
            path: 'award-setting-management',
            component: () =>
              import(
                '@/views/small-backstage/bonus-management/award-setting-management'
              ),
            name: 'award-setting-management',
            meta: {
              title: '奖项设置管理',
              roles: [ROLES_TENANT],
              menuId: 'award-setting-management'
            }
          },
          {
            path: 'bonus-dimension-management',
            component: () =>
              import(
                '@/views/small-backstage/bonus-management/bonus-dimension-management'
              ),
            name: 'bonus-dimension-management',
            meta: {
              title: '奖金维度管理',
              roles: [ROLES_TENANT],
              menuId: 'bonus-dimension-management'
            }
          },
          {
            path: 'bonus-template-management',
            component: () =>
              import(
                '@/views/small-backstage/bonus-management/bonus-template-management'
              ),
            name: 'bonus-template-management',
            meta: {
              title: '奖金模板管理',
              roles: [ROLES_TENANT],
              menuId: 'bonus-template-management'
            }
          },
          {
            path: 'configure-bonus-template',
            hidden: true,
            component: () =>
              import(
                '@/views/small-backstage/bonus-management/bonus-template-management/configure-bonus-template'
              ),
            name: 'configure-bonus-template',
            meta: {
              hidden: true,
              title: '配置模板',
              roles: [ROLES_TENANT],
              menuId: 'bonus-template-management',
              activeMenu: '/small/bonus-management/bonus-template-management'
            }
          },
          {
            path: 'bonus-inquiry',
            component: () =>
              import('@/views/small-backstage/bonus-management/bonus-inquiry'),
            name: 'bonus-inquiry',
            meta: {
              title: '奖金查询',
              roles: [ROLES_TENANT],
              menuId: 'bonus-inquiry'
            }
          },
          {
            path: 'bonus-appeal',
            component: () =>
              import('@/views/small-backstage/bonus-management/bonus-appeal'),
            name: 'bonus-appeal',
            meta: {
              title: '奖金申诉',
              roles: [ROLES_TENANT],
              menuId: 'bonus-appeal'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/small/Y-Service',
    component: Layout,
    name: 'small-Y-Service',
    meta: {
      title: 'Y-Service',
      icon: 'Y-Service',
      roles: [ROLES_TENANT],
      menuId: 'small-Y-Service'
    },
    children: [
      {
        path: '/small/verification_management',
        component: { render: (e) => e('router-view') },
        name: 'smallVerificationManagement',
        meta: {
          title: '核销管理',
          roles: [ROLES_TENANT],
          menuId: 'verification_management'
        },
        children: [
          {
            path: 'verification_business_management',
            component: () =>
              import(
                '@/views/small-backstage/verification-management/verification-business-management'
              ),
            name: 'verification_business_management',
            meta: {
              title: '核销业务管理',
              roles: [ROLES_TENANT],
              menuId: 'verification_business_management'
            }
          },
          {
            path: 'verification_business_management_template',
            component: () =>
              import('@/views/small-backstage/tenant-after-verification/visit'),
            name: 'verification_business_management_template',
            hidden: true,
            meta: {
              title: '设置字段',
              roles: [ROLES_TENANT],
              menuId: 'verification_business_management_template',
              activeMenu:
                '/small/verification_management/verification_business_management'
            }
          },
          {
            path: 'verification_business_list',
            component: () =>
              import(
                '@/views/small-backstage/verification-management/verification-business-list'
              ),
            name: 'verification_business_list',
            meta: {
              title: '核销业务列表',
              roles: [ROLES_TENANT],
              menuId: 'verification_business_list'
            }
          },
          {
            path: 'verification_business_list_detail',
            component: () =>
              import(
                '@/views/small-backstage/verification-management/verification-business-list/detail'
              ),
            name: 'verification_business_list_detail',
            hidden: true,
            meta: {
              title: '核销业务详情',
              roles: [ROLES_TENANT],
              menuId: 'verification_business_list_detail',
              activeMenu:
                '/small/verification_management/verification_business_list'
            }
          }
        ]
      },
      {
        path: '/small/time-set',
        component: { render: (e) => e('router-view') },
        name: 'smallTimeSet',
        meta: {
          title: '时间窗配置',
          roles: [ROLES_TENANT],
          menuId: 'smallTimeSet'
        },
        children: [
          {
            path: 'time-window-set',
            component: () =>
              import('@/views/small-backstage/time-set/time-window-set'),
            name: 'time-window-set',
            meta: {
              title: '时间窗配置',
              roles: [ROLES_TENANT],
              menuId: 'time-window-set'
            }
          },
          {
            path: 'time-window-config',
            component: () =>
              import('@/views/small-backstage/time-set/time-window-config'),
            name: 'time-window-config',
            meta: {
              title: '财年账期',
              roles: [ROLES_TENANT],
              menuId: 'time-window-config'
            }
          }
        ]
      },
      {
        path: '/small/sfe-config',
        component: { render: (e) => e('router-view') },
        name: 'smallSFEConfig',
        meta: {
          title: 'SFE配置',
          roles: [ROLES_TENANT],
          menuId: 'smallSFEConfig'
        },
        children: [
          {
            path: 'attachment-config',
            component: () =>
              import('@/views/small-backstage/sfe-config/attachment-config'),
            name: 'attachment-config',
            meta: {
              title: '挂靠配置',
              roles: [ROLES_TENANT],
              menuId: 'attachment-config'
            }
          },
          {
            path: 'metrics-config',
            component: () =>
              import('@/views/small-backstage/sfe-config/metrics-config'),
            name: 'metrics-config',
            meta: {
              title: '指标配置',
              roles: [ROLES_TENANT],
              menuId: 'metrics-config'
            }
          },
          {
            path: 'estimation-config',
            component: () =>
              import('@/views/small-backstage/sfe-config/estimation-config'),
            name: 'estimation-config',
            meta: {
              title: '预估配置',
              roles: [ROLES_TENANT],
              menuId: 'estimation-config'
            }
          },
          {
            path: 'appeal-config',
            component: () =>
              import('@/views/small-backstage/sfe-config/appeal-config'),
            name: 'appeal-config',
            meta: {
              title: '申诉配置',
              roles: [ROLES_TENANT],
              menuId: 'appeal-config'
            }
          },
          {
            path: 'bonus-config',
            component: () =>
              import('@/views/small-backstage/sfe-config/bonus-config'),
            name: 'bonus-config',
            meta: {
              title: '奖金配置',
              roles: [ROLES_TENANT],
              menuId: 'bonus-config'
            }
          }
        ]
      },

      {
        path: '/small/userCenter',
        component: { render: (e) => e('router-view') },
        name: 'small-userCenter',
        meta: {
          title: '用户中心',
          roles: [ROLES_TENANT],
          menuId: 'small-userCenter'
        },
        children: [
          {
            path: 'tenant-proxy-approval',
            component: () =>
              import(
                '@/views/small-backstage/tenant-after-verification/proxy-approva'
              ),
            name: 'tenant-proxy-approval',
            meta: {
              title: '代理审批',
              roles: [ROLES_TENANT],
              menuId: 'agent-manage-list'
            }
          },
          {
            path: 'accountBlack',
            component: () =>
              import('@/views/small-backstage/account-blacklist/index.vue'),
            name: 'accountBlack',
            meta: {
              title: '黑名单管理',
              roles: [ROLES_TENANT],
              menuId: 'account-blacklist'
            }
          },
          {
            path: 'tenant-user-conversion/user-list',
            component: () =>
              import(
                '@/views/small-backstage/tenant-user-conversion/user-list.vue'
              ),
            name: 'user-list',
            meta: {
              title: '微信用户管理',
              roles: [ROLES_TENANT],
              menuId: 'user-list'
            }
          },
          {
            path: 'informed-consent-staff',
            component: () =>
              import(
                '@/views/small-backstage/tenant-user-center/informedConsentStaff/index'
              ),
            name: 'informed-consent-staff',
            meta: {
              title: '企业承诺书',
              roles: [ROLES_TENANT],
              menuId: 'informed-consent-staff'
            }
          }
        ]
      },
      {
        path: 'questionnaire-management',
        component: { render: (e) => e('router-view') },
        name: 'questionnaire-management',
        meta: {
          title: '问卷管理',
          roles: [ROLES_TENANT],
          menuId: 'questionnaire-management'
        },
        children: [
          {
            path: 'questionnaireManagementPortal',
            component: () =>
              import('@/views/small-backstage/questionnaire-management'),
            name: 'questionnaireManagementPortal',
            meta: {
              title: '问卷管理',
              menuId: 'questionnaireManagementPortal'
            }
          },
          {
            path: 'recycle-questionnaire',
            hidden: true,
            component: () =>
              import(
                '@/views/small-backstage/questionnaire-management/recycle-questionnaire'
              ),
            name: 'recycle-questionnaire',
            meta: {
              title: '回收站',
              menuId: 'questionnaireManagementPortal',
              activeMenu:
                '/small/Y-Service/questionnaire-management/questionnaireManagementPortal'
            }
          },
          {
            path: 'create-questionnaire',
            hidden: true,
            component: () =>
              import(
                '@/views/small-backstage/questionnaire-management/create-questionnaire'
              ),
            name: 'create-questionnaire',
            meta: {
              title: '创建问卷',
              menuId: 'questionnaireManagementPortal',
              activeMenu:
                '/small/Y-Service/questionnaire-management/questionnaireManagementPortal'
            }
          },
          {
            path: 'data-qustatistics',
            hidden: true,
            component: () =>
              import(
                '@/views/small-backstage/questionnaire-management/data-statistics'
              ),
            name: 'data-qustatistics',
            meta: {
              title: '数据统计',
              menuId: 'questionnaireManagementPortal',
              activeMenu:
                '/small/Y-Service/questionnaire-management/questionnaireManagementPortal'
            }
          },
          {
            path: 'test-paper-details',
            hidden: true,
            component: () =>
              import(
                '@/views/small-backstage/questionnaire-management/test-paper-details'
              ),
            name: 'test-paper-details',
            meta: {
              title: '问卷详情',
              menuId: 'questionnaireManagementPortal',
              activeMenu:
                '/small/Y-Service/questionnaire-management/questionnaireManagementPortal'
            }
          },
          {
            path: 'questionnaireRecords',
            component: () =>
              import(
                '@/views/small-backstage/questionnaire-management/records'
              ),
            name: 'questionnaireRecords',
            meta: {
              title: '答卷记录',
              menuId: 'questionnaireRecords'
            }
          },
          {
            path: 'questionnaireClassify',
            component: () =>
              import(
                '@/views/small-backstage/questionnaire-management/classify'
              ),
            name: 'questionnaireClassify',
            meta: {
              title: '问卷分类',
              menuId: 'questionnaireClassify'
            }
          },
          {
            path: 'questionnaireSupplement',
            component: () =>
              import(
                '@/views/small-backstage/questionnaire-management/questionnaire-supplement'
              ),
            hidden: true,
            name: 'questionnaireSupplement',
            meta: {
              title: '问卷补录',
              menuId: 'questionnaire-management'
            }
          },
          {
            path: 'preview-questionnaire',
            component: () =>
              import(
                '@/views/small-backstage/questionnaire-management/preview-questionnaire'
              ),
            hidden: true,
            name: 'preview-questionnaire',
            meta: {
              title: '问卷预览',
              menuId: 'questionnaire-management'
            }
          }
        ]
      },
      {
        path: '/small/tag-management',
        component: {
          render: (e) => e('router-view')
        },
        name: 'tag-management',
        meta: {
          title: '标签管理',
          roles: [ROLES_TENANT],
          menuId: 'tag-management'
        },
        children: [
          {
            path: 'tagTypeManage',
            component: () =>
              import(
                '@/views/small-backstage/tag-management/tagTypeManage.vue'
              ),
            name: 'tagTypeManage',
            meta: {
              title: '标签分类管理',
              roles: [ROLES_TENANT],
              menuId: 'tagTypeManage'
            }
          },
          {
            path: 'tagList',
            component: () =>
              import('@/views/small-backstage/tag-management/tagList.vue'),
            name: 'tagList',
            meta: {
              title: '标签列表',
              roles: [ROLES_TENANT],
              menuId: 'tagList'
            }
          }
        ]
      },
      {
        path: '/small/noticeManage',
        component: {
          render: (e) => e('router-view')
        },
        name: 'small-noticeManage',
        meta: {
          title: '公告管理',
          roles: [ROLES_TENANT],
          menuId: 'small-noticeManage'
        },
        children: [
          {
            path: 'list',
            component: () =>
              import('@/views/small-backstage/notice-manage/list.vue'),
            name: 'notice-list',
            meta: {
              title: '公告列表',
              roles: [ROLES_TENANT],
              menuId: 'notice-list'
            }
          },
          {
            path: 'sender',
            component: () =>
              import('@/views/small-backstage/notice-manage/sender.vue'),
            name: 'notice-sender',
            hidden: true,
            meta: {
              title: '发送对象',
              roles: [ROLES_TENANT],
              menuId: 'notice-list',
              activeMenu: '/small/noticeManage/list'
            }
          },
          {
            path: 'detail',
            component: () =>
              import('@/views/small-backstage/notice-manage/detail.vue'),
            name: 'notice-detail',
            hidden: true,
            meta: {
              title: '公告详情',
              roles: [ROLES_TENANT],
              menuId: 'notice-list',
              activeMenu: '/small/noticeManage/list'
            }
          }
        ]
      },
      {
        path: 'company-pointsMall',
        component: { render: (e) => e('router-view') },
        name: 'company-pointsMall',
        meta: {
          title: '企业积分商城',
          roles: [ROLES_TENANT],
          menuId: 'company-pointsMall'
        },
        children: [
          {
            path: 'company-categoryManagement',
            component: () =>
              import(
                '@/views/small-backstage/points-mall/category-management/list.vue'
              ),
            name: 'company-categoryManagement',
            meta: {
              title: '品类管理',
              menuId: 'company-categoryManagement',
              type: 'COMPANY'
            }
          },
          {
            path: 'company-goodsManagement',
            component: () =>
              import(
                '@/views/small-backstage/points-mall/goods-management/list.vue'
              ),
            name: 'company-goodsManagement',
            meta: {
              title: '商品管理',
              menuId: 'company-goodsManagement',
              type: 'COMPANY'
            }
          },
          {
            path: 'company-addCommodity',
            component: () =>
              import(
                '@/views/small-backstage/points-mall/goods-management/addCommodity.vue'
              ),
            hidden: true,
            name: 'company-addCommodity',
            meta: {
              title: '添加商品',
              menuId: 'company-goodsManagement',
              activeMenu:
                '/small/Y-Service/company-pointsMall/company-goodsManagement',
              type: 'COMPANY'
            }
          },
          {
            path: 'company-addCommodity-edit',
            component: () =>
              import(
                '@/views/small-backstage/points-mall/goods-management/addCommodity.vue'
              ),
            hidden: true,
            name: 'company-addCommodity-edit',
            meta: {
              title: '编辑商品',
              menuId: 'company-goodsManagement',
              activeMenu:
                '/small/Y-Service/company-pointsMall/company-goodsManagement',
              type: 'COMPANY'
            }
          },
          {
            path: 'company-editInventory',
            component: () =>
              import(
                '@/views/small-backstage/points-mall/goods-management/editInventory.vue'
              ),
            hidden: true,
            name: 'company-editInventory',
            meta: {
              title: '编辑库存',
              menuId: 'company-goodsManagement',
              activeMenu:
                '/small/Y-Service/company-pointsMall/company-goodsManagement',
              type: 'COMPANY'
            }
          },
          {
            path: 'company-orderManagement',
            component: () =>
              import(
                '@/views/small-backstage/points-mall/order-management/list.vue'
              ),
            name: 'company-orderManagement',
            meta: {
              title: '订单管理',
              menuId: 'company-orderManagement',
              type: 'COMPANY'
            }
          },
          {
            path: 'company-goods-detail',
            component: () =>
              import(
                '@/views/small-backstage/points-mall/order-management/goods-detail.vue'
              ),
            name: 'company-goods-detail',
            hidden: true,
            meta: {
              title: '订单详情',
              menuId: 'company-orderManagement',
              activeMenu:
                '/small/Y-Service/company-pointsMall/company-orderManagement',
              type: 'COMPANY'
            }
          }
        ]
      },
      {
        path: '/small/customerServiceAssistant',
        component: { render: (e) => e('router-view') },
        name: 'customer-service-assistant',
        meta: {
          title: '客服助手',
          roles: [ROLES_TENANT],
          menuId: 'customer-service-assistant'
        },
        children: [
          {
            path: 'question-classify',
            component: () =>
              import(
                '@/views/small-backstage/customer-service-assistant/classify.vue'
              ),
            name: 'question-classify',
            meta: {
              title: '问题分类',
              roles: [ROLES_TENANT],
              menuId: 'question-classify'
            }
          },
          {
            path: 'issue-management',
            component: () =>
              import(
                '@/views/small-backstage/customer-service-assistant/issue-management.vue'
              ),
            name: 'issue-management',
            meta: {
              title: '问题管理',
              roles: [ROLES_TENANT],
              menuId: 'issue-management'
            }
          },
          {
            path: 'browse-details-list',
            component: () =>
              import(
                '@/views/small-backstage/customer-service-assistant/browse-details-list.vue'
              ),
            name: 'browse-details-list',
            meta: {
              title: '问题浏览明细',
              roles: [ROLES_TENANT],
              menuId: 'browse-details-list'
            }
          },
          {
            path: 'search-details-list',
            component: () =>
              import(
                '@/views/small-backstage/customer-service-assistant/search-details-list.vue'
              ),
            name: 'search-details-list',
            meta: {
              title: '问题搜索明细',
              roles: [ROLES_TENANT],
              menuId: 'search-details-list'
            }
          },

          {
            path: 'question-detail',
            component: () =>
              import(
                '@/views/small-backstage/customer-service-assistant/question-detail.vue'
              ),
            name: 'question-detail',
            hidden: true,
            meta: {
              title: '问题详情',
              roles: [ROLES_TENANT],
              menuId: 'issue-management',
              activeMenu: '/small/customerServiceAssistant/issue-management'
            }
          }
        ]
      },
      {
        path: '/small/configurationCenter',
        component: { render: (e) => e('router-view') },
        name: 'small-configurationCenter',
        meta: {
          title: '配置中心',
          roles: [ROLES_TENANT],
          menuId: 'small-configurationCenter'
        },
        children: [
          {
            path: 'currency-config',
            component: () =>
              import(
                '@/views/small-backstage/tenant-configuration-center/currency.vue'
              ),
            name: 'currency-config',
            meta: {
              title: '通用配置',
              roles: [ROLES_TENANT],
              menuId: 'currency-config'
            }
          },
          {
            path: 'miniprogram-config',
            component: () =>
              import(
                '@/views/small-backstage/tenant-configuration-center/index.vue'
              ),
            name: 'miniprogram-config',
            meta: {
              title: '小程序界面配置',
              roles: [ROLES_TENANT],
              menuId: 'miniprogram-config'
            }
          }
        ]
      },

      {
        path: '/small/contract-management',
        component: { render: (e) => e('router-view') },
        name: 'small-contract-management',
        meta: {
          title: '合约管理',
          roles: [ROLES_TENANT],
          menuId: 'agreement_manage'
        },
        children: [
          // 合约项目列表
          {
            path: 'contract-list',
            component: () =>
              import(
                '@/views/small-backstage/contract-management/contract-list'
              ),
            name: 'contract-list',
            meta: {
              title: '合约项目列表',
              roles: [ROLES_TENANT],
              menuId: 'agreement_project'
            }
          },
          // 合约列表编辑
          {
            path: 'contract-list-edit',
            component: () =>
              import(
                '@/views/small-backstage/contract-management/contract-list/edit-page'
              ),
            name: 'contract-list-edit',
            hidden: true,
            meta: {
              title: '合约列表编辑',
              roles: [ROLES_TENANT],
              menuId: 'agreement_project',
              activeMenu: '/small/contract-management/contract-list'
            }
          },
          // 合约列表查看
          {
            path: 'contract-list-view',
            component: () =>
              import(
                '@/views/small-backstage/contract-management/contract-list/view-page'
              ),
            name: 'contract-list-view',
            hidden: true,
            meta: {
              title: '合约列表查看',
              roles: [ROLES_TENANT],
              menuId: 'agreement_project',
              activeMenu: '/small/contract-management/contract-list'
            }
          },
          // 合约项目-查看用户列表
          {
            path: 'contract-user-list-view',
            component: () =>
              import(
                '@/views/small-backstage/contract-management/contract-list/user-list-page'
              ),
            name: 'contract-user-list-view',
            hidden: true,
            meta: {
              title: '查看用户列表',
              roles: [ROLES_TENANT],
              menuId: 'agreement_project',
              activeMenu: '/small/contract-management/contract-list'
            }
          },
          // 合约项目-新增、编辑用户
          {
            path: 'contract-user-list-edit',
            component: () =>
              import(
                '@/views/small-backstage/contract-management/contract-list/user-list-page-edit'
              ),
            name: 'contract-user-list-edit',
            hidden: true,
            meta: {
              title: '新增用户',
              roles: [ROLES_TENANT],
              menuId: 'agreement_project',
              activeMenu: '/small/contract-management/contract-list'
            }
          },
          // 合约项目-用户详情
          {
            path: 'contract-user-list-detail',
            component: () =>
              import(
                '@/views/small-backstage/contract-management/contract-list/user-list-page-detail'
              ),
            name: 'contract-user-list-detail',
            hidden: true,
            meta: {
              title: '用户详情',
              roles: [ROLES_TENANT],
              menuId: 'agreement_project',
              activeMenu: '/small/contract-management/contract-list'
            }
          },
          // 项目用户列表
          {
            path: 'contract-program-user-list',
            component: () =>
              import(
                '@/views/small-backstage/contract-management/contract-list/user-list-page'
              ),
            name: 'contract-program-user-list',
            hidden: true,
            meta: {
              title: '项目用户列表',
              roles: [ROLES_TENANT],
              menuId: 'agreement_project',
              activeMenu: '/small/contract-management/contract-list'
            }
          },
          // 签约列表
          {
            path: 'contract-sign-list',
            component: () =>
              import(
                '@/views/small-backstage/contract-management/contract-sign-list'
              ),
            name: 'contract-sign-list',
            meta: {
              title: '签约列表',
              roles: [ROLES_TENANT],
              menuId: 'agreement_sign_record'
            }
          },
          // 用户合约信息
          {
            path: 'contract-user-info',
            component: () =>
              import(
                '@/views/small-backstage/contract-management/contract-user-info'
              ),
            name: 'contract-user-info',
            meta: {
              title: '合约用户信息',
              roles: [ROLES_TENANT],
              menuId: 'agreement_user'
            }
          },
          {
            path: 'contract-user-info-edit',
            component: () =>
              import(
                '@/views/small-backstage/contract-management/contract-user-info/edit'
              ),
            name: 'contract-user-info-edit',
            hidden: true,
            meta: {
              title: '编辑用户',
              roles: [ROLES_TENANT],
              menuId: 'agreement_user',
              activeMenu: '/small/contract-management/contract-user-info'
            }
          },
          {
            path: 'contract-user-info-detail',
            component: () =>
              import(
                '@/views/small-backstage/contract-management/contract-user-info/detail.vue'
              ),
            name: 'contract-user-info-detail',
            hidden: true,
            meta: {
              title: '用户详情',
              roles: [ROLES_TENANT],
              menuId: 'agreement_user',
              activeMenu: '/small/contract-management/contract-user-info'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/h5',
    name: 'h5',
    component: { render: (e) => e('router-view') },
    children: [
      {
        path: 'bi',
        name: 'bi',
        hidden: true,
        component: { render: (e) => e('router-view') },
        children: [
          {
            path: 'ranking-overview',
            name: 'bi-ranking-overview',
            hidden: true,
            component: () => import('@/views/h5/bi/ranking-overview/index.vue'),
            meta: {
              title: '总览统计',
              menuId: 'bi-analysis-league-table'
            }
          },
          {
            path: 'produce',
            name: 'produce',
            hidden: true,
            component: () => import('@/views/h5/bi/produce/index.vue'),
            meta: {
              title: '产出',
              menuId: 'produce'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/test',
    hidden: true,
    component: Layout,
    children: [
      {
        path: 'smart-table',
        component: () => import('@/views/smart-table/index.vue'),
        meta: {
          roles: [ROLES_TENANT],
          menuId: 'target-customer'
        }
      }
    ]
  },
  {
    path: '/small/system-management',
    component: Layout,
    meta: {
      title: '系统管理',
      icon: 'oms-system-management',
      roles: [ROLES_TENANT],
      menuId: 'oms-system-management'
    },
    children: [
      {
        path: 'oms-data-management',
        component: { render: (e) => e('router-view') },
        name: 'oms-data-masterDataManage',
        meta: {
          title: '主数据管理',
          roles: [ROLES_TENANT],
          menuId: 'oms-data-management'
        },
        children: [
          {
            path: 'tenant-institutions',
            component: () =>
              import('@/views/small-backstage/tenant-institutions'),
            name: 'tenant-institutions',
            meta: {
              title: '机构管理',
              roles: [ROLES_TENANT],
              menuId: 'tenant-institutions',
              keepAlive: true
            }
          },
          {
            path: 'tenant-institutions-detail',
            component: () =>
              import('@/views/small-backstage/tenant-institutions-detail'),
            name: 'tenant-institutions-detail',
            hidden: true,
            meta: {
              title: '机构详情',
              roles: [ROLES_TENANT],
              menuId: 'tenant-institutions',
              activeMenu:
                '/small/system-management/oms-data-management/tenant-institutions'
            }
          },

          {
            path: 'tenant-institutions-addOrEdit',
            component: () =>
              import('@/views/small-backstage/tenant-institutions-addOrEdit'),
            name: 'tenant-institutions-addOrEdit',
            hidden: true,
            meta: {
              title: '机构管理',
              menuId: 'tenant-institutions',
              roles: [ROLES_TENANT],
              activeMenu:
                '/small/system-management/oms-data-management/tenant-institutions'
            }
          },

          {
            path: 'tenant-product',
            component: () =>
              import('@/views/small-backstage/basic-set/tenant-product'),
            name: 'tenant-product',
            meta: {
              title: '产品管理',
              roles: [ROLES_TENANT],
              menuId: 'tenant-product'
            }
          },
          {
            path: 'tenant-product-detail',
            component: () =>
              import(
                '@/views/small-backstage/basic-set/tenant-product/productDetail'
              ),
            name: 'tenant-product-detail',
            hidden: true,
            meta: {
              title: '产品详情',
              roles: [ROLES_TENANT],
              menuId: 'tenant-product',
              activeMenu:
                '/small/system-management/oms-data-management/tenant-product'
            }
          },
          {
            path: 'tenant-product-set',
            component: () =>
              import('@/views/small-backstage/basic-set/tenant-product-set'),
            name: 'tenant-product-set',
            hidden: true,
            meta: {
              title: '产品管理',
              roles: [ROLES_TENANT],
              menuId: 'tenant-product',
              activeMenu:
                '/small/system-management/oms-data-management/tenant-product'
            }
          },
          {
            path: 'dictionary-config',
            component: () =>
              import('@/views/small-backstage/dictionary-config'),
            name: 'dictionary-config',
            meta: {
              title: '主数据字段配置',
              roles: [ROLES_TENANT],
              menuId: 'dictionary-config'
            }
          },
          {
            path: 'dictionary-customer',
            component: () =>
              import('@/views/small-backstage/dictionary-customer'),
            name: 'dictionary-customer',
            meta: {
              title: '字典设置',
              roles: [ROLES_TENANT],
              menuId: 'dictionary-customer'
            }
          }
        ]
      },
      {
        path: 'dataManage',
        component: { render: (e) => e('router-view') },
        name: 'dataManage',
        meta: {
          title: '导入导出中心',
          roles: [ROLES_TENANT],
          menuId: 'small-dataManage'
        },
        children: [
          {
            path: 'data-update2',
            component: () => import('@/views/small-backstage/data-update2'),
            name: 'data-update2',
            meta: {
              title: '导入中心',
              roles: [ROLES_TENANT],
              menuId: 'data-update2'
            }
          },
          {
            path: 'export-list',
            component: () => import('@/views/small-backstage/export-list'),
            name: 'export-list',
            meta: {
              title: '导出中心',
              roles: [ROLES_TENANT],
              menuId: 'export-list'
            }
          },
          {
            path: 'import-records',
            component: () => import('@/views/small-backstage/import-records'),
            name: 'import-records',
            meta: {
              title: '导入记录',
              roles: [ROLES_TENANT],
              menuId: 'import-records'
            }
          }
        ]
      },
      {
        path: 'soms-user-userCenter',
        component: { render: (e) => e('router-view') },
        name: 'oms-user-userCenter',
        meta: {
          title: '用户管理',
          roles: [ROLES_TENANT],
          menuId: 'oms-user-management'
        },
        children: [
          {
            path: 'accountManage',
            component: () => import('@/views/small-backstage/account-manage'),
            name: 'accountManage',
            meta: {
              title: '账号管理',
              roles: [ROLES_TENANT],
              menuId: 'accountManage',
              keepAlive: true
            }
          },
          {
            path: 'accountDetail',
            component: () =>
              import('@/views/small-backstage/account-manage/indexDetail.vue'),
            name: 'accountDetail',
            hidden: true,
            meta: {
              title: '账号管理',
              roles: [ROLES_TENANT],
              menuId: 'accountManage',
              activeMenu:
                '/small/system-management/oms-user-userCenter/accountManage'
            }
          },
          {
            path: 'roleManage',
            component: () =>
              import('@/views/small-backstage/tenant-user-center/index.vue'),
            name: 'roleManage',
            meta: {
              title: '角色管理',
              roles: [ROLES_TENANT],
              menuId: 'roleManage'
            }
          }
        ]
      },
      {
        path: 'region-management',
        component: { render: (e) => e('router-view') },
        name: 'region-management',
        meta: {
          title: '区域管理',
          roles: [ROLES_TENANT],
          menuId: 'region-management'
        },
        children: [
          {
            path: 'big-region-management',
            component: () =>
              import(
                '@/views/small-backstage/regionManagement/bigRegionManagement/index'
              ),
            name: 'big-region-management',
            meta: {
              title: '大区管理',
              roles: [ROLES_TENANT],
              menuId: 'big-region-management',
              keepAlive: true
            }
          },
          {
            path: 'province-region-management',
            component: () =>
              import(
                '@/views/small-backstage/regionManagement/provinceRegionManagement/index'
              ),
            name: 'province-region-management',
            meta: {
              title: '省区管理',
              roles: [ROLES_TENANT],
              menuId: 'province-region-management',
              keepAlive: true
            }
          },
          // {
          //   path: 'county-manage',
          //   component: () =>
          //     import('@/views/small-backstage/county-manage/index'),
          //   name: 'county-manage',
          //   meta: {
          //     title: '区县管理',
          //     roles: [ROLES_TENANT],
          //     menuId: 'county-manage'
          //   }
          // },
          {
            path: 'administrative-division',
            component: () =>
              import(
                '@/views/small-backstage/system-management/administrative-division/index'
              ),
            name: 'administrative-division-list',
            meta: {
              title: '行政区划管理',
              roles: [ROLES_TENANT],
              menuId: 'oms-administrative-area-management'
            }
          },
          {
            path: 'administrative-division/form',
            component: () =>
              import(
                '@/views/small-backstage/system-management/administrative-division/form'
              ),
            name: 'administrative-division-form',
            hidden: true,
            meta: {
              title: '行政区划',
              roles: [ROLES_TENANT],
              menuId: 'oms-administrative-area-management',
              activeMenu:
                '/small/system-management/region-management/administrative-division'
            }
          }
        ]
      },
      {
        path: 'log-center',
        component: { render: (e) => e('router-view') },
        name: 'log-center',
        meta: {
          title: '日志中心',
          roles: [ROLES_TENANT],
          menuId: 'log-center'
        },
        children: [
          {
            path: 'user-login-log',
            component: () =>
              import('@/views/small-backstage/log-center/user-login-log.vue'),
            name: 'user-login-log',
            meta: {
              title: '用户登录日志',
              roles: [ROLES_TENANT],
              menuId: 'user-login-log'
            }
          },
          {
            path: 'account-manage-log',
            component: () =>
              import('@/views/small-backstage/account-manage-log/index.vue'),
            name: 'account-manage-log',
            meta: {
              title: '账号管理日志',
              roles: [ROLES_TENANT],
              menuId: 'account-manage-log'
            }
          },
          {
            path: 'user-action-log',
            component: () =>
              import('@/views/small-backstage/user-action-log/index.vue'),
            name: 'user-action-log',
            meta: {
              title: '用户操作日志',
              roles: [ROLES_TENANT],
              menuId: 'user-action-log'
            }
          },
          {
            path: 'data-recycle-bin',
            component: () =>
              import('@/views/small-backstage/data-recycle-bin/index.vue'),
            name: 'data-recycle-bin',
            meta: {
              title: '数据回收站',
              roles: [ROLES_TENANT],
              menuId: 'data-recycle-bin'
            }
          }
        ]
      }
    ]
  },

  {
    path: '/small/oms-service-task-management',
    component: Layout,
    meta: {
      title: '服务商管理',
      icon: 'oms-agency',
      roles: [ROLES_TENANT],
      menuId: 'oms-agency'
    },
    children: [
      {
        path: 'oms-service-provider-info',
        component: () =>
          import(
            '@/views/small-backstage/oms-service-task-management/service-provider-info/index'
          ),
        name: 'oms-service-provider-info',
        meta: {
          title: '服务商信息管理',
          roles: [ROLES_TENANT],
          menuId: 'agency-information'
        }
      },
      {
        path: 'oms-service-provider-info-edit',
        component: () =>
          import(
            '@/views/small-backstage/oms-service-task-management/service-provider-apply-management/edit-apply.vue'
          ),
        name: 'oms-service-provider-info-edit',
        hidden: true,
        meta: {
          title: '编辑服务商', // 服务商/外部服务商 信息变更申请
          roles: [ROLES_TENANT],
          activeMenu:
            '/small/oms-service-task-management/oms-service-provider-info',
          menuId: 'agency-information'
        }
      },
      {
        path: 'oms-service-provider',
        component: () =>
          import(
            '@/views/small-backstage/oms-service-task-management/service-provider'
          ),
        name: 'oms-service-provider',
        meta: {
          title: '服务商管理',
          roles: [ROLES_TENANT],
          menuId: 'agency'
        }
      },
      {
        path: 'oms-service-provider-create',
        component: () =>
          import(
            '@/views/small-backstage/oms-service-task-management/service-provider/create.vue'
          ),
        name: 'oms-service-provider-create',
        hidden: true,
        meta: {
          title: '新建服务商',
          roles: [ROLES_TENANT],
          activeMenu: '/small/oms-service-task-management/oms-service-provider',

          menuId: 'agency'
        }
      },
      {
        path: 'oms-service-provider-edit',
        component: () =>
          import(
            '@/views/small-backstage/oms-service-task-management/service-provider-apply-management/edit-apply.vue'
          ),
        name: 'oms-service-provider-edit',
        hidden: true,
        meta: {
          title: '编辑服务商', // 服务商/外部服务商 信息变更申请
          roles: [ROLES_TENANT],
          activeMenu: '/small/oms-service-task-management/oms-service-provider',
          menuId: 'agency'
        }
      },
      {
        path: 'oms-service-provider-detail',
        component: () =>
          import(
            '@/views/small-backstage/oms-service-task-management/service-provider/detail.vue'
          ),
        name: 'oms-service-provider-detail',
        hidden: true,
        meta: {
          title: '服务商详情',
          roles: [ROLES_TENANT],
          activeMenu: '/small/oms-service-task-management/oms-service-provider',
          menuId: 'dashboard'
        }
      },
      {
        path: 'oms-service-provider-virtual-detail',
        component: () =>
          import(
            '@/views/small-backstage/oms-service-task-management/service-provider/detail-virtual.vue'
          ),
        name: 'oms-service-provider-virtual-detail',
        hidden: true,
        meta: {
          title: '服务商详情',
          roles: [ROLES_TENANT],
          activeMenu: '/small/oms-service-task-management/oms-service-provider',
          menuId: 'dashboard'
        }
      },
      {
        path: 'oms-service-provider-apply-management',
        component: () =>
          import(
            '@/views/small-backstage/oms-service-task-management/service-provider-apply-management/index'
          ),
        name: 'oms-service-provider-apply-management',
        meta: {
          title: '服务商申请管理',
          roles: [ROLES_TENANT],
          menuId: 'agency-apply'
        }
      },
      {
        path: 'oms-service-provider-apply-management-admission-detail',
        component: () =>
          import(
            '@/views/small-backstage/oms-service-task-management/service-provider-apply-management/detail.vue'
          ),
        name: 'oms-service-provider-apply-management-admission-detail',
        hidden: true,
        meta: {
          title: '服务商准入详情',
          roles: [ROLES_TENANT],
          activeMenu:
            '/small/oms-service-task-management/oms-service-provider-apply-management',
          menuId: 'dashboard'
        }
      },
      {
        path: 'oms-service-provider-apply-management-info-change-detail',
        component: () =>
          import(
            '@/views/small-backstage/oms-service-task-management/service-provider-apply-management/detail.vue'
          ),
        name: 'oms-service-provider-apply-management-info-change-detail',
        hidden: true,
        meta: {
          title: '服务商信息变更详情',
          roles: [ROLES_TENANT],
          activeMenu:
            '/small/oms-service-task-management/oms-service-provider-apply-management',
          menuId: 'dashboard'
        }
      },
      {
        path: 'oms-service-provider-apply-management-contract-sign-detail',
        component: () =>
          import(
            '@/views/small-backstage/oms-service-task-management/service-provider-apply-management/detail.vue'
          ),
        name: 'oms-service-provider-apply-management-contract-sign-detail',
        hidden: true,
        meta: {
          title: '服务商签约详情',
          roles: [ROLES_TENANT],
          activeMenu:
            '/small/oms-service-task-management/oms-service-provider-apply-management',
          menuId: 'dashboard'
        }
      },
      {
        path: 'oms-service-provider-apply-management-contract-terminate-detail',
        component: () =>
          import(
            '@/views/small-backstage/oms-service-task-management/service-provider-apply-management/detail.vue'
          ),
        name: 'oms-service-provider-apply-management-contract-terminate-detail',
        hidden: true,
        meta: {
          title: '服务商解约详情',
          roles: [ROLES_TENANT],
          activeMenu:
            '/small/oms-service-task-management/oms-service-provider-apply-management',
          menuId: 'dashboard'
        }
      },
      {
        path: 'oms-service-provider-apply-management-add-sign-apply',
        component: () =>
          import(
            '@/views/small-backstage/oms-service-task-management/service-provider-apply-management/add-sign-apply.vue'
          ),
        name: 'oms-service-provider-apply-management-add-sign-apply',
        hidden: true,
        meta: {
          title: '新增签约申请',
          roles: [ROLES_TENANT],
          activeMenu:
            '/small/oms-service-task-management/oms-service-provider-apply-management',
          menuId: 'agency-apply'
        }
      },
      {
        path: 'oms-service-provider-apply-management-unsign-apply',
        component: () =>
          import(
            '@/views/small-backstage/oms-service-task-management/service-provider-apply-management/unsign-apply.vue'
          ),
        name: 'oms-service-provider-apply-management-unsign-apply',
        hidden: true,
        meta: {
          title: '新建解约申请',
          roles: [ROLES_TENANT],
          activeMenu:
            '/small/oms-service-task-management/oms-service-provider-apply-management',
          menuId: 'agency-apply'
        }
      },
      {
        path: 'oms-service-provider-apply-management-edit-apply',
        component: () =>
          import(
            '@/views/small-backstage/oms-service-task-management/service-provider-apply-management/edit-apply.vue'
          ),
        name: 'oms-service-provider-apply-management-edit-apply',
        hidden: true,
        meta: {
          title: '编辑服务商', // 服务商/外部服务商 信息变更申请
          roles: [ROLES_TENANT],
          activeMenu:
            '/small/oms-service-task-management/oms-service-provider-apply-management',
          menuId: 'agency-apply'
        }
      },
      {
        path: 'oms-service-provider-apply-management-selection',
        component: () =>
          import(
            '@/views/small-backstage/oms-service-task-management/service-provider-apply-management/selection.vue'
          ),
        name: 'oms-service-provider-apply-management-selection',
        hidden: true,
        meta: {
          title: '遴选详情',
          roles: [ROLES_TENANT],
          activeMenu:
            '/small/oms-service-task-management/oms-service-provider-apply-management',
          menuId: 'agency-apply'
        }
      },
      {
        path: 'oms-service-provider-access-assessment',
        component: () =>
          import(
            '@/views/small-backstage/oms-service-task-management/access-assessment-management/index.vue'
          ),
        name: 'oms-service-provider-access-assessment',
        meta: {
          title: '准入评估管理',
          roles: [ROLES_TENANT],
          menuId: 'agency-judge'
        }
      },

      {
        path: 'oms-service-provider-selection-assessment',
        component: () =>
          import(
            '@/views/small-backstage/oms-service-task-management/access-assessment-management/selection-assessment.vue'
          ),
        name: 'oms-service-provider-selection-assessment',
        hidden: true,
        meta: {
          title: '遴选评估',
          roles: [ROLES_TENANT],
          activeMenu:
            '/small/oms-service-task-management/oms-service-provider-access-assessment',
          menuId: 'agency-judge'
        }
      },

      // 遴选模板管理
      {
        path: 'oms-service-provider-selection-assessment-template-management',
        component: () =>
          import(
            '@/views/small-backstage/oms-service-task-management/selection-assessment-management/index.vue'
          ),
        name: 'oms-service-provider-selection-assessment-template-management',
        meta: {
          title: '遴选评估模板管理',
          roles: [ROLES_TENANT],
          menuId: 'agency-judge-template'
        }
      },
      {
        path: 'oms-service-provider-selection-assessment-template-config',
        component: () =>
          import(
            '@/views/small-backstage/oms-service-task-management/selection-assessment-management/template.vue'
          ),
        name: 'oms-service-provider-selection-assessment-template-config',
        hidden: true,
        meta: {
          title: '模板配置',
          roles: [ROLES_TENANT],
          menuId: 'agency-judge-template',
          activeMenu:
            '/small/oms-service-task-management/oms-service-provider-selection-assessment-template-management'
        }
      }
    ]
  },

  {
    path: '/small/Y-OMS',
    component: Layout,
    name: 'small-Y-OMS',
    meta: {
      title: '订单管理',
      icon: 'Y-OMS',
      roles: [ROLES_TENANT],
      menuId: 'oms-order-management'
    },
    children: [
      {
        path: 'opended-management',
        component: { render: (e) => e('router-view') },
        name: 'opended-management',
        meta: {
          title: '疾控管理',
          roles: [ROLES_TENANT],
          menuId: 'opended-management'
        },
        children: [
          {
            path: 'opended-org-management',
            component: () =>
              import('@/views/small-backstage/opended-org-management/index'),
            name: 'opended-org-management',
            meta: {
              title: '疾控管理列表',
              roles: [ROLES_TENANT],
              menuId: 'opended-org-management'
            }
          }
        ]
      },
      {
        path: 'order-management',
        component: { render: (e) => e('router-view') },
        name: 'order-management',
        meta: {
          title: '订单管理',
          roles: [ROLES_TENANT],
          menuId: 'order-management-one'
        },
        children: [
          {
            path: 'chose-order-management',
            component: () =>
              import(
                '@/views/small-backstage/oms-order-management/chose-order-management/index'
              ),
            name: 'chose-order-management',
            meta: {
              title: '点单列表',
              roles: [ROLES_TENANT],
              menuId: 'pre-order-management'
            }
          },
          {
            path: 'chose-order-management-add',
            component: () =>
              import(
                '@/views/small-backstage/oms-order-management/chose-order-management/ChoseOrderEditor.vue'
              ),
            name: 'chose-order-management-add',
            hidden: true,
            meta: {
              title: '新建点单',
              roles: [ROLES_TENANT],
              menuId: 'pre-order-management',
              activeMenu: '/small/Y-OMS/order-management/chose-order-management'
            }
          },
          {
            path: 'chose-order-management-editor',
            component: () =>
              import(
                '@/views/small-backstage/oms-order-management/chose-order-management/ChoseOrderEditor.vue'
              ),
            name: 'chose-order-management-editor',
            hidden: true,
            meta: {
              title: '编辑点单',
              roles: [ROLES_TENANT],
              menuId: 'pre-order-management',
              activeMenu: '/small/Y-OMS/order-management/chose-order-management'
            }
          },
          {
            path: 'chose-order-management-detail',
            component: () =>
              import(
                '@/views/small-backstage/oms-order-management/chose-order-management/ChoseOrderDetail.vue'
              ),
            name: 'chose-order-management-detail',
            hidden: true,
            meta: {
              title: '点单详情',
              roles: [ROLES_TENANT],
              menuId: 'pre-order-management',
              activeMenu: '/small/Y-OMS/order-management/chose-order-management'
            }
          },
          {
            path: 'order-management-index-page',
            component: () =>
              import(
                '@/views/small-backstage/oms-order-management/order-management/index'
              ),
            name: 'order-management-index-page',
            meta: {
              title: '订单列表',
              roles: [ROLES_TENANT],
              menuId: 'order-management-three'
            }
          },
          {
            path: 'order-management-add',
            component: () =>
              import(
                '@/views/small-backstage/oms-order-management/order-management/OrderEditor.vue'
              ),
            name: 'order-management-add',
            hidden: true,
            meta: {
              title: '新建订单',
              roles: [ROLES_TENANT],
              menuId: 'order-management-three',
              activeMenu:
                '/small/Y-OMS/order-management/order-management-index-page'
            }
          },
          {
            path: 'order-management-editor',
            component: () =>
              import(
                '@/views/small-backstage/oms-order-management/order-management/OrderEditor.vue'
              ),
            name: 'order-management-editor',
            hidden: true,
            meta: {
              title: '编辑订单',
              roles: [ROLES_TENANT],
              menuId: 'order-management-three',
              activeMenu:
                '/small/Y-OMS/order-management/order-management-index-page'
            }
          },
          {
            path: 'order-management-detail',
            component: () =>
              import(
                '@/views/small-backstage/oms-order-management/order-management/OrderDetail.vue'
              ),
            name: 'order-management-detail',
            hidden: true,
            meta: {
              title: '订单详情',
              roles: [ROLES_TENANT],
              menuId: 'order-management-three',
              activeMenu:
                '/small/Y-OMS/order-management/order-management-index-page'
            }
          },
          {
            path: 'order-management-withdraw-apply',
            component: () =>
              import(
                '@/views/small-backstage/oms-order-management/order-management/order-withdrawal-request/index'
              ),
            name: 'order-management-withdraw-apply',
            meta: {
              title: '撤销列表',
              roles: [ROLES_TENANT],
              menuId: 'orders-revoke-apply'
            }
          },
          {
            path: 'order-management-withdraw-detail',
            component: () =>
              import(
                '@/views/small-backstage/oms-order-management/order-management/order-withdrawal-request/OrderWithdrawalDetail.vue'
              ),
            name: 'order-management-withdraw-detail',
            hidden: true,
            meta: {
              title: '撤销详情',
              roles: [ROLES_TENANT],
              menuId: 'orders-revoke-apply',
              activeMenu:
                '/small/Y-OMS/order-management/order-management-withdraw-apply'
            }
          }
        ]
      },
      //储运管理
      {
        path: 'transport-management',
        component: { render: (e) => e('router-view') },
        name: 'transport-management',
        meta: {
          title: '储运管理',
          roles: [ROLES_TENANT],
          menuId: 'storage-transport-management'
        },
        children: [
          {
            //待出库
            path: 'wait-out-of-stock',
            component: { render: (e) => e('router-view') },
            name: 'wait-out-of-stock',
            meta: {
              title: '待出库',
              roles: [ROLES_TENANT],
              menuId: 'pending-outbound'
            },
            children: [
              {
                //订单待出库
                path: 'order-wait-out-of-stock',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/wait-out-of-stock/order-wait-out-of-stock'
                  ),
                name: 'order-wait-out-of-stock',
                meta: {
                  title: '订单待出库',
                  roles: [ROLES_TENANT],
                  menuId: 'order-pending-outbound'
                }
              },
              {
                //订单出库编辑页
                path: 'order-wait-out-of-stock-edit',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/wait-out-of-stock/order-wait-out-of-stock-edit'
                  ),
                name: 'order-wait-out-of-stock-edit',
                hidden: true,
                meta: {
                  title: '订单出库',
                  roles: [ROLES_TENANT],
                  menuId: 'order-pending-outbound',
                  activeMenu:
                    '/small/Y-OMS/transport-management/wait-out-of-stock/order-wait-out-of-stock'
                }
              },
              {
                //订单待出库详情页
                path: 'order-wait-out-of-stock-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/wait-out-of-stock/order-wait-out-of-stock-detail'
                  ),
                name: 'order-wait-out-of-stock-detail',
                hidden: true,
                meta: {
                  title: '订单待出库详情',
                  roles: [ROLES_TENANT],
                  menuId: 'order-pending-outbound',
                  activeMenu:
                    '/small/Y-OMS/transport-management/wait-out-of-stock/order-wait-out-of-stock'
                }
              },
              {
                //调拨待出库
                path: 'allocation-wait-out-of-stock',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/wait-out-of-stock/allocation-wait-out-of-stock'
                  ),
                name: 'allocation-wait-out-of-stock',
                meta: {
                  title: '调拨待出库',
                  roles: [ROLES_TENANT],
                  menuId: 'transfer-pending-outbound'
                }
              },
              //调拨出库
              {
                path: 'allocation-wait-out-of-stock-edit',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/wait-out-of-stock/allocation-wait-out-of-stock-edit'
                  ),
                name: 'allocation-wait-out-of-stock-edit',
                hidden: true,
                meta: {
                  title: '调拨出库',
                  roles: [ROLES_TENANT],
                  menuId: 'transfer-pending-outbound',
                  activeMenu:
                    '/small/Y-OMS/transport-management/wait-out-of-stock/allocation-wait-out-of-stock'
                }
              },
              //调拨详情
              {
                path: 'allocation-wait-out-of-stock-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/wait-out-of-stock/allocation-wait-out-of-stock-detail'
                  ),
                name: 'allocation-wait-out-of-stock-detail',
                hidden: true,
                meta: {
                  title: '调拨详情',
                  roles: [ROLES_TENANT],
                  menuId: 'transfer-pending-outbound',
                  activeMenu:
                    '/small/Y-OMS/transport-management/wait-out-of-stock/allocation-wait-out-of-stock'
                }
              },
              //退货待出库
              {
                path: 'return-wait-out-of-stock',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/wait-out-of-stock/return-wait-out-of-stock'
                  ),
                name: 'return-wait-out-of-stock',
                meta: {
                  title: '退货待出库',
                  roles: [ROLES_TENANT],
                  menuId: 'return-pending-outbound'
                }
              },
              //退货出库
              {
                path: 'return-wait-out-of-stock-edit',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/wait-out-of-stock/return-wait-out-of-stock-edit'
                  ),
                name: 'return-wait-out-of-stock-edit',
                hidden: true,
                meta: {
                  title: '退货出库',
                  roles: [ROLES_TENANT],
                  menuId: 'return-pending-outbound',
                  activeMenu:
                    '/small/Y-OMS/transport-management/wait-out-of-stock/return-wait-out-of-stock'
                }
              },
              //退货待出库详情
              {
                path: 'return-wait-out-of-stock-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/wait-out-of-stock/return-wait-out-of-stock-detail'
                  ),
                name: 'return-wait-out-of-stock-detail',
                hidden: true,
                meta: {
                  title: '退货待出库详情',
                  roles: [ROLES_TENANT],
                  menuId: 'return-pending-outbound',
                  activeMenu:
                    '/small/Y-OMS/transport-management/wait-out-of-stock/return-wait-out-of-stock'
                }
              },
              //退库待出库
              {
                path: 'return-stock-wait-out-of-stock',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/wait-out-of-stock/return-stock-wait-out-of-stock'
                  ),
                name: 'return-stock-wait-out-of-stock',
                meta: {
                  title: '退库待出库',
                  roles: [ROLES_TENANT],
                  menuId: 'transfer-return-pending-outbound'
                }
              },
              //退库出库
              {
                path: 'return-stock-wait-out-of-stock-edit',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/wait-out-of-stock/return-stock-wait-out-of-stock-edit'
                  ),
                name: 'return-stock-wait-out-of-stock-edit',
                hidden: true,
                meta: {
                  title: '退库出库',
                  roles: [ROLES_TENANT],
                  menuId: 'transfer-return-pending-outbound',
                  activeMenu:
                    '/small/Y-OMS/transport-management/wait-out-of-stock/return-stock-wait-out-of-stock'
                }
              },
              //退库待出库详情
              {
                path: 'return-stock-wait-out-of-stock-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/wait-out-of-stock/return-stock-wait-out-of-stock-detail'
                  ),
                name: 'return-stock-wait-out-of-stock-detail',
                hidden: true,
                meta: {
                  title: '退库待出库详情',
                  roles: [ROLES_TENANT],
                  menuId: 'transfer-return-pending-outbound',
                  activeMenu:
                    '/small/Y-OMS/transport-management/wait-out-of-stock/return-stock-wait-out-of-stock'
                }
              }
            ]
          },
          {
            //出库单
            path: 'out-of-stock-list',
            component: { render: (e) => e('router-view') },
            name: 'out-of-stock-list',
            meta: {
              title: '出库单',
              roles: [ROLES_TENANT],
              menuId: 'outbound'
            },
            children: [
              //订单出库
              {
                path: 'order-out-of-stock',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/out-of-stock-list/order-out-of-stock'
                  ),
                name: 'order-out-of-stock',
                meta: {
                  title: '订单出库',
                  roles: [ROLES_TENANT],
                  menuId: 'order-outbound'
                }
              },
              //订单出库详情
              {
                path: 'order-out-of-stock-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/out-of-stock-list/order-out-of-stock-detail'
                  ),
                name: 'order-out-of-stock-detail',
                hidden: true,
                meta: {
                  title: '订单出库详情',
                  roles: [ROLES_TENANT],
                  menuId: 'order-outbound',
                  activeMenu:
                    '/small/Y-OMS/transport-management/out-of-stock-list/order-out-of-stock'
                }
              },
              //编辑订单出库信息
              {
                path: 'order-out-of-stock-edit',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/out-of-stock-list/order-out-of-stock-edit'
                  ),
                name: 'order-out-of-stock-edit',
                hidden: true,
                meta: {
                  title: '编辑订单出库信息',
                  roles: [ROLES_TENANT],
                  menuId: 'order-outbound',
                  activeMenu:
                    '/small/Y-OMS/transport-management/out-of-stock-list/order-out-of-stock'
                }
              },
              //调拨出库列表
              {
                path: 'allocation-out-of-stock',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/out-of-stock-list/allocation-out-of-stock'
                  ),
                name: 'allocation-out-of-stock',
                meta: {
                  title: '调拨出库',
                  roles: [ROLES_TENANT],
                  menuId: 'transfer-outbound'
                }
              },
              //调拨出库详情
              {
                path: 'allocation-out-of-stock-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/out-of-stock-list/allocation-out-of-stock-detail'
                  ),
                name: 'allocation-out-of-stock-detail',
                hidden: true,
                meta: {
                  title: '调拨出库详情',
                  roles: [ROLES_TENANT],
                  menuId: 'transfer-outbound',
                  activeMenu:
                    '/small/Y-OMS/transport-management/out-of-stock-list/allocation-out-of-stock'
                }
              },
              //编辑调拨出库信息
              {
                path: 'allocation-out-of-stock-edit-outstock',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/out-of-stock-list/allocation-out-of-stock-edit-outstock'
                  ),
                name: 'allocation-out-of-stock-edit-outstock',
                hidden: true,
                meta: {
                  title: '编辑调拨出库信息',
                  roles: [ROLES_TENANT],
                  menuId: 'transfer-outbound',
                  activeMenu:
                    '/small/Y-OMS/transport-management/out-of-stock-list/allocation-out-of-stock'
                }
              },
              //其他出库列表
              {
                path: 'other-out-of-stock',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/out-of-stock-list/other-out-of-stock'
                  ),
                name: 'other-out-of-stock',
                meta: {
                  title: '其他出库',
                  roles: [ROLES_TENANT],
                  menuId: 'other-outbound'
                }
              },
              //其他出库详情
              {
                path: 'other-out-of-stock-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/out-of-stock-list/other-out-of-stock-detail'
                  ),
                name: 'other-out-of-stock-detail',
                hidden: true,
                meta: {
                  title: '其他出库详情',
                  roles: [ROLES_TENANT],
                  menuId: 'other-outbound',
                  activeMenu:
                    '/small/Y-OMS/transport-management/out-of-stock-list/other-out-of-stock'
                }
              },
              //退货列表
              {
                path: 'return-list',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/out-of-stock-list/return-list'
                  ),
                name: 'return-list',
                meta: {
                  title: '退货单',
                  roles: [ROLES_TENANT],
                  menuId: 'return-outbound'
                }
              },
              //退货详情
              {
                path: 'return-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/out-of-stock-list/return-detail'
                  ),
                name: 'return-detail',
                hidden: true,
                meta: {
                  title: '退货详情',
                  roles: [ROLES_TENANT],
                  menuId: 'return-outbound',
                  activeMenu:
                    '/small/Y-OMS/transport-management/out-of-stock-list/return-list'
                }
              },
              //编辑退货出库信息
              {
                path: 'return-list-edit',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/out-of-stock-list/return-list-edit'
                  ),
                name: 'return-list-edit',
                hidden: true,
                meta: {
                  title: '编辑退货出库信息',
                  roles: [ROLES_TENANT],
                  menuId: 'return-outbound',
                  activeMenu:
                    '/small/Y-OMS/transport-management/out-of-stock-list/return-list'
                }
              },
              //退库列表
              {
                path: 'return-stock-list',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/out-of-stock-list/return-stock-list'
                  ),
                name: 'return-stock-list',
                meta: {
                  title: '退库单',
                  roles: [ROLES_TENANT],
                  menuId: 'transfer-return-outbound'
                }
              },
              //退库详情
              {
                path: 'return-stock-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/out-of-stock-list/return-stock-detail'
                  ),
                name: 'return-stock-detail',
                hidden: true,
                meta: {
                  title: '退库详情',
                  roles: [ROLES_TENANT],
                  menuId: 'transfer-return-outbound',
                  activeMenu:
                    '/small/Y-OMS/transport-management/out-of-stock-list/return-stock-list'
                }
              }
            ]
          },
          //待入库
          {
            path: 'wait-in-stock',
            component: { render: (e) => e('router-view') },
            name: 'wait-in-stock',
            meta: {
              title: '待入库',
              roles: [ROLES_TENANT],
              menuId: 'pending-inbound'
            },
            children: [
              //退货待入库
              {
                path: 'return-wait-in-stock',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/wait-in-stock/return-wait-in-stock'
                  ),
                name: 'return-wait-in-stock',
                meta: {
                  title: '退货待入库',
                  roles: [ROLES_TENANT],
                  menuId: 'return-pending-inbound'
                }
              },
              //退货待入库详情
              {
                path: 'return-wait-in-stock-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/wait-in-stock/return-wait-in-stock-detail'
                  ),
                name: 'return-wait-in-stock-detail',
                hidden: true,
                meta: {
                  title: '退货待入库详情',
                  roles: [ROLES_TENANT],
                  menuId: 'return-pending-inbound',
                  activeMenu:
                    '/small/Y-OMS/transport-management/wait-in-stock/return-wait-in-stock'
                }
              },
              //退库待入库
              {
                path: 'return-stock-wait-in-stock',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/wait-in-stock/return-stock-wait-in-stock'
                  ),
                name: 'return-stock-wait-in-stock',
                meta: {
                  title: '退库待入库',
                  roles: [ROLES_TENANT],
                  menuId: 'transfer-return-pending-inbound'
                }
              },
              //退库待入库详情
              {
                path: 'return-stock-wait-in-stock-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/wait-in-stock/return-stock-wait-in-stock-detail'
                  ),
                name: 'return-stock-wait-in-stock-detail',
                hidden: true,
                meta: {
                  title: '退库待入库详情',
                  roles: [ROLES_TENANT],
                  menuId: 'transfer-return-pending-inbound',
                  activeMenu:
                    '/small/Y-OMS/transport-management/wait-in-stock/return-stock-wait-in-stock'
                }
              }
            ]
          }, // 入库单, 146 第一批先不开发，先注释
          {
            path: 'in-stock',
            component: { render: (e) => e('router-view') },
            name: 'in-stock',
            meta: {
              title: '入库单',
              roles: [ROLES_TENANT],
              menuId: 'warehouse-management'
            },
            children: [
              {
                path: 'new-product-in-stock',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/in-stock/new-product-in-stock'
                  ),
                name: 'new-product-in-stock',
                meta: {
                  title: '新品入库单',
                  roles: [ROLES_TENANT],
                  menuId: 'warehouse-new-management'
                }
              },
              {
                path: 'new-product-in-stock-create',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/in-stock/new-product-in-stock-create'
                  ),
                name: 'new-product-in-stock-create',
                hidden: true,
                meta: {
                  title: '添加新品入库单',
                  roles: [ROLES_TENANT],
                  menuId: 'warehouse-new-management',
                  activeMenu:
                    '/small/Y-OMS/transport-management/in-stock/new-product-in-stock'
                }
              },
              {
                path: 'new-product-in-stock-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/in-stock/new-product-in-stock-detail'
                  ),
                name: 'new-product-in-stock-detail',
                hidden: true,
                meta: {
                  title: '新品入库单详情',
                  roles: [ROLES_TENANT],
                  menuId: 'warehouse-new-management',
                  activeMenu:
                    '/small/Y-OMS/transport-management/in-stock/new-product-in-stock'
                }
              },
              {
                path: 'new-product-in-stock-edit',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/in-stock/new-product-in-stock-create'
                  ),
                name: 'new-product-in-stock-edit',
                hidden: true,
                meta: {
                  title: '编辑新品入库单',
                  roles: [ROLES_TENANT],
                  menuId: 'warehouse-new-management',
                  activeMenu:
                    '/small/Y-OMS/transport-management/in-stock/new-product-in-stock'
                }
              },
              {
                path: 'return-in-stock',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/in-stock/return-in-stock/index.vue'
                  ),
                name: 'return-in-stock',
                meta: {
                  title: '退货入库单',
                  roles: [ROLES_TENANT],
                  menuId: 'return-orders-management'
                }
              },
              {
                path: 'return-in-stock-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/in-stock/return-in-stock/detail.vue'
                  ),
                name: 'return-in-stock-detail',
                hidden: true,
                meta: {
                  title: '退货入库单详情',
                  roles: [ROLES_TENANT],
                  menuId: 'return-orders-management',
                  activeMenu:
                    '/small/Y-OMS/transport-management/in-stock/return-in-stock'
                }
              },
              {
                path: 'return-stock-in-stock',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/in-stock/return-stock-in-stock/index.vue'
                  ),
                name: 'return-stock-in-stock',
                meta: {
                  title: '退库入库单',
                  roles: [ROLES_TENANT],
                  menuId: 'return-warehouse-management'
                }
              },
              {
                path: 'return-stock-in-stock-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/in-stock/return-stock-in-stock/detail.vue'
                  ),
                name: 'return-stock-in-stock-detail',
                hidden: true,
                meta: {
                  title: '退库入库单详情',
                  roles: [ROLES_TENANT],
                  menuId: 'return-warehouse-management',
                  activeMenu:
                    '/small/Y-OMS/transport-management/in-stock/return-stock-in-stock'
                }
              },
              {
                path: 'transfer-in-stock',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/in-stock/transfer-in-stock/index'
                  ),
                name: 'transfer-in-stock',
                meta: {
                  title: '其他入库单',
                  roles: [ROLES_TENANT],
                  menuId: 'warehouse-transfer-management'
                }
              },
              {
                path: 'transfer-in-stock-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/in-stock/transfer-in-stock/detail'
                  ),
                name: 'transfer-in-stock-detail',
                hidden: true,
                meta: {
                  title: '其他入库单详情',
                  roles: [ROLES_TENANT],
                  menuId: 'warehouse-transfer-management',
                  activeMenu:
                    '/small/Y-OMS/transport-management/in-stock/transfer-in-stock'
                }
              }
            ]
          },
          // 物流任务
          {
            path: 'logistics-task',
            name: 'logistics-task',
            component: { render: (e) => e('router-view') },
            meta: {
              title: '物流任务',
              roles: [ROLES_TENANT],
              menuId: 'logistics-management'
            },
            children: [
              // 物流任务管理
              {
                path: 'logistics-task-management',
                name: 'logistics-task-management',
                meta: {
                  title: '物流任务管理',
                  roles: [ROLES_TENANT],
                  menuId: 'logistics-task-management'
                },
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/logistics-task/logistics-task-management.vue'
                  )
              },
              // 物流任务详情（固定详情页面）
              {
                path: 'logistics-task-detail/:id',
                name: 'logistics-task-detail',
                hidden: true,
                meta: {
                  title: '物流任务详情',
                  roles: [ROLES_TENANT],
                  menuId: 'logistics-task-management',
                  activeMenu:
                    '/small/Y-OMS/transport-management/logistics-task/logistics-task-management'
                },
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/logistics-task/logistics-details/index.vue'
                  )
              },
              // 物流任务详情（合并所有状态）
              {
                path: 'logistics-detail/:id',
                name: 'logistics-detail',
                hidden: true,
                meta: {
                  title: '物流详情',
                  roles: [ROLES_TENANT],
                  menuId: 'logistics-task-management',
                  activeMenu:
                    '/small/Y-OMS/transport-management/logistics-task/logistics-task-management'
                },
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/logistics-task/logistics-details/index.vue'
                  )
              }
            ]
          },
          // 库存报表
          {
            path: 'stock-report',
            component: { render: (e) => e('router-view') },
            name: 'stock-report',
            meta: {
              title: '库存报表',
              roles: [ROLES_TENANT],
              menuId: 'warehouse-report-management'
            },
            children: [
              // 实时库存
              {
                path: 'real-time-stock',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/stock-report/real-time-stock'
                  ),
                name: 'real-time-stock',
                meta: {
                  title: '实时库存',
                  roles: [ROLES_TENANT],
                  menuId: 'realtime-warehouse-management'
                }
              }
            ]
          }
        ]
      },
      {
        path: 'non-sales-management',
        component: { render: (e) => e('router-view') },
        name: 'non-sales-management',
        meta: {
          title: '非销管理',
          roles: [ROLES_TENANT],
          menuId: 'oms-no-sale'
        },
        children: [
          {
            path: 'allocation-out-of-stock-my',
            component: () =>
              import(
                '@/views/small-backstage/transport-management/out-of-stock-list/allocation-out-of-stock-my.vue'
              ),
            name: 'allocation-out-of-stock-my',
            meta: {
              title: '调拨出库申请',
              roles: [ROLES_TENANT],
              menuId: 'transfer-outbound-my'
            }
          },
          {
            path: 'allocation-out-of-stock-add',
            component: () =>
              import(
                '@/views/small-backstage/transport-management/out-of-stock-list/allocation-out-of-stock-edit'
              ),
            name: 'allocation-out-of-stock-add',
            hidden: true,
            meta: {
              title: '新增调拨出库申请',
              roles: [ROLES_TENANT],
              menuId: 'transfer-outbound-my',
              activeMenu:
                '/small/Y-OMS/non-sales-management/allocation-out-of-stock-my'
            }
          },
          {
            path: 'allocation-out-of-stock-edit',
            component: () =>
              import(
                '@/views/small-backstage/transport-management/out-of-stock-list/allocation-out-of-stock-edit'
              ),
            name: 'allocation-out-of-stock-edit',
            hidden: true,
            meta: {
              title: '编辑调拨出库申请',
              roles: [ROLES_TENANT],
              menuId: 'transfer-outbound-my',
              activeMenu:
                '/small/Y-OMS/non-sales-management/allocation-out-of-stock-my'
            }
          },
          {
            path: 'allocation-out-of-stock-my-detail',
            component: () =>
              import(
                '@/views/small-backstage/transport-management/out-of-stock-list/allocation-out-of-stock-detail'
              ),
            name: 'allocation-out-of-stock-my-detail',
            hidden: true,
            meta: {
              title: '调拨出库申请详情',
              roles: [ROLES_TENANT],
              menuId: 'transfer-outbound-my',
              activeMenu:
                '/small/Y-OMS/non-sales-management/allocation-out-of-stock-my'
            }
          },
          {
            path: 'return-order-management',
            component: () =>
              import(
                '@/views/small-backstage/oms-order-management/return-order-management/index'
              ),
            name: 'return-order-management',
            meta: {
              title: '退货申请',
              roles: [ROLES_TENANT],
              menuId: 'return-goods-management'
            }
          },
          {
            path: 'return-order-management-add',
            component: () =>
              import(
                '@/views/small-backstage/oms-order-management/return-order-management/ReturnOrderEditor.vue'
              ),
            name: 'return-order-management-add',
            hidden: true,
            meta: {
              title: '新建退货申请',
              roles: [ROLES_TENANT],
              menuId: 'return-goods-management',
              activeMenu:
                '/small/Y-OMS/non-sales-management/return-order-management'
            }
          },
          {
            path: 'return-order-management-editor',
            component: () =>
              import(
                '@/views/small-backstage/oms-order-management/return-order-management/ReturnOrderEditor.vue'
              ),
            name: 'return-order-management-editor',
            hidden: true,
            meta: {
              title: '编辑退货申请',
              roles: [ROLES_TENANT],
              menuId: 'return-goods-management',
              activeMenu:
                '/small/Y-OMS/non-sales-management/return-order-management'
            }
          },
          {
            path: 'return-order-management-detail',
            component: () =>
              import(
                '@/views/small-backstage/oms-order-management/return-order-management/ReturnOrderDetail.vue'
              ),
            name: 'return-order-management-detail',
            hidden: true,
            meta: {
              title: '退货申请详情页',
              roles: [ROLES_TENANT],
              menuId: 'return-goods-management',
              activeMenu:
                '/small/Y-OMS/non-sales-management/return-order-management'
            }
          },
          {
            path: 'return-stock-management',
            component: () =>
              import(
                '@/views/small-backstage/oms-order-management/return-stock-management/index.vue'
              ),
            name: 'return-stock-management',
            meta: {
              title: '退库申请',
              roles: [ROLES_TENANT],
              menuId: 'return-warehouse-mng'
            }
          },
          {
            path: 'return-stock-management-detail',
            component: () =>
              import(
                '@/views/small-backstage/oms-order-management/return-stock-management/ReturnStockDetail.vue'
              ),
            name: 'return-stock-management-detail',
            hidden: true,
            meta: {
              title: '退库申请详情页',
              roles: [ROLES_TENANT],
              menuId: 'return-warehouse-mng',
              activeMenu:
                '/small/Y-OMS/non-sales-management/return-stock-management'
            }
          },
          {
            path: 'return-stock-management-add',
            component: () =>
              import(
                '@/views/small-backstage/oms-order-management/return-stock-management/ReturnStockEditor.vue'
              ),
            name: 'return-stock-management-add',
            hidden: true,
            meta: {
              title: '新增退库申请',
              roles: [ROLES_TENANT],
              menuId: 'return-warehouse-mng',
              activeMenu:
                '/small/Y-OMS/non-sales-management/return-stock-management'
            }
          },
          {
            path: 'return-stock-management-editor',
            component: () =>
              import(
                '@/views/small-backstage/oms-order-management/return-stock-management/ReturnStockEditor.vue'
              ),
            name: 'return-stock-management-editor',
            hidden: true,
            meta: {
              title: '编辑退库申请',
              roles: [ROLES_TENANT],
              menuId: 'return-warehouse-mng',
              activeMenu:
                '/small/Y-OMS/non-sales-management/return-stock-management'
            }
          },
          {
            path: 'other-out-of-stock-my',
            component: () =>
              import(
                '@/views/small-backstage/transport-management/out-of-stock-list/other-out-of-stock-my'
              ),
            name: 'other-out-of-stock-my',
            meta: {
              title: '其他出库申请',
              roles: [ROLES_TENANT],
              menuId: 'other-outbound-my'
            }
          },
          {
            path: 'other-out-of-stock-add',
            component: () =>
              import(
                '@/views/small-backstage/transport-management/out-of-stock-list/other-out-of-stock-edit'
              ),
            name: 'other-out-of-stock-add',
            hidden: true,
            meta: {
              title: '新建其他出库申请',
              roles: [ROLES_TENANT],
              menuId: 'other-outbound-my',
              activeMenu:
                '/small/Y-OMS/non-sales-management/other-out-of-stock-my'
            }
          },
          {
            path: 'other-out-of-stock-edit',
            component: () =>
              import(
                '@/views/small-backstage/transport-management/out-of-stock-list/other-out-of-stock-edit'
              ),
            name: 'other-out-of-stock-edit',
            hidden: true,
            meta: {
              title: '编辑其他出库申请',
              roles: [ROLES_TENANT],
              menuId: 'other-outbound-my',
              activeMenu:
                '/small/Y-OMS/non-sales-management/other-out-of-stock-my'
            }
          },
          {
            path: 'other-out-of-stock-my-detail',
            component: () =>
              import(
                '@/views/small-backstage/transport-management/out-of-stock-list/other-out-of-stock-detail'
              ),
            name: 'other-out-of-stock-my-detail',
            hidden: true,
            meta: {
              title: '其他出库申请详情',
              roles: [ROLES_TENANT],
              menuId: 'other-outbound-my',
              activeMenu:
                '/small/Y-OMS/non-sales-management/other-out-of-stock-my'
            }
          },
          {
            path: 'transfer-in-stock-my',
            component: () =>
              import(
                '@/views/small-backstage/transport-management/in-stock/transfer-in-stock/index-my'
              ),
            name: 'transfer-in-stock-my',
            meta: {
              title: '其他入库申请',
              roles: [ROLES_TENANT],
              menuId: 'warehouse-transfer-my-view-management'
            }
          },
          {
            path: 'transfer-in-stock-my-detail',
            component: () =>
              import(
                '@/views/small-backstage/transport-management/in-stock/transfer-in-stock/detail'
              ),
            name: 'transfer-in-stock-my-detail',
            hidden: true,
            meta: {
              title: '其他入库申请详情',
              roles: [ROLES_TENANT],
              menuId: 'warehouse-transfer-my-view-management',
              activeMenu:
                '/small/Y-OMS/non-sales-management/transfer-in-stock-my'
            }
          },
          {
            path: 'transfer-in-stock-add',
            component: () =>
              import(
                '@/views/small-backstage/transport-management/in-stock/transfer-in-stock/create'
              ),
            name: 'transfer-in-stock-add',
            hidden: true,
            meta: {
              title: '新建其他入库申请',
              roles: [ROLES_TENANT],
              menuId: 'warehouse-transfer-my-view-management',
              activeMenu:
                '/small/Y-OMS/non-sales-management/transfer-in-stock-my'
            }
          },
          {
            path: 'transfer-in-stock-create',
            component: () =>
              import(
                '@/views/small-backstage/transport-management/in-stock/transfer-in-stock/create'
              ),
            name: 'transfer-in-stock-create',
            hidden: true,
            meta: {
              title: '编辑其他入库申请',
              roles: [ROLES_TENANT],
              menuId: 'warehouse-transfer-my-view-management',
              activeMenu:
                '/small/Y-OMS/non-sales-management/transfer-in-stock-my'
            }
          }
        ]
      },
      // 发票管理
      {
        path: 'oms-invoice-management',
        component: { render: (e) => e('router-view') },
        name: 'oms-invoice-management',
        meta: {
          title: '发票管理',
          roles: [ROLES_TENANT],
          menuId: 'invoice-management'
        },
        children: [
          {
            path: 'oms-invoice-application-management',
            component: () =>
              import(
                '@/views/small-backstage/oms-invoice-management/invoice-application/index.vue'
              ),
            name: 'oms-invoice-application-management',
            meta: {
              title: '发票申请',
              roles: [ROLES_TENANT],
              menuId: 'invoice-apply-management'
            }
          },
          // 开票申请
          {
            path: 'oms-invoice-application-create',
            component: () =>
              import(
                '@/views/small-backstage/oms-invoice-management/invoice-application/create.vue'
              ),
            name: 'oms-invoice-application-create',
            hidden: true,
            meta: {
              title: '开票申请',
              roles: [ROLES_TENANT],
              menuId: 'invoice-apply-management',
              activeMenu:
                '/small/Y-OMS/oms-invoice-management/oms-invoice-application-management'
            }
          },
          // 详情页
          {
            path: 'oms-invoice-application-detail',
            component: () =>
              import(
                '@/views/small-backstage/oms-invoice-management/invoice-application/detail.vue'
              ),
            name: 'oms-invoice-application-detail',
            hidden: true,
            meta: {
              title: '开票申请详情',
              roles: [ROLES_TENANT],
              menuId: 'invoice-apply-management',
              activeMenu:
                '/small/Y-OMS/oms-invoice-management/oms-invoice-application-management'
            }
          },
          {
            path: 'oms-invoice-issuance-management',
            component: () =>
              import(
                '@/views/small-backstage/oms-invoice-management/invoice-issuance/index.vue'
              ),
            name: 'oms-invoice-issuance-management',
            meta: {
              title: '开票管理',
              roles: [ROLES_TENANT],
              menuId: 'invoicing-management'
            }
          },
          // 详情页
          {
            path: 'oms-invoice-issuance-detail',
            component: () =>
              import(
                '@/views/small-backstage/oms-invoice-management/invoice-issuance/detail.vue'
              ),
            name: 'oms-invoice-issuance-detail',
            hidden: true,
            meta: {
              title: '详情',
              roles: [ROLES_TENANT],
              menuId: 'invoicing-management',
              activeMenu:
                '/small/Y-OMS/oms-invoice-management/oms-invoice-issuance-management'
            }
          }
        ]
      },
      {
        path: 'oms-adjustment-management',
        component: { render: (e) => e('router-view') },
        name: 'oms-adjustment-management',
        meta: {
          title: '调价管理',
          roles: [ROLES_TENANT],
          menuId: 'oms-adjustment-management'
        },
        children: [
          {
            path: 'oms-adjustment-application-management',
            component: () =>
              import(
                '@/views/small-backstage/oms-invoice-management/adjustment-application/index.vue'
              ),
            name: 'oms-adjustment-application-management',
            meta: {
              title: '调价单申请',
              roles: [ROLES_TENANT],
              menuId: 'adjustment-apply-management'
            }
          },
          {
            path: 'oms-adjustment-application-create',
            component: () =>
              import(
                '@/views/small-backstage/oms-invoice-management/adjustment-application/create.vue'
              ),
            name: 'oms-adjustment-application-create',
            hidden: true,
            meta: {
              title: '新建调价单申请',
              roles: [ROLES_TENANT],
              menuId: 'adjustment-apply-management',
              activeMenu:
                '/small/Y-OMS/oms-invoice-management/oms-adjustment-management'
            }
          },
          {
            path: 'oms-adjustment-application-detail',
            component: () =>
              import(
                '@/views/small-backstage/oms-invoice-management/adjustment-application/detail.vue'
              ),
            name: 'oms-adjustment-application-detail',
            hidden: true,
            meta: {
              title: '调价单申请详情',
              roles: [ROLES_TENANT],
              menuId: 'adjustment-apply-management',
              activeMenu:
                '/small/Y-OMS/oms-invoice-management/oms-adjustment-management'
            }
          }
        ]
      },

      {
        path: 'system-settings',
        component: { render: (e) => e('router-view') },
        name: 'system-settings',
        meta: {
          title: '系统设置',
          roles: [ROLES_TENANT],
          menuId: 'system-setting'
        },
        children: [
          {
            path: 'warehouse-management',
            component: () =>
              import('@/views/small-backstage/warehouse-management/index.vue'),
            name: 'warehouse-management',
            meta: {
              title: '仓库管理',
              roles: [ROLES_TENANT],
              menuId: 'warehouse'
            }
          },
          {
            path: 'warehouse-management-detail',
            component: () =>
              import('@/views/small-backstage/warehouse-management/detail.vue'),
            name: 'warehouse-management-detail',
            hidden: true,
            meta: {
              title: '仓库详情',
              roles: [ROLES_TENANT],
              menuId: 'warehouse',
              activeMenu: '/small/Y-OMS/system-settings/warehouse-management'
            }
          },
          {
            path: 'warehouse-management-create',
            component: () =>
              import('@/views/small-backstage/warehouse-management/create.vue'),
            name: 'warehouse-management-create',
            hidden: true,
            meta: {
              title: '新建仓库',
              roles: [ROLES_TENANT],
              menuId: 'warehouse',
              activeMenu: '/small/Y-OMS/system-settings/warehouse-management'
            }
          },
          {
            path: 'warehouse-management-edit',
            component: () =>
              import('@/views/small-backstage/warehouse-management/create.vue'),
            name: 'warehouse-management-edit',
            hidden: true,
            meta: {
              title: '编辑仓库',
              roles: [ROLES_TENANT],
              menuId: 'warehouse',
              activeMenu: '/small/Y-OMS/system-settings/warehouse-management'
            }
          },
          {
            path: 'distribution-org-management',
            component: () =>
              import(
                '@/views/small-backstage/distribution-org-management/index.vue'
              ),
            name: 'distribution-org-management',
            meta: {
              title: '配送单位管理',
              roles: [ROLES_TENANT],
              menuId: 'delivery-company'
            }
          },
          {
            path: 'distribution-org-detail',
            component: () =>
              import(
                '@/views/small-backstage/distribution-org-management/detail.vue'
              ),
            name: 'distribution-org-detail',
            hidden: true,
            meta: {
              title: '配送单位详情',
              roles: [ROLES_TENANT],
              menuId: 'delivery-company',
              activeMenu:
                '/small/Y-OMS/system-settings/distribution-org-management'
            }
          },
          {
            path: 'distribution-org-create',
            component: () =>
              import(
                '@/views/small-backstage/distribution-org-management/create.vue'
              ),
            name: 'distribution-org-create',
            hidden: true,
            meta: {
              title: '新建配送单位',
              roles: [ROLES_TENANT],
              menuId: 'delivery-company',
              activeMenu:
                '/small/Y-OMS/system-settings/distribution-org-management'
            }
          },
          {
            path: 'distribution-org-edit',
            component: () =>
              import(
                '@/views/small-backstage/distribution-org-management/create.vue'
              ),
            name: 'distribution-org-edit',
            hidden: true,
            meta: {
              title: '编辑配送单位',
              roles: [ROLES_TENANT],
              menuId: 'delivery-company',
              activeMenu:
                '/small/Y-OMS/system-settings/distribution-org-management'
            }
          },
          {
            path: 'warehouse-set',
            component: () =>
              import('@/views/small-backstage/oms-set/warehouse-set/index'),
            name: 'warehouse-set',
            meta: {
              title: '仓库设置',
              roles: [ROLES_TENANT],
              menuId: 'warehouse-set'
            }
          },
          {
            path: 'verification-set',
            component: () =>
              import('@/views/small-backstage/oms-set/verification-set/index'),
            name: 'verification-set',
            meta: {
              title: '审批设置',
              roles: [ROLES_TENANT],
              menuId: 'approval-set'
            }
          },
          {
            path: 'notifications-set',
            component: () =>
              import('@/views/small-backstage/oms-set/notifications-set/index'),
            name: 'notifications-set',
            meta: {
              title: '通知设置',
              roles: [ROLES_TENANT],
              menuId: 'notifications-set'
            }
          },
          {
            path: 'bid-price-management',
            component: () =>
              import(
                '@/views/small-backstage/oms-price-management/bid-price-management/index'
              ),
            name: 'bid-price-management',
            meta: {
              title: '中标价管理',
              roles: [ROLES_TENANT],
              menuId: 'bid-price'
            }
          },
          {
            path: 'bid-price-management-create',
            component: () =>
              import(
                '@/views/small-backstage/oms-price-management/bid-price-management/create.vue'
              ),
            name: 'bid-price-management-create',
            hidden: true,
            meta: {
              title: '新建中标价',
              roles: [ROLES_TENANT],
              menuId: 'bid-price',
              activeMenu: '/small/Y-OMS/system-settings/bid-price-management'
            }
          },
          {
            path: 'bid-price-management-edit',
            component: () =>
              import(
                '@/views/small-backstage/oms-price-management/bid-price-management/create.vue'
              ),
            name: 'bid-price-management-edit',
            hidden: true,
            meta: {
              title: '编辑中标价',
              roles: [ROLES_TENANT],
              menuId: 'bid-price',
              activeMenu: '/small/Y-OMS/system-settings/bid-price-management'
            }
          },
          {
            path: 'bid-price-management-detail',
            component: () =>
              import(
                '@/views/small-backstage/oms-price-management/bid-price-management/detail'
              ),
            name: 'bid-price-management-detail',
            hidden: true,
            meta: {
              title: '中标价详情',
              roles: [ROLES_TENANT],
              menuId: 'bid-price',
              activeMenu: '/small/Y-OMS/system-settings/bid-price-management'
            }
          },
          {
            path: 'bid-price-query',
            component: () =>
              import(
                '@/views/small-backstage/oms-price-management/bid-price-management/detailQuery.vue'
              ),
            name: 'bid-price-query',
            meta: {
              title: '中标价明细查询',
              roles: [ROLES_TENANT],
              menuId: 'bid-price-detail'
            }
          },
          {
            path: 'manufacturer-management',
            component: () =>
              import('@/views/small-backstage/manufacturer-management/index'),
            name: 'manufacturer-management',
            meta: {
              title: '生产厂家管理',
              roles: [ROLES_TENANT],
              menuId: 'manufacturer-management'
            }
          }
        ]
      },
      // 预算管理
      {
        path: '/small/budget-management',
        component: { render: (e) => e('router-view') },
        name: 'budget-management',
        meta: {
          title: '预算管理',
          roles: [ROLES_TENANT],
          menuId: 'oms-agency-budget'
        },
        children: [
          {
            path: 'budget-pool',
            component: () =>
              import('@/views/small-backstage/budget-management/budget-pool'),
            name: 'budget-pool',
            meta: {
              title: '预算池',
              roles: [ROLES_TENANT],
              menuId: 'oms-budget-pool-management'
            }
          },
          {
            path: 'market-budget-management',
            component: () =>
              import(
                '@/views/small-backstage/budget-management/market-budget-management'
              ),
            name: 'market-budget-management',
            meta: {
              title: '市场预算',
              roles: [ROLES_TENANT],
              menuId: 'oms-agency-budget-province'
            }
          },
          {
            path: 'regional-budget-management',
            component: () =>
              import(
                '@/views/small-backstage/budget-management/regional-budget-management'
              ),
            name: 'regional-budget-management',
            meta: {
              title: '区域预算',
              roles: [ROLES_TENANT],
              menuId: 'oms-agency-budget-province-agency'
            }
          },
          {
            path: 'service-provider-area-budget-details',
            component: () =>
              import(
                '@/views/small-backstage/budget-management/service-provider-budget-details/details'
              ),
            name: 'service-provider-area-budget-details',
            hidden: true,
            meta: {
              title: '服务商预算详情',
              roles: [ROLES_TENANT],
              menuId: 'oms-agency-budget-province-agency',
              hidden: true,
              activeMenu: '/small/budget-management/regional-budget-management'
            }
          },
          {
            path: 'service-provider-budget-details',
            component: () =>
              import(
                '@/views/small-backstage/budget-management/service-provider-budget-details/details'
              ),
            name: 'service-provider-budget-details',
            hidden: true,
            meta: {
              title: '服务商预算详情',
              roles: [ROLES_TENANT],
              menuId: 'oms-agency-budget-province-agency',
              hidden: true,
              activeMenu:
                '/small/budget-management/service-provider-budget-management'
            }
          },
          {
            path: 'service-provider-budget-management',
            component: () =>
              import(
                '@/views/small-backstage/budget-management/service-provider-budget-management'
              ),
            name: 'service-provider-budget-management',
            meta: {
              title: '服务商预算',
              roles: [ROLES_TENANT],
              menuId: 'oms-agency-budget-agency'
            }
          },
          {
            path: 'service-provider-execution-details',
            component: () =>
              import(
                '@/views/small-backstage/budget-management/service-provider-execution-details'
              ),
            name: 'oms-agency-budget-summary-select',
            meta: {
              title: '预算综合查询', // 服务商执行明细
              roles: [ROLES_TENANT],
              menuId: 'oms-agency-budget-summary-select'
            }
          },
          {
            path: 'service-provider-execution-records',
            component: () =>
              import(
                '@/views/small-backstage/budget-management/service-provider-execution-records'
              ),
            name: 'service-provider-execution-records',
            meta: {
              title: '服务商执行记录',
              roles: [ROLES_TENANT],
              menuId: 'oms-agency-budget-summary-task-select'
            }
          },
          {
            path: 'service-provider-execution-records-approval-detail',
            component: () =>
              import(
                '@/views/small-backstage/budget-management/service-provider-execution-records/approval.vue'
              ),
            name: 'service-provider-execution-records-approval-detail',
            hidden: true,
            meta: {
              title: '详情', // 服务商执行记录-详情
              roles: [ROLES_TENANT],
              menuId: 'oms-agency-budget-summary-task-select',
              activeMenu:
                '/small/budget-management/service-provider-execution-records'
            }
          },
          {
            path: 'financial-settlement-approval',
            component: () =>
              import(
                '@/views/small-backstage/budget-management/financial-settlement-approval'
              ),
            name: 'financial-settlement-approval',
            meta: {
              title: '财务结算审批',
              roles: [ROLES_TENANT],
              menuId: 'oms-agency-budget-finance'
            }
          },
          {
            path: 'financial-settlement-approval-details',
            component: () =>
              import(
                '@/views/small-backstage/budget-management/financial-settlement-approval/detail.vue'
              ),
            name: 'financial-settlement-approval-details',
            hidden: true,
            meta: {
              title: '财务结算审批详情',
              roles: [ROLES_TENANT],
              menuId: 'oms-agency-budget-finance',
              hidden: true,
              activeMenu:
                '/small/budget-management/financial-settlement-approval'
            }
          }
        ]
      },

      {
        path: 'agency-special-rewards-deductions',
        component: { render: (e) => e('router-view') },
        name: 'agency-special-rewards-deductions',
        meta: {
          title: '服务商特殊奖励和罚扣',
          roles: [ROLES_TENANT],
          menuId: 'agency-special-rewards-deductions'
        },
        children: [
          {
            path: 'type-management',
            component: () =>
              import(
                '@/views/small-backstage/oms-service-task-management/agency-special-rewards-deductions/type-management'
              ),
            name: 'special-rewards-deductions-type-management',
            meta: {
              title: '特殊奖励和罚扣类型',
              roles: [ROLES_TENANT],
              menuId: 'special-rewards-deductions-type-management'
            }
          },
          {
            path: 'records-management',
            component: () =>
              import(
                '@/views/small-backstage/oms-service-task-management/agency-special-rewards-deductions/records-management'
              ),
            name: 'special-rewards-deductions-records-management',
            meta: {
              title: '特殊奖励和罚扣记录',
              roles: [ROLES_TENANT],
              menuId: 'special-rewards-deductions-records-management'
            }
          },
          {
            path: 'records-management-details',
            component: () =>
              import(
                '@/views/small-backstage/oms-service-task-management/agency-special-rewards-deductions/records-management/records-management-details'
              ),
            name: 'special-rewards-deductions-records-details',
            hidden: true,
            meta: {
              title: '特殊奖励和罚扣记录详情',
              roles: [ROLES_TENANT],
              menuId: 'special-rewards-deductions-records-management',
              activeMenu:
                '/small/Y-OMS/agency-special-rewards-deductions/records-management'
            }
          }
        ]
      },
      {
        path: 'oms-price-management',
        component: { render: (e) => e('router-view') },
        name: 'oms-price-management',
        meta: {
          title: '价格管理',
          roles: [ROLES_TENANT],
          menuId: 'price-management'
        },
        children: [
          {
            path: 'return-cost-management',
            component: () =>
              import(
                '@/views/small-backstage/oms-price-management/return-cost-management/index.vue'
              ),
            name: 'return-cost-management',
            meta: {
              title: '退货成本管理',
              roles: [ROLES_TENANT],
              menuId: 'return-goods-cost-management'
            }
          },
          {
            path: 'return-cost-management-create',
            component: () =>
              import(
                '@/views/small-backstage/oms-price-management/return-cost-management/create.vue'
              ),
            name: 'return-cost-management-create',
            hidden: true,
            meta: {
              title: '新建退货成本',
              roles: [ROLES_TENANT],
              menuId: 'return-goods-cost-management',
              activeMenu:
                '/small/Y-OMS/oms-price-management/return-cost-management'
            }
          },
          {
            path: 'return-cost-management-detail',
            component: () =>
              import(
                '@/views/small-backstage/oms-price-management/return-cost-management/detail.vue'
              ),
            name: 'return-cost-management-detail',
            hidden: true,
            meta: {
              title: '退货成本详情',
              roles: [ROLES_TENANT],
              menuId: 'return-goods-cost-management',
              activeMenu:
                '/small/Y-OMS/oms-price-management/return-cost-management'
            }
          },
          // 7.168 销毁成本管理
          {
            path: 'destroy-cost-management',
            component: () =>
              import(
                '@/views/small-backstage/oms-price-management/destroy-cost-management/index.vue'
              ),
            name: 'destroy-cost-management',
            meta: {
              title: '销毁成本管理',
              roles: [ROLES_TENANT],
              menuId: 'destroy-cost-management'
            }
          },
          {
            path: 'destroy-cost-management-detail',
            component: () =>
              import(
                '@/views/small-backstage/oms-price-management/destroy-cost-management/detail.vue'
              ),
            name: 'destroy-cost-management-detail',
            hidden: true,
            meta: {
              title: '销毁成本详情',
              roles: [ROLES_TENANT],
              menuId: 'destroy-cost-management',
              activeMenu:
                '/small/Y-OMS/oms-price-management/destroy-cost-management'
            }
          },
          {
            path: 'destroy-cost-management-create',
            component: () =>
              import(
                '@/views/small-backstage/oms-price-management/destroy-cost-management/create.vue'
              ),
            name: 'destroy-cost-management-create',
            hidden: true,
            meta: {
              title: '新建销毁成本',
              roles: [ROLES_TENANT],
              menuId: 'destroy-cost-management',
              activeMenu:
                '/small/Y-OMS/oms-price-management/destroy-cost-management'
            }
          },
          {
            path: 'consign-warehouse-delivery-fee',
            component: () =>
              import(
                '@/views/small-backstage/oms-price-management/consign-warehouse-delivery-fee/index.vue'
              ),
            name: 'consign-warehouse-delivery-fee',
            meta: {
              title: '委托仓储配送费用管理',
              roles: [ROLES_TENANT],
              menuId: 'delivery-fee-rule-finance-management'
            }
          },
          {
            path: 'consign-warehouse-delivery-fee-region-create',
            component: () =>
              import(
                '@/views/small-backstage/oms-price-management/consign-warehouse-delivery-fee/region-create.vue'
              ),
            name: 'consign-warehouse-delivery-fee-region-create',
            hidden: true,
            meta: {
              title: '新建委托仓储配送费',
              roles: [ROLES_TENANT],
              menuId: 'delivery-fee-rule-finance-management',
              activeMenu:
                '/small/Y-OMS/oms-price-management/consign-warehouse-delivery-fee'
            }
          },
          {
            path: 'consign-warehouse-delivery-fee-region-edit',
            component: () =>
              import(
                '@/views/small-backstage/oms-price-management/consign-warehouse-delivery-fee/region-create.vue'
              ),
            name: 'consign-warehouse-delivery-fee-region-edit',
            hidden: true,
            meta: {
              title: '编辑委托仓储配送费',
              roles: [ROLES_TENANT],
              menuId: 'delivery-fee-rule-finance-management',
              activeMenu:
                '/small/Y-OMS/oms-price-management/consign-warehouse-delivery-fee'
            }
          },
          {
            path: 'consign-warehouse-delivery-fee-trunk-create',
            component: () =>
              import(
                '@/views/small-backstage/oms-price-management/consign-warehouse-delivery-fee/trunk-create.vue'
              ),
            name: 'consign-warehouse-delivery-fee-trunk-create',
            hidden: true,
            meta: {
              title: '新建委托仓储配送费',
              roles: [ROLES_TENANT],
              menuId: 'delivery-fee-rule-finance-management',
              activeMenu:
                '/small/Y-OMS/oms-price-management/consign-warehouse-delivery-fee'
            }
          },
          {
            path: 'consign-warehouse-delivery-fee-trunk-edit',
            component: () =>
              import(
                '@/views/small-backstage/oms-price-management/consign-warehouse-delivery-fee/trunk-create.vue'
              ),
            name: 'consign-warehouse-delivery-fee-trunk-edit',
            hidden: true,
            meta: {
              title: '编辑委托仓储配送费',
              roles: [ROLES_TENANT],
              menuId: 'delivery-fee-rule-finance-management',
              activeMenu:
                '/small/Y-OMS/oms-price-management/consign-warehouse-delivery-fee'
            }
          }
        ]
      },
      // 特殊流向管理父级菜单
      {
        path: 'special-flow',
        component: { render: (e) => e('router-view') },
        name: 'special-flow',
        meta: {
          title: '特殊流向管理',
          roles: [ROLES_TENANT],
          menuId: 'special-flow-management'
        },
        children: [
          // 特殊流向管理列表
          {
            path: 'special-flow-management',
            component: () =>
              import(
                '@/views/small-backstage/special-flow/special-flow-management/index.vue'
              ),
            name: 'special-flow-management',
            meta: {
              title: '特殊流向管理',
              roles: [ROLES_TENANT],
              menuId: 'special-flow-management-2'
            }
          },
          // 特殊流向申请列表
          {
            path: 'special-flow-application',
            component: () =>
              import(
                '@/views/small-backstage/special-flow/special-flow-application/index.vue'
              ),
            name: 'special-flow-application',
            meta: {
              title: '特殊流向申请',
              roles: [ROLES_TENANT],
              menuId: 'special-flow-appeal-management'
            }
          },
          // 服务商结算变更申请（隐藏菜单）
          {
            path: 'provider-settlement-change',
            component: () =>
              import(
                '@/views/small-backstage/special-flow/special-flow-management/provider-settlement-change.vue'
              ),
            name: 'provider-settlement-change',
            hidden: true,
            meta: {
              title: '服务商结算变更申请',
              roles: [ROLES_TENANT],
              menuId: 'special-flow-management-2',
              activeMenu: '/small/Y-OMS/special-flow/special-flow-management'
            }
          },
          {
            path: 'manager-change',
            component: () =>
              import(
                '@/views/small-backstage/special-flow/special-flow-management/manager-change.vue'
              ),
            name: 'manager-change',
            hidden: true,
            meta: {
              title: '省区经理对象变更申请',
              roles: [ROLES_TENANT],
              menuId: 'special-flow-management-2',
              activeMenu: '/small/Y-OMS/special-flow/special-flow-management'
            }
          },
          {
            path: 'special-flow-application-detail',
            component: () =>
              import(
                '@/views/small-backstage/special-flow/special-flow-application/detail.vue'
              ),
            name: 'special-flow-application-detail',
            hidden: true,
            meta: {
              title: '特殊流向申请详情',
              roles: [ROLES_TENANT],
              menuId: 'special-flow-appeal-management',
              activeMenu: '/small/Y-OMS/special-flow/special-flow-application'
            }
          }
        ]
      },

      // 指标管理
      {
        path: 'indicator-management',
        component: { render: (e) => e('router-view') },
        name: 'indicator-management',
        meta: {
          title: '指标管理',
          roles: [ROLES_TENANT],
          menuId: 'oms-indicator'
        },
        children: [
          // 服务商指标管理
          {
            path: 'service-provider-indicator-management',
            component: { render: (e) => e('router-view') },
            name: 'service-provider-indicator-management',
            meta: {
              title: '服务商指标管理',
              roles: [ROLES_TENANT],
              menuId: 'agency-indicator-manager'
            },
            children: [
              {
                path: 'service-provider-indicator-query',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-indicator-management/service-provider-indicator-query/index.vue'
                  ),
                name: 'service-provider-indicator-query',
                meta: {
                  title: '服务商签约指标查询',
                  roles: [ROLES_TENANT],
                  menuId: 'agency-signed-indicator-mng'
                }
              },
              {
                path: 'service-provider-indicator',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-indicator-management/service-provider-indicator/index.vue'
                  ),
                name: 'service-provider-indicator',
                meta: {
                  title: '服务商指标管理',
                  roles: [ROLES_TENANT],
                  menuId: 'agency-indicator-mng'
                }
              },
              {
                path: 'service-provider-indicator-detail-query',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-indicator-management/service-provider-indicator-detail-query/index.vue'
                  ),
                name: 'service-provider-indicator-detail-query',
                meta: {
                  title: '服务商指标明细查询',
                  roles: [ROLES_TENANT],
                  menuId: 'agency-indicator-detail-mng'
                }
              }
            ]
          },
          {
            path: 'district-indicator',
            component: { render: (e) => e('router-view') },
            name: 'district-indicator',
            meta: {
              title: '区县指标管理',
              roles: [ROLES_TENANT],
              menuId: 'oms-indicator-county'
            },
            children: [
              {
                path: 'district-indicator-management',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-indicator-management/district-indicator/index.vue'
                  ),
                name: 'district-indicator-management',
                meta: {
                  title: '区县指标管理',
                  roles: [ROLES_TENANT],
                  menuId: 'oms-indicator-county-all'
                }
              },
              {
                path: 'district-indicator-adjustment',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-indicator-management/district-indicator-adjustment/index.vue'
                  ),
                name: 'district-indicator-adjustment',
                meta: {
                  title: '区县指标调整',
                  roles: [ROLES_TENANT],
                  menuId: 'oms-indicator-county-region'
                }
              },
              // 区县指标调整记录
              {
                path: 'district-indicator-adjustment-record',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-indicator-management/district-indicator-record-adjustment/index.vue'
                  ),
                name: 'district-indicator-adjustment-record',
                meta: {
                  title: '区县指标调整记录',
                  roles: [ROLES_TENANT],
                  menuId: 'oms-indicator-county-record'
                }
              },
              // 区县指标审批详情
              {
                path: 'district-indicator-adjustment-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-indicator-management/district-indicator-record-adjustment/detail.vue'
                  ),
                name: 'district-indicator-adjustment-detail',
                hidden: true,
                meta: {
                  title: '区县指标审批详情',
                  roles: [ROLES_TENANT],
                  menuId: 'oms-indicator-county-record',
                  activeMenu:
                    '/small/Y-OMS/indicator-management/district-indicator/district-indicator-adjustment-record'
                }
              },
              // 区县指标查询
              {
                path: 'district-indicator-query',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-indicator-management/district-indicator-query/index.vue'
                  ),
                name: 'district-indicator-query',
                meta: {
                  title: '区县指标查询',
                  roles: [ROLES_TENANT],
                  menuId: 'oms-indicator-county-query'
                }
              }
            ]
          },
          {
            path: 'province-indicator',
            component: { render: (e) => e('router-view') },
            name: 'province-indicator',
            meta: {
              title: '省区经理指标管理',
              roles: [ROLES_TENANT],
              menuId: 'oms-indicator-province-region'
            },
            children: [
              {
                path: 'province-indicator-management',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-indicator-management/province-indicator/index.vue'
                  ),
                name: 'province-indicator-management',
                meta: {
                  title: '省区经理指标管理',
                  roles: [ROLES_TENANT],
                  menuId: 'oms-indicator-province-region-sub'
                }
              },
              // 省区经理指标调整记录
              {
                path: 'province-indicator-adjustment-record',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-indicator-management/province-indicator-record-adjustment/index.vue'
                  ),
                name: 'province-indicator-adjustment-record',
                meta: {
                  title: '省区经理指标调整记录',
                  roles: [ROLES_TENANT],
                  menuId: 'oms-indicator-province-region-record'
                }
              },
              // 省区经理指标审批详情
              {
                path: 'province-indicator-adjustment-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-indicator-management/province-indicator-record-adjustment/detail.vue'
                  ),
                name: 'province-indicator-adjustment-detail',
                hidden: true,
                meta: {
                  title: '省区经理指标审批详情',
                  roles: [ROLES_TENANT],
                  menuId: 'oms-indicator-province-region-record',
                  activeMenu:
                    '/small/Y-OMS/indicator-management/province-indicator/province-indicator-adjustment-record'
                }
              },
              // 省区经理指标查询
              {
                path: 'province-indicator-query',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-indicator-management/province-indicator-query/index.vue'
                  ),
                name: 'province-indicator-query',
                meta: {
                  title: '省区经理指标查询',
                  roles: [ROLES_TENANT],
                  menuId: 'oms-indicator-province-region-query'
                }
              }
            ]
          }
        ]
      },
      {
        path: 'market-guardian-management',
        component: { render: (e) => e('router-view') },
        name: 'market-guardian-management',
        meta: {
          title: '保证金管理',
          roles: [ROLES_TENANT],
          menuId: 'market-margin-manager'
        },
        children: [
          {
            path: 'service-provider-guardian-query',
            component: () =>
              import(
                '@/views/small-backstage/oms-market-guardian-management/service-provider-guardian-query/index.vue'
              ),
            name: 'service-provider-guardian-query',
            meta: {
              title: '市场保证金查询',
              roles: [ROLES_TENANT],
              menuId: 'agency-margin-manager'
            }
          },
          {
            path: 'market-guardian-refund-apply',
            component: () =>
              import(
                '@/views/small-backstage/oms-market-guardian-management/market-guardian-refund-apply/index.vue'
              ),
            name: 'market-guardian-refund-apply',
            meta: {
              title: '市场保证金退款申请',
              roles: [ROLES_TENANT],
              menuId: 'market-margin-refund-apply'
            }
          },
          {
            path: 'market-guardian-refund-apply-editor',
            component: () =>
              import(
                '@/views/small-backstage/oms-market-guardian-management/market-guardian-refund-apply/editor.vue'
              ),
            name: 'market-guardian-refund-apply-editor',
            hidden: true,
            meta: {
              title: '市场保证金退款申请新建',
              roles: [ROLES_TENANT],
              menuId: 'market-margin-refund-apply',
              activeMenu:
                '/small/Y-OMS/market-guardian-management/market-guardian-refund-apply'
            }
          },
          {
            path: 'market-guardian-refund-apply-detail',
            component: () =>
              import(
                '@/views/small-backstage/oms-market-guardian-management/market-guardian-refund-apply/detail.vue'
              ),
            name: 'market-guardian-refund-apply-detail',
            hidden: true,
            meta: {
              title: '市场保证金退款申请详情',
              roles: [ROLES_TENANT],
              menuId: 'market-margin-refund-apply',
              activeMenu:
                '/small/Y-OMS/market-guardian-management/market-guardian-refund-apply'
            }
          }
        ]
      },
      // 财务管理
      {
        path: 'warehouse-finance-management',
        component: { render: (e) => e('router-view') },
        name: 'warehouse-finance-management',
        meta: {
          title: '财务管理',
          roles: [ROLES_TENANT],
          menuId: 'warehouse-finance-management'
        },
        children: [
          {
            path: 'flow-expense-detail',
            component: () =>
              import('@/views/small-backstage/flow-expense-detail/index'),
            name: 'flow-expense-detail',
            meta: {
              title: '流向费用明细',
              roles: [ROLES_TENANT],
              menuId: 'flow-payment-goods-management'
            }
          },
          {
            path: 'flow-expense-detail-detail',
            component: () =>
              import('@/views/small-backstage/flow-expense-detail/detail.vue'),
            name: 'flow-expense-detail-detail',
            hidden: true,
            meta: {
              title: '流向费用明细详情',
              roles: [ROLES_TENANT],
              menuId: 'flow-payment-goods-management'
            }
          },
          // 7.168 CDC储运费明细
          {
            path: 'cdc-order-warehouse-delivery-fee-management',
            component: () =>
              import(
                '@/views/small-backstage/oms-price-management/cdc-order-warehouse-delivery-fee/index.vue'
              ),
            name: 'cdc-order-warehouse-delivery-fee-management',
            meta: {
              title: 'CDC储运费明细',
              roles: [ROLES_TENANT],
              menuId: 'cdc-storage-transport-fee-detail'
            }
          },
          // 7.168 效期外CDC储运费申请
          {
            path: 'expired-cdc-warehouse-delivery-fee-application',
            component: () =>
              import(
                '@/views/small-backstage/warehouse-finance-management/expired-cdc-warehouse-delivery-fee-application/index.vue'
              ),
            name: 'expired-cdc-warehouse-delivery-fee-application',
            meta: {
              title: '效期外CDC储运费申请',
              roles: [ROLES_TENANT],
              menuId: 'expired-cdc-storage-transport-fee-apply'
            }
          },
          {
            path: 'expired-cdc-warehouse-delivery-fee-application-create',
            component: () =>
              import(
                '@/views/small-backstage/warehouse-finance-management/expired-cdc-warehouse-delivery-fee-application/create.vue'
              ),
            name: 'expired-cdc-warehouse-delivery-fee-application-create',
            hidden: true,
            meta: {
              title: '新建和编辑效期外CDC储运费申请',
              roles: [ROLES_TENANT],
              menuId: 'expired-cdc-storage-transport-fee-apply',
              activeMenu:
                '/small/Y-OMS/warehouse-finance-management/expired-cdc-warehouse-delivery-fee-application'
            }
          },
          {
            path: 'expired-cdc-warehouse-delivery-fee-application-detail',
            component: () =>
              import(
                '@/views/small-backstage/warehouse-finance-management/expired-cdc-warehouse-delivery-fee-application/detail.vue'
              ),
            name: 'expired-cdc-warehouse-delivery-fee-application-detail',
            hidden: true,
            meta: {
              title: '效期外CDC储运费申请详情',
              roles: [ROLES_TENANT],
              menuId: 'expired-cdc-storage-transport-fee-apply',
              activeMenu:
                '/small/Y-OMS/warehouse-finance-management/expired-cdc-warehouse-delivery-fee-application'
            }
          },
          // 7.168 CDC储运费申请管理
          {
            path: 'cdc-warehouse-delivery-fee-application',
            component: () =>
              import(
                '@/views/small-backstage/warehouse-finance-management/cdc-warehouse-delivery-fee-application/index.vue'
              ),
            name: 'cdc-warehouse-delivery-fee-application',
            meta: {
              title: 'CDC储运费申请',
              roles: [ROLES_TENANT],
              menuId: 'cdc-storage-transport-fee-apply'
            }
          },
          {
            path: 'cdc-warehouse-delivery-fee-application-create',
            component: () =>
              import(
                '@/views/small-backstage/warehouse-finance-management/cdc-warehouse-delivery-fee-application/create.vue'
              ),
            name: 'cdc-warehouse-delivery-fee-application-create',
            hidden: true,
            meta: {
              title: '新建和编辑CDC储运费申请',
              roles: [ROLES_TENANT],
              menuId: 'cdc-storage-transport-fee-apply',
              activeMenu:
                '/small/Y-OMS/warehouse-finance-management/cdc-warehouse-delivery-fee-application'
            }
          },
          {
            path: 'cdc-warehouse-delivery-fee-application-detail',
            component: () =>
              import(
                '@/views/small-backstage/warehouse-finance-management/cdc-warehouse-delivery-fee-application/detail.vue'
              ),
            name: 'cdc-warehouse-delivery-fee-application-detail',
            hidden: true,
            meta: {
              title: 'CDC储运费申请详情',
              roles: [ROLES_TENANT],
              menuId: 'cdc-storage-transport-fee-apply',
              activeMenu:
                '/small/Y-OMS/warehouse-finance-management/cdc-warehouse-delivery-fee-application'
            }
          },
          {
            path: 'warehouse-fee-management',
            component: () =>
              import(
                '@/views/small-backstage/warehouse-finance-management/warehouse-fee-management/index'
              ),
            name: 'warehouse-fee-management',
            meta: {
              title: '委托仓储配送费用',
              roles: [ROLES_TENANT],
              menuId: 'warehouse-fee-management'
            }
            // children: [
            //   {
            //     path: 'warehouse-fee-summary-management',
            //     component: () =>
            //       import(
            //         '@/views/small-backstage/warehouse-finance-management/warehouse-fee-management/index'
            //       ),
            //     name: 'warehouse-fee-summary-management',
            //     meta: {
            //       title: '费用汇总',
            //       roles: [ROLES_TENANT],
            //       menuId: 'warehouse-fee-summary-management'
            //     }
            //   },
            //   {
            //     path: 'warehouse-fee-sku-summary-management',
            //     component: () =>
            //       import(
            //         '@/views/small-backstage/warehouse-finance-management/warehouse-fee-sku-summary-management/index'
            //       ),
            //     name: 'warehouse-fee-sku-summary-management',
            //     meta: {
            //       title: '区域仓储配送费用汇总',
            //       roles: [ROLES_TENANT],
            //       menuId: 'warehouse-fee-sku-summary-management'
            //     }
            //   },
            //   {
            //     path: 'warehouse-fee-sku-detail-management',
            //     component: () =>
            //       import(
            //         '@/views/small-backstage/warehouse-finance-management/warehouse-fee-sku-detail-management/index'
            //       ),
            //     name: 'warehouse-fee-sku-detail-management',
            //     meta: {
            //       title: '区域仓储配送费用明细',
            //       roles: [ROLES_TENANT],
            //       menuId: 'warehouse-fee-sku-detail-management'
            //     }
            //   }
            // ]
          },
          {
            path: 'warehouse-fee-detail',
            component: () =>
              import(
                '@/views/small-backstage/warehouse-finance-management/warehouse-fee-detail/index'
              ),
            name: 'warehouse-fee-detail',
            hidden: true,
            meta: {
              title: '费用明细',
              roles: [ROLES_TENANT],
              menuId: 'warehouse-fee-line-detail',
              activeMenu:
                '/small/Y-OMS/warehouse-finance-management/warehouse-fee-management/warehouse-fee-summary-management'
            }
          },
          {
            path: 'pending-payment',
            component: { render: (e) => e('router-view') },
            name: 'pending-payment',
            meta: {
              title: '待支付',
              roles: [ROLES_TENANT],
              menuId: 'finance-manager-pending-pay'
            },
            children: [
              {
                path: 'pending-payment-page',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-financial-management/pending-payment/index.vue'
                  ),
                name: 'pending-payment-page',
                meta: {
                  title: '市场保证金',
                  roles: [ROLES_TENANT],
                  menuId: 'pending-pay-market-margin'
                }
              },
              // 7.168 待支付 CDC储运费
              {
                path: 'pending-payment-cdc',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-financial-management/pending-payment/pending-payment-cdc/index.vue'
                  ),
                name: 'pending-payment-cdc',
                meta: {
                  title: 'CDC储运费',
                  roles: [ROLES_TENANT],
                  menuId: 'cdc-storage-transport-fee-apply-pending-pay'
                }
              },
              {
                path: 'pending-payment-cdc-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-financial-management/pending-payment/pending-payment-cdc/detail.vue'
                  ),
                name: 'pending-payment-cdc-detail',
                hidden: true,
                meta: {
                  title: 'CDC储运费详情',
                  roles: [ROLES_TENANT],
                  menuId: 'cdc-storage-transport-fee-apply-pending-pay',
                  activeMenu:
                    '/small/Y-OMS/warehouse-finance-management/pending-payment/pending-payment-cdc'
                }
              }
            ]
          },
          {
            path: 'paid-payment',
            component: { render: (e) => e('router-view') },
            name: 'paid-payment',
            meta: {
              title: '已支付',
              roles: [ROLES_TENANT],
              menuId: 'finance-manager-pay'
            },
            children: [
              {
                path: 'paid-payment-page',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-financial-management/paid-payment/index.vue'
                  ),
                name: 'paid-payment-page',
                meta: {
                  title: '市场保证金',
                  roles: [ROLES_TENANT],
                  menuId: 'pay-market-margin'
                }
              },
              // 7.168 已支付 CDC储运费
              {
                path: 'paid-payment-cdc',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-financial-management/paid-payment/paid-payment-cdc/index.vue'
                  ),
                name: 'paid-payment-cdc',
                meta: {
                  title: 'CDC储运费',
                  roles: [ROLES_TENANT],
                  menuId: 'cdc-storage-transport-fee-apply-paid'
                }
              },
              {
                path: 'paid-payment-cdc-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-financial-management/paid-payment/paid-payment-cdc/detail.vue'
                  ),
                name: 'paid-payment-cdc-detail',
                hidden: true,
                meta: {
                  title: 'CDC储运费详情',
                  roles: [ROLES_TENANT],
                  menuId: 'cdc-storage-transport-fee-apply-paid',
                  activeMenu:
                    '/small/Y-OMS/warehouse-finance-management/paid-payment/paid-payment-cdc'
                }
              }
            ]
          },
          {
            path: 'pending-repayment',
            component: { render: (e) => e('router-view') },
            name: 'pending-repayment',
            meta: {
              title: '待回款',
              roles: [ROLES_TENANT],
              menuId: 'finance-manager-pending-received'
            },
            children: [
              {
                path: 'pending-repayment-page',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-financial-management/pending-repayment/index.vue'
                  ),
                name: 'pending-repayment-page',
                meta: {
                  title: '市场保证金',
                  roles: [ROLES_TENANT],
                  menuId: 'pending-received-market-margin'
                }
              },
              {
                path: 'pending-payment-for-goods',
                component: () =>
                  import(
                    '@/views/small-backstage/pendingPaymentForGoods/index.vue'
                  ),
                name: 'pending-payment-for-goods',
                meta: {
                  title: '货款',
                  roles: [ROLES_TENANT],
                  menuId: 'receiving-payment-goods-management'
                }
              }
            ]
          },
          {
            path: 'paid-repayment',
            component: { render: (e) => e('router-view') },
            name: 'paid-repayment',
            meta: {
              title: '已回款',
              roles: [ROLES_TENANT],
              menuId: 'finance-manager-received'
            },
            children: [
              {
                path: 'paid-repayment-page',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-financial-management/paid-repayment/index.vue'
                  ),
                name: 'paid-repayment-page',
                meta: {
                  title: '市场保证金',
                  roles: [ROLES_TENANT],
                  menuId: 'received-market-margin'
                }
              },
              {
                path: 'received-payments',
                component: () =>
                  import('@/views/small-backstage/receivedPayments/index.vue'),
                name: 'received-payments',
                meta: {
                  title: '货款',
                  roles: [ROLES_TENANT],
                  menuId: 'received-payment-goods-management'
                }
              }
            ]
          },
          {
            path: 'flow-management',
            component: { render: (e) => e('router-view') },
            name: 'flow-management',
            meta: {
              title: '流水管理',
              roles: [ROLES_TENANT],
              menuId: 'flow-payment-book-management'
            },
            children: [
              {
                path: 'payment-import-distribution',
                component: () =>
                  import(
                    '@/views/small-backstage/paymentImportDistribution/index'
                  ),
                name: 'payment-import-distribution',
                meta: {
                  title: '回款导入分配',
                  roles: [ROLES_TENANT],
                  menuId: 'receipt-flow-payment-book-import-management'
                }
              },
              {
                path: 'payment-import-distribution-edit',
                component: () =>
                  import(
                    '@/views/small-backstage/paymentImportDistribution/edit'
                  ),
                name: 'payment-import-distribution-edit',
                hidden: true,
                meta: {
                  title: '编辑回款导入分配',
                  roles: [ROLES_TENANT],
                  menuId: 'receipt-flow-payment-book-import-management'
                }
              },
              {
                path: 'payment-import-distribution-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/paymentImportDistribution/detail'
                  ),
                name: 'payment-import-distribution-detail',
                hidden: true,
                meta: {
                  title: '回款导入分配详情',
                  roles: [ROLES_TENANT],
                  menuId: 'receipt-flow-payment-book-import-management'
                }
              },
              {
                path: 'purchase-ledger',
                component: () =>
                  import('@/views/small-backstage/purchaseLedger/index'),
                name: 'purchase-ledger',
                meta: {
                  title: '货款台账',
                  roles: [ROLES_TENANT],
                  menuId: 'receipt-flow-goods-book-management'
                }
              },
              {
                path: 'market-deposit-ledger',
                component: () =>
                  import('@/views/small-backstage/marketDepositLedger/index'),
                name: 'market-deposit-ledger',
                meta: {
                  title: '市场保证金台账',
                  roles: [ROLES_TENANT],
                  menuId: 'receipt-flow-market-book-management'
                }
              }
            ]
          }
        ]
      },
      {
        path: 'oms-set',
        component: { render: (e) => e('router-view') },
        name: 'oms-set',
        meta: {
          title: 'OMS设置',
          roles: [ROLES_TENANT],
          menuId: 'OMS-set'
        },
        children: [
          // 保证金设置
          {
            path: 'margin-set',
            component: () =>
              import('@/views/small-backstage/oms-set/margin-set/index'),
            name: 'margin-set',
            meta: {
              title: '保证金设置',
              roles: [ROLES_TENANT],
              menuId: 'market-margin-config'
            }
          },
          // 订单规则设置
          {
            path: 'order-rule-set',
            component: () =>
              import(
                /* webpackChunkName: "order-rule-set" */
                '@/views/small-backstage/oms-order-management/order-rule-set/index.vue'
              ),
            name: 'order-rule-set',
            meta: {
              title: '订单规则设置',
              roles: [ROLES_TENANT],
              menuId: 'order-rule-set'
            }
          },
          // 检测费用设置
          {
            path: 'inspection-fee-set',
            component: () =>
              import(
                /* webpackChunkName: "inspection-fee-set" */
                '@/views/small-backstage/oms-order-management/inspection-fee-set/index.vue'
              ),
            name: 'inspection-fee-set',
            meta: {
              title: '退货退库设置',
              roles: [ROLES_TENANT],
              menuId: 'testing-fee-set'
            }
          }
        ]
      },
      // 报表中心
      {
        path: 'oms-report',
        component: { render: (e) => e('router-view') },
        name: 'oms-report',
        meta: {
          title: '报表中心',
          roles: [ROLES_TENANT],
          menuId: 'oms-report'
        },
        children: [
          {
            path: 'oms-report-storage-transport',
            component: { render: (e) => e('router-view') },
            name: 'oms-report-storage-transport',
            meta: {
              title: '储运报表',
              roles: [ROLES_TENANT],
              menuId: 'oms-report-storage-transport'
            },
            children: [
              // 库存汇总报表
              {
                path: 'oms-report-storage-transport-stock',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-report/storage/oms-report-storage-transport-stock/index.vue'
                  ),
                name: 'oms-report-storage-transport-stock',
                meta: {
                  title: '库存汇总报表',
                  roles: [ROLES_TENANT],
                  menuId: 'oms-report-storage-transport-stock'
                }
              },
              // 待审核订单
              {
                path: 'oms-report-pending-audit',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-report/storage/oms-report-pending-audit/index.vue'
                  ),
                name: 'oms-report-pending-audit',
                meta: {
                  title: '待审核订单',
                  roles: [ROLES_TENANT],
                  menuId: 'oms-report-pending-audit'
                }
              },
              // 待出库订单
              {
                path: 'pending-outbound-orders',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/transport-report/pending-outbound-orders/index.vue'
                  ),
                name: 'pending-outbound-orders',
                meta: {
                  title: '待出库订单',
                  roles: [ROLES_TENANT],
                  menuId: 'oms-report-pending-outbound'
                }
              },
              // 待发货订单
              {
                path: 'pending-shipment-orders',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/transport-report/pending-shipment-orders/index.vue'
                  ),
                name: 'pending-shipment-orders',
                meta: {
                  title: '待发货订单',
                  roles: [ROLES_TENANT],
                  menuId: 'oms-report-pending-delivery'
                }
              },
              // 订单流向
              {
                path: 'oms-report-order-flow',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-report/storage/oms-report-order-flow/index.vue'
                  ),
                name: 'oms-report-order-flow',
                meta: {
                  title: '订单流向表',
                  roles: [ROLES_TENANT],
                  menuId: 'oms-report-order-flow'
                }
              },
              // 批签发汇总
              {
                path: 'batch-release-summary',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/transport-report/batch-release-summary/index.vue'
                  ),
                name: 'batch-release-summary',
                meta: {
                  title: '批签发汇总',
                  roles: [ROLES_TENANT],
                  menuId: 'oms-report-batch-issue-summary'
                }
              },
              // 发运汇总
              {
                path: 'shipment-summary',
                component: () =>
                  import(
                    '@/views/small-backstage/transport-management/transport-report/shipment-summary/index.vue'
                  ),
                name: 'shipment-summary',
                meta: {
                  title: '发运汇总',
                  roles: [ROLES_TENANT],
                  menuId: 'oms-report-shipping-summary'
                }
              },
              // 储运成本报表
              {
                path: 'oms-report-storage-transport-cost',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-report/storage/oms-report-storage-transport-cost/index.vue'
                  ),
                name: 'oms-report-storage-transport-cost',
                meta: {
                  title: '储运成本报表',
                  roles: [ROLES_TENANT],
                  menuId: 'oms-report-storage-transport-cost'
                }
              },
              // 储运成本报表 - 明细
              {
                path: 'oms-report-storage-transport-cost-detail',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-report/storage/oms-report-storage-transport-cost/detail.vue'
                  ),
                name: 'oms-report-storage-transport-cost-detail',
                hidden: true,
                meta: {
                  title: '明细',
                  roles: [ROLES_TENANT],
                  menuId: 'oms-report-storage-transport-cost',
                  activeMenu:
                    '/small/Y-OMS/oms-report/oms-report-storage-transport/oms-report-storage-transport-cost'
                }
              }
            ]
          },
          {
            path: 'org-report',
            component: { render: (e) => e('router-view') },
            name: 'org-report',
            meta: {
              title: '机构报表',
              roles: [ROLES_TENANT],
              menuId: 'oms-org-bi'
            },
            children: [
              {
                path: 'admitted-status-change',
                name: 'AdmittedStatusChange',
                component: () =>
                  import(
                    '@/views/small-backstage/report/org/AdmittedStatusChange'
                  ),
                meta: {
                  title: 'NR机构状态变更',
                  roles: [ROLES_TENANT],
                  menuId: 'omg-org-bi-admitted-status-change'
                }
              },
              {
                path: 'lost',
                name: 'Lost',
                component: () =>
                  import('@/views/small-backstage/report/org/Lost'),
                meta: {
                  title: '现存流失机构',
                  roles: [ROLES_TENANT],
                  menuId: 'omg-org-bi-lost'
                }
              },
              {
                path: 'unadmitted',
                name: 'Unadmitted',
                component: () =>
                  import('@/views/small-backstage/report/org/Unadmitted'),
                meta: {
                  title: '未准入机构',
                  roles: [ROLES_TENANT],
                  menuId: 'omg-org-bi-unadmitted'
                }
              },
              {
                path: 'status',
                name: 'Status',
                component: () =>
                  import('@/views/small-backstage/report/org/Status'),
                meta: {
                  title: '准入与流失机构',
                  roles: [ROLES_TENANT],
                  menuId: 'omg-org-bi-status'
                }
              }
            ]
          },
          {
            path: 'oms-report-achievement-rate',
            name: 'oms-report-achievement-rate',
            component: { render: (e) => e('router-view') },
            meta: {
              title: '达成率报表',
              roles: [ROLES_TENANT],
              menuId: 'oms-report-achievement-rate'
            },
            children: [
              {
                path: 'oms-report-achievement-rate-region-quarter',
                name: 'oms-report-achievement-rate-region-quarter',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-report/achievement-rate/oms-report-achievement-rate-region-quarter/index.vue'
                  ),
                meta: {
                  title: '大区季度达成率报表',
                  roles: [ROLES_TENANT],
                  menuId: 'oms-report-achievement-rate-region-quarter'
                }
              },
              {
                path: 'oms-report-regional-manager-quarter-achievement',
                name: 'oms-report-regional-manager-quarter-achievement',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-report/achievement-rate/oms-report-regional-manager-quarter-achievement/index.vue'
                  ),
                meta: {
                  title: '省区经理季度达成率报表',
                  roles: [ROLES_TENANT],
                  menuId: 'oms-report-regional-manager-quarter-achievement'
                }
              },
              {
                path: 'oms-report-province-quarter-achievement',
                name: 'oms-report-province-quarter-achievement',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-report/achievement-rate/oms-report-province-quarter-achievement/index.vue'
                  ),
                meta: {
                  title: '省份季度达成率报表',
                  roles: [ROLES_TENANT],
                  menuId: 'oms-report-province-quarter-achievement'
                }
              },
              {
                path: 'oms-report-service-provider-achievement',
                name: 'oms-report-service-provider-achievement',
                component: () =>
                  import(
                    '@/views/small-backstage/oms-report/achievement-rate/oms-report-service-provider-achievement/index.vue'
                  ),
                meta: {
                  title: '服务商达成率',
                  roles: [ROLES_TENANT],
                  menuId: 'oms-report-service-provider-achievement'
                }
              }
            ]
          },
           {
             path: 'third-party-data',
             component: () =>
               import(
                 '@/views/small-backstage/oms-report/third-party-data/third-party-data.vue'
               ),
             name: 'third-party-data',
             meta: {
               title: '第三方数据',
               roles: [ROLES_TENANT],
               menuId: 'oms-report-third-party-data'
             }
           },
            // 签约报表
            {
              path: 'contract-report',
              component: { render: (e) => e('router-view') },
              name: 'contract-report',
              meta: {
                title: '签约报表',
                roles: [ROLES_TENANT],
                menuId: 'oms-report-sign'
              },
              children: [
                // 机构签约查询
                {
                  path: 'org-contract-query',
                  component: () =>
                    import(
                      '@/views/small-backstage/oms-report/contract-report/org-contract-query.vue'
                    ),
                  name: 'org-contract-query',
                  meta: {
                    title: '机构签约查询',
                    roles: [ROLES_TENANT],
                    menuId: 'oms-report-sign-org'
                  }
                },
                // 服务商签约汇总查询
                {
                  path: 'service-provider-contract-summary',
                  component: () =>
                    import(
                      '@/views/small-backstage/oms-report/contract-report/service-provider-contract-summary.vue'
                    ),
                  name: 'service-provider-contract-summary',
                  meta: {
                    title: '服务商签约汇总查询',
                    roles: [ROLES_TENANT],
                    menuId: 'oms-report-agency-sign-summary'
                  }
                },
                // 服务商签解约明细
                {
                  path: 'agency-sign-detail',
                  component: () =>
                    import(
                      '@/views/small-backstage/oms-report/contract-report/agency-sign-detail.vue'
                    ),
                  name: 'agency-sign-detail',
                  meta: {
                    title: '服务商签解约明细',
                    roles: [ROLES_TENANT],
                    menuId: 'oms-report-agency-sign-detail'
                  }
                }
              ]
            }
         ]
       }
    ]
  },
  {
    path: '/small/approval-center',
    component: Layout,
    name: 'smallApprovalCenter',
    meta: {
      title: '审批中心',
      icon: 'small-approval-center',
      roles: [ROLES_TENANT],
      menuId: 'smallApprovalCenter'
    },
    children: [
      {
        path: 'my-approval',
        component: () =>
          import(
            '@/views/small-backstage/tenant-after-verification/my-approval'
          ),
        name: 'my-approval',
        meta: {
          title: '我的审批',
          roles: [ROLES_TENANT],
          menuId: 'my-approval',
          keepAlive: true
        }
      },
      {
        path: 'my-approval-detail',
        component: () =>
          import(
            '@/views/small-backstage/tenant-after-verification-detail/my-approval-detail'
          ),
        name: 'my-approval-detail',
        hidden: true,
        meta: {
          title: '审批详情',
          roles: [ROLES_TENANT],
          menuId: 'my-approval',
          activeMenu: '/small/approval-center/my-approval'
        }
      },
      {
        path: 'bpmn-preview',
        component: () =>
          import(
            '@/views/small-backstage/tenant-after-verification/bpmn-preview'
          ),
        name: 'bpmn-preview',
        hidden: true,
        meta: {
          title: '审批流追踪',
          roles: [ROLES_TENANT],
          menuId: 'my-approval',
          activeMenu: '/small/approval-center/my-approval'
        }
      },
      {
        path: 'tenant-after-verification',
        component: () =>
          import('@/views/small-backstage/tenant-after-verification'),
        name: 'tenant-after-verification',
        meta: {
          title: '审批记录',
          roles: [ROLES_TENANT],
          menuId: 'tenant-after-verification',
          keepAlive: true
        }
      },
      {
        path: 'approval-record-detail',
        component: () =>
          import(
            '@/views/small-backstage/tenant-after-verification-detail/approval-record-detail'
          ),
        name: 'approval-record-detail',
        hidden: true,
        meta: {
          title: '审批详情',
          roles: [ROLES_TENANT],
          menuId: 'tenant-after-verification',
          activeMenu: '/small/approval-center/tenant-after-verification'
        }
      },
      {
        path: 'approval-bpmn-preview',
        component: () =>
          import(
            '@/views/small-backstage/tenant-after-verification/bpmn-preview'
          ),
        name: 'approval-bpmn-preview',
        hidden: true,
        meta: {
          title: '审批流追踪',
          roles: [ROLES_TENANT],
          menuId: 'tenant-after-verification',
          activeMenu: '/small/approval-center/tenant-after-verification'
        }
      },
      {
        path: 'tenant-verification-set',
        component: () =>
          import(
            '@/views/small-backstage/tenant-after-verification/verification'
          ),
        name: 'tenant-verification-set',
        meta: {
          title: '审批配置',
          roles: [ROLES_TENANT],
          menuId: 'tenant-verification-set'
        }
      },
      {
        path: 'tenant-verification-set2',
        component: () =>
          import(
            '@/views/small-backstage/tenant-after-verification/verification2'
          ),
        name: 'tenant-verification-set2',
        meta: {
          title: '审批配置',
          roles: [ROLES_TENANT],
          menuId: 'tenant-verification-set2'
        }
      },

      {
        path: 'verification-process',
        component: () =>
          import('@/views/small-backstage/tenant-after-verification/process'),
        name: 'verification-process',
        hidden: true,
        meta: {
          title: '审批流程',
          roles: [ROLES_TENANT],
          menuId: 'tenant-verification-set',
          activeMenu: '/small/approval-center/tenant-verification-set'
        }
      },
      {
        path: 'add-approver',
        component: () =>
          import(
            '@/views/small-backstage/tenant-after-verification/add-approver'
          ),
        name: 'add-approver',
        hidden: true,
        meta: {
          title: '设置审批流',
          roles: [ROLES_TENANT],
          menuId: 'tenant-verification-set',
          activeMenu: '/small/approval-center/tenant-verification-set'
        }
      },
      {
        path: 'tenant-template-visit',
        component: () =>
          import('@/views/small-backstage/tenant-after-verification/visit'),
        name: 'tenant-template-visit',
        hidden: true,
        meta: {
          title: '设置字段',
          roles: [ROLES_TENANT],
          menuId: 'tenant-verification-set',
          activeMenu: '/small/approval-center/tenant-verification-set'
        }
      },
      {
        path: 'add-bpmnjs',
        component: () =>
          import(
            '@/views/small-backstage/tenant-after-verification/add-bpmnjs'
          ),
        name: 'add-bpmnjs',
        hidden: true,
        meta: {
          title: '设置审批流',
          roles: [ROLES_TENANT],
          menuId: 'tenant-verification-set2',
          activeMenu: '/small/approval-center/tenant-verification-set2'
        }
      },
      {
        path: 'meet-voucher-visit',
        component: () =>
          import(
            '@/views/small-backstage/tenant-after-verification/meet-voucher-visit'
          ),
        name: 'meet-voucher-visit',
        hidden: true,
        meta: {
          title: '线下会议字段',
          roles: [ROLES_TENANT],
          menuId: 'tenant-verification-set',
          activeMenu: '/small/approval-center/tenant-verification-set'
        }
      }
    ]
  },
  {
    path: '/small/Y-notifications',
    component: Layout,
    // name: 'notifications-management',
    redirect: 'notifications-list',
    meta: {
      roles: [ROLES_TENANT],
      menuId: 'message-management'
    },
    children: [
      {
        path: 'notifications-list',
        component: () =>
          import(
            '@/views/small-backstage/notifications-management/notifications-list/index'
          ),
        name: 'notifications-list',
        meta: {
          title: '站内信',
          icon: 'message-management',
          roles: [ROLES_TENANT],
          menuId: 'message-management'
        }
      },
      {
        path: 'notifications-detail',
        component: () =>
          import(
            '@/views/small-backstage/notifications-management/notifications-list/detail'
          ),
        name: 'notifications-detail',
        hidden: true,
        meta: {
          title: '通知详情',
          roles: [ROLES_TENANT],
          menuId: 'dashboard'
        }
      }
    ]
  }
];

const resource = [
  {
    path: '/big/resourceManage',
    component: Layout,
    name: 'big-resourceManage',
    hidden: true,
    meta: {
      title: '资源管理',
      icon: 'person_manage',
      roles: [ROLES_ADMIN]
    },
    children: [
      {
        path: 'resourceManageList',
        component: () => import('@/views/backstage/resource-manage'),
        name: 'resourceManageList',
        hidden: true,
        meta: {
          title: '资源列表',
          roles: [ROLES_ADMIN]
        }
      }
    ]
  }
];

export const constantRoutes = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',

    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard/index'),
        name: 'Dashboard',
        meta: {
          title: '首页',
          icon: 'dashboard',
          menuId: 'dashboard'
        }
      }
    ]
  },
  ...big,
  ...small,
  ...resource,
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
];

const createRouter = () =>
  new Router({
    scrollBehavior: () => ({
      y: 0
    }),
    routes: constantRoutes
  });

const router = createRouter();

router.beforeEach((to, from, next) => {
  if (to && to.meta && to.meta.activeMenu) {
    try {
      if (typeof window !== 'undefined') {
        const storage = window.sessionStorage;
        if (storage && to.meta.activeMenu) {
          storage.setItem(
            `smart-table:restore-flag:${to.meta.activeMenu}`,
            '1'
          );
        }
      }
    } catch (error) {
      // ignore storage errors
    }
  }
  next();
});

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
